const es = {
  "Articles-Articles": "Artículos",
  "Articles-EditArticle": "Editar artículo",
  "Articles-NewArticle": "Nuevo artículo",
  "BusinessRules-Address": "Dirección",
  "BusinessRules-BusinessName": "Razón social",
  "BusinessRules-BusinessUnits": "Unidades de negocio",
  "BusinessRules-Channels": "Canales",
  "BusinessRules-ChannelType": "Tipo",
  "BusinessRules-ChannelTypeNotEntered": "Seleccione un tipo",
  "BusinessRules-CompanyInfoTitle": "Datos de la empresa ",
  "BusinessRules-CreateBusinessUnitSucessMessage":
    "Se ha creado una nueva unidad de negocio.",
  "BusinessRules-CreateChannelSucessMessage": "Se ha creado un nuevo canal.",
  "BusinessRules-Currency": "Moneda",
  "BusinessRules-CurrencyNotEntered": "Seleccione una moneda",
  "BusinessRules-EditBusinessUnit": "Editar unidad de negocio",
  "BusinessRules-EditChannel": "Editar canal",
  "BusinessRules-Language": "Idioma",
  "BusinessRules-LanguageNotEntered": "Seleccione un idioma",
  "BusinessRules-NewBusinessUnit": "Agregar unidad de negocio",
  "BusinessRules-NewChannel": "Nuevo canal",
  "BusinessRules-PreferenceCurrency": "Moneda de preferencia",
  "BusinessRules-Rut": "RUT",
  "BusinessRules-Title": "Configuración de reglas de negocio",
  "BusinessRules-UpdateErrorMessage":
    "Hubo un problema al actualizar, intentelo en un momento",
  "BusinessRules-UpdateSuccessMessage": "Se ha actualizado correctamente.",
  "BusinessRules-UrlNotEntered": "Ingrese una url",
  "BrandAnalysis-ActiveProducts": "Productos activos",
  "BrandAnalysis-Alerts": "Alertas",
  "BrandAnalysis-AllChannels": "Todos los canales",
  "BrandAnalysis-AllStores": "Todas las tiendas",
  "BrandAnalysis-AtRisk": "En riesgo",
  "BrandAnalysis-Brand": "Marca",
  "BrandAnalysis-Brands": "Marcas",
  "BrandAnalysis-BusinessDependency": "Dependencia del negocio",
  "BrandAnalysis-Channel": "Canal",
  "BrandAnalysis-Alert-LowSalesDiversity":
    "Gran parte del catálogo de la marca no genera ventas",
  "BrandAnalysis-Alert-MarginDecline": "Margen deteriorado respecto al año anterior",
  "BrandAnalysis-Alert-Overstock": "Marca con exceso de cobertura de stock",
  "BrandAnalysis-Alert-PromoDependency": "Marca altamente dependiente de promociones",
  "BrandAnalysis-Alert-SalesDropVsLY": "Marca con caída relevante vs año anterior",
  "BrandAnalysis-Alert-Top3Concentration":
    "La venta de la marca está concentrada en pocos productos",
  "BrandAnalysis-CommercialDiagnostic": "Diagnostico Comercial",
  "BrandAnalysis-Driver-ChannelGrowth":
    "{{channel}} explica el {{pct}}% del crecimiento de la marca.",
  "BrandAnalysis-Driver-DominantProduct":
    "{{product}} concentra el {{pct}}% de la venta de la marca.",
  "BrandAnalysis-Driver-ProductMixGain":
    "{{product}} gana {{pp}} puntos de participación dentro de la marca.",
  "BrandAnalysis-Driver-StoreGrowth":
    "{{store}} explica el {{pct}}% del crecimiento de la marca.",
  "BrandAnalysis-GrossSales": "Venta Bruta",
  "BrandAnalysis-Insight-ChannelShareGain":
    "{{channel}} gana relevancia dentro de la venta de la marca",
  "BrandAnalysis-Insight-DeclineConcentration":
    "La caída se explica principalmente por {{channel1}} y {{channel2}}",
  "BrandAnalysis-Insight-GeographicExpansion":
    "La marca amplía presencia comercial en más tiendas",
  "BrandAnalysis-Insight-GrowthConcentration":
    "El crecimiento se concentra en {{channel1}} y {{channel2}}",
  "BrandAnalysis-Insight-PromoDependency":
    "Más de la mitad de la venta de la marca ocurre bajo promociones",
  "BrandAnalysis-Insight-Top3Concentration":
    "{{count}} productos concentran el {{pct}}% de la venta total de la marca",
  "BrandAnalysis-Last180Days": "Últimos 180 días",
  "BrandAnalysis-Last30Days": "Últimos 30 días",
  "BrandAnalysis-Last60Days": "Últimos 60 días",
  "BrandAnalysis-Last90Days": "Últimos 90 días",
  "BrandAnalysis-Margin": "Margen",
  "BrandAnalysis-NoBrands": "Sin marcas",
  "BrandAnalysis-NoPotentialBrands":
    "No hay marcas con potencial bajo esta regla.",
  "BrandAnalysis-Opportunity-AcceleratedGrowth": "Marca en fuerte crecimiento",
  "BrandAnalysis-Opportunity-HealthyDemandLowPromo":
    "Marca con demanda sana sin dependencia promocional",
  "BrandAnalysis-Opportunity-HighMarginLowVolume":
    "Marca rentable con oportunidad de crecimiento",
  "BrandAnalysis-Opportunity-MixExpansion":
    "La marca amplía su mix con productos activos",
  "BrandAnalysis-Opportunity-RecentRecovery": "Marca mostrando recuperación comercial",
  "BrandAnalysis-Period": "Período",
  "BrandAnalysis-Potential": "Potencial",
  "BrandAnalysis-Risk": "Riesgo",
  "BrandAnalysis-SalesPercent": "% venta",
  "BrandAnalysis-SearchBrand": "Buscar marca",
  "BrandAnalysis-Store": "Tienda",
  "BrandAnalysis-UnexploitedPotentialBrands":
    "Marcas con potencial no explotado",
  "BrandAnalysis-Units": "Unidades",
  "BrandDetail-ActiveAlerts": "Alertas activas",
  "BrandDetail-ActiveProducts": "Productos activos",
  "BrandDetail-Affinity": "Afinidad",
  "BrandDetail-AllChannels": "Todos los canales",
  "BrandDetail-AllStores": "Todas las tiendas",
  "BrandDetail-AverageTicket": "Ticket promedio",
  "BrandDetail-BottomProducts": "Productos menos vendidos",
  "BrandDetail-Brand": "Marca",
  "BrandDetail-Brands": "Marcas",
  "BrandDetail-Channel": "Canal",
  "BrandDetail-ChannelPerformance": "Performance por canal",
  "BrandDetail-ColumnPresence": "Presencia",
  "BrandDetail-ComplementaryBrands": "Marcas complementarias",
  "BrandDetail-DetectedDrivers": "Drivers detectados",
  "BrandDetail-ExploreRelatedAlerts": "Explorar alertas relacionadas",
  "BrandDetail-Forecast": "Forecast",
  "BrandDetail-GoToAssociatedPromotions": "Ir a promociones asociadas",
  "BrandDetail-GrossSales": "Venta Bruta",
  "BrandDetail-Insights": "Insights",
  "BrandDetail-Last180Days": "Ultimos 180 dias",
  "BrandDetail-Last30Days": "Ultimos 30 dias",
  "BrandDetail-Last60Days": "Ultimos 60 dias",
  "BrandDetail-Last90Days": "Ultimos 90 dias",
  "BrandDetail-Margin": "Margen",
  "BrandDetail-NoAlertsDetected": "Sin alertas activas en este período.",
  "BrandDetail-NoBrandFound": "No se encontro la marca",
  "BrandDetail-NoCategory": "Sin categoria",
  "BrandDetail-NoChannelData": "Sin datos por canal",
  "BrandDetail-NoComplementaryBrands": "Sin marcas complementarias",
  "BrandDetail-NoDriversDetected": "Sin drivers destacados en este período.",
  "BrandDetail-NoEvolutionForPeriod": "Sin evolucion para el periodo",
  "BrandDetail-NoInsightsDetected": "Sin insights destacados en este período.",
  "BrandDetail-NoOpportunitiesDetected":
    "Sin oportunidades destacadas en este período.",
  "BrandDetail-NoProducts": "Sin productos para mostrar",
  "BrandDetail-NoPromotions": "Sin promociones para mostrar",
  "BrandDetail-NoStoreData": "Sin datos por tienda",
  "BrandDetail-NoSubstituteBrands": "Sin marcas sustitutas",
  "BrandDetail-Opportunities": "Oportunidades",
  "BrandDetail-ParticipatedPromotions": "Promociones en las que participó",
  "BrandDetail-Participation": "Participacion",
  "BrandDetail-PendingPredictiveModel":
    "Pendiente hasta conectar el modelo predictivo.",
  "BrandDetail-Period": "PERIODO",
  "BrandDetail-Product": "Producto",
  "BrandDetail-Promotion": "Promoción",
  "BrandDetail-RealSales": "Venta real",
  "BrandDetail-Reason": "Motivo",
  "BrandDetail-RelatedActions": "Acciones relacionadas",
  "BrandDetail-Result": "Resultado",
  "BrandDetail-Roi": "ROI",
  "BrandDetail-Sale": "Venta",
  "BrandDetail-SalesEvolutionForecast": "Evolución de ventas y forecast",
  "BrandDetail-SalesWeight":
    "Peso en ventas: {{pct}}% - {{products}} productos activos",
  "BrandDetail-SalesWeightLabel": "Peso en venta",
  "BrandDetail-Stock": "Stock",
  "BrandDetail-Store": "Tienda",
  "BrandDetail-StorePerformance": "Performance por tienda",
  "BrandDetail-SubstituteBrands": "Marcas sustitutas",
  "BrandDetail-TopProducts": "Productos más vendidos",
  "BrandDetail-Units": "Unidades",
  "BrandDetail-ViewBrandProducts": "Ver productos de la marca",
  "Categories-Categories": "Categorías",
  "Categories-CreateCategorySucessMessage": "Se ha creado una nueva categoría.",
  "Categories-Father": "Padre",
  "Categories-New": "Nueva",
  "Categories-NewCategory": "Nueva categoría",
  "Categories-RoundingType": "Tipo de redondeo",
  "Categories-RoundingTypeNotEntered": "Seleccione un tipo de redondeo",
  "Categories-Status": "Estado",
  "ChannelAnalysis-AllChannels": "Todos los canales",
  "ChannelAnalysis-AverageTicket": "Ticket Promedio",
  "ChannelAnalysis-BasketSize": "Tamaño Cesta",
  "ChannelAnalysis-Breaks": "Quiebres",
  "ChannelAnalysis-Channel": "Canal",
  "ChannelAnalysis-Channels": "Canales",
  "ChannelAnalysis-GrossSales": "Venta Bruta",
  "ChannelAnalysis-Last180Days": "Últimos 180 días",
  "ChannelAnalysis-Last30Days": "Últimos 30 días",
  "ChannelAnalysis-Last60Days": "Últimos 60 días",
  "ChannelAnalysis-Last90Days": "Últimos 90 días",
  "ChannelAnalysis-Margin": "Margen",
  "ChannelAnalysis-NoChannels": "Sin canales",
  "ChannelAnalysis-Period": "Período",
  "ChannelAnalysis-SalesMix": "Mix de venta",
  "ChannelAnalysis-SalesMixDescription": "Distribución comercial del canal.",
  "ChannelAnalysis-SearchChannel": "Buscar canal",
  "ChannelAnalysis-Stock": "Stock",
  "ChannelAnalysis-Units": "Unidades",
  "ChannelDetail-Article": "Artículo",
  "ChannelDetail-AverageTicketShort": "Ticket Prom.",
  "ChannelDetail-BasketSize": "Tamaño de cesta",
  "ChannelDetail-Brand": "Marca",
  "ChannelDetail-Category": "Categoría",
  "ChannelDetail-ChannelAverageTicket": "Ticket promedio canal",
  "ChannelDetail-ChannelClients": "Clientes del canal",
  "ChannelDetail-ChannelShare": "Participación en la empresa",
  "ChannelDetail-ChannelSalesPercent": "% venta canal",
  "ChannelDetail-Clients": "Clientes",
  "ChannelDetail-CurrentChannelResult": "Resultado actual del canal",
  "ChannelDetail-ExclusiveChannelClients": "Clientes exclusivos canal",
  "ChannelDetail-Forecast": "Forecast",
  "ChannelDetail-ForecastBase": "Estimación base según tendencia reciente",
  "ChannelDetail-Frequency": "Frecuencia",
  "ChannelDetail-GeographicLocation": "Ubicación geográfica",
  "ChannelDetail-Global": "Global",
  "ChannelDetail-GrossSales": "Venta Bruta",
  "ChannelDetail-Growth": "Crecimiento",
  "ChannelDetail-Last180Days": "Últimos 180 días",
  "ChannelDetail-Last30Days": "Últimos 30 días",
  "ChannelDetail-Last60Days": "Últimos 60 días",
  "ChannelDetail-Last90Days": "Últimos 90 días",
  "ChannelDetail-LastPeriodSales": "Venta último período",
  "ChannelDetail-Location": "Ubicación",
  "ChannelDetail-MainSupplyOrigin": "Origen principal del suministro",
  "ChannelDetail-Margin": "Margen",
  "ChannelDetail-Month": "Mes",
  "ChannelDetail-NewClients": "Clientes nuevos",
  "ChannelDetail-NewClientsByMonth": "Clientes nuevos por mes",
  "ChannelDetail-NewClientsByMonthYear": "Clientes nuevos por mes ({{year}})",
  "ChannelDetail-NextPeriodForecast": "Forecast próximo período",
  "ChannelDetail-NoChannelFound": "No se encontró el canal",
  "ChannelDetail-ProjectedSales": "Venta proyectada",
  "ChannelDetail-RealSales": "Venta real",
  "ChannelDetail-RecurrentClients": "Clientes recurrentes",
  "ChannelDetail-Sale": "Venta",
  "ChannelDetail-SalesMix": "Mix de ventas",
  "ChannelDetail-SalesTrend": "Tendencia de ventas",
  "ChannelDetail-SalesTrendDescription":
    "Evolución de ventas del canal según tickets del período.",
  "ChannelDetail-SalesTrendForecast": "Tendencia de ventas y forecast",
  "ChannelDetail-SearchProduct": "Buscar marca, categoría o artículo",
  "ChannelDetail-Supply": "Abastecimiento",
  "ChannelDetail-Tickets": "Tickets",
  "ChannelDetail-TopBrands": "Marcas más vendidas",
  "ChannelDetail-TopCategories": "Categorías más vendidas",
  "ChannelDetail-TopStores": "Top tiendas",
  "ChannelDetail-UniqueClients": "Clientes únicos",
  "ChannelDetail-Units": "Unidades",
  "ChangePassword-Description":
    "Ingrese una contraseña segura que puedas recordar!",
  "ChangePassword-ResetPassword": "Reiniciar contraseña",
  "ChangePassword-SendErrorMessage":
    "Hubo un problema, intentelo en un momento",
  "ChangePassword-SendSuccesMessage": "Se ha cambiado su contraseña.",
  "ChangePassword-Title": "Crea una nueva contraseña",
  "ChangePassword-SuccessTitle": "¡Contraseña cambiada!",
  "ChangePassword-SuccessMessage":
    "Tu contraseña ha sido actualizada exitosamente.",
  "ChangePassword-RedirectMessage":
    "Serás redirigido al login en unos segundos...",
  "ChatIa-inputPlaceholder": "Escribi un mensaje",
  "ChatIa-send": "Enviar",
  "CheckEmail-SendAgain": "Enviar correo otra vez",
  "CheckEmail-SendErrorMessage":
    "Hubo un problema al enviar el correo, intentelo en un momento",
  "CheckEmail-SendSuccesMessage":
    "Se ha enviado correctamente. Revise su casilla de correo electronico.",
  "CheckEmail-Title": "Revise su email para continuar con el registro",
  "CheckEmail-Description":
    "Hemos enviado un enlace de verificación a {{email}}. Por favor, revisa tu bandeja de entrada y haz clic en el enlace para activar tu cuenta.",
  "Common-AboutUs": "Sobre nosotros",
  "Common-AcceptedGoods": "Bienes aceptados",
  "Common-AcceptedPaymentMethod": "Medio de pago aceptado",
  "Common-AcceptedPaymentMethods": "Medios de pagos aceptados",
  "Common-AccountPoints": "Puntos en su cuenta",
  "Common-AccumulateOtherPromos": "Acumula con otras promociones",
  "Common-AccumulatePoints": "Puntos acumulados",
  "Common-AccumulateUnits": "Unidades de acumulación",
  "Common-Accumulation": "Acumulación",
  "Common-AccumulationFactor": "Factor de acumulación",
  "Common-Actions": "Acciones",
  "Common-Active": "Activo",
  "Common-Actives": "Activos",
  "Common-ActualPassword": "Contraseña actual",
  "Common-ActualPrice": "Precio actual",
  "Common-Add": "Agregar",
  "Common-AddArticles": "Agregar artículo",
  "Common-AddFromSegment": "Agregar desde segmento",
  "Common-AddCSV": "Subir CSV",
  "Common-AddedSuccessMessage": "Se han agregado correctamente",
  "Common-AddNew": "Agregar nueva",
  "Common-AddPurchaseOrder": "Agregar Orden de Compra",
  "Common-AddRepositionOrder": "Agregar Orden de Reposición",
  "Common-Address": "Dirección",
  "Common-AddSkus": "Agregar sku",
  "Common-AddStock": "Agregar stock",
  "Common-AddStockMovement": "Agregar movimiento de stock",
  "Common-AddSuccessMessage": "Se ha agregado correctamente",
  "Common-Adjustment": "Ajuste",
  "Common-Age": "Edad",
  "Common-AgreedDiscounts": "Descuentos acordados",
  "Common-All": "Todas",
  "Common-AllProducts": "Aplica solo a productos iguales",
  "Common-AllRightsReserved": "Todos los derechos reservados por",
  "Home-Welcome": "Bienvenido",
  "Home-Modules": "Módulos disponibles",
  "Home-Admin-Organizations": "Organizaciones activas",
  "Home-Module-Admin-Description": "Panel de control y métricas principales",
  "Home-Module-Pricing-Description": "Configura precios",
  "Home-Module-Promotions-Description": "Crea y gestiona promociones",
  "Home-Module-Fidelity-Description": "Programa de fidelidad e incentivos",
  "Home-Module-PurchaseOrders-Description": "Órdenes de compra y proveedores",
  "Home-Module-RepositionOrders-Description": "Órdenes de reposición y stock",
  "Common-AllSkus": "Todos",
  "Common-Alphanumeric": "Alfanumérico",
  "Common-AmmountSpent": "Cantidad de dinero gastado en un período de tiempo",
  "Common-Analysis": "Análisis",
  "Common-Anually": "Anual",
  "Common-ApplyAllTogether": "Aplican todas juntas",
  "Common-Article": "Artículo",
  "Common-ArticleGroup": "Grupo de Artículos",
  "Common-ArticleGroups": "Grupos de Artículos",
  "Common-Articles": "Artículos",
  "Common-Of": "de",
  "Common-ArticleCode": "Código de artículo",
  "Common-ArticleName": "Nombre del artículo",
  "Common-Attribute": "Atributo",
  "Common-Attributes": "Atributos",
  "Common-AvailableStock": "Stock Disponible",
  "Common-Back": "Volver",
  "Common-RequiredField": "Campo requerido",
  "Common-MinLength3": "Mínimo 3 caracteres",
  "Common-Create": "Crear",
  "Common-CreditNote": "Nota de crédito",
  "Common-CreditInvoice": "Factura crédito",
  "Common-CashTicket": "Ticket contado",
  "Common-Update": "Actualizar",
  "Common-UpdateSuccessMessage": "Se ha actualizado correctamente.",
  "DataScienceJobs-Title": "Procesos de análisis",
  "DataScienceJobs-DashboardTitle": "Panel de procesos de análisis",
  "DataScienceJobs-DashboardDescription":
    "Resumen de trabajos, ejecuciones recientes y acceso rápido a cada tipo de análisis.",
  "DataScienceJobs-BackToDashboard": "Volver al panel",
  "DataScienceJobs-LastFinishedRun": "Última ejecución finalizada",
  "DataScienceJobs-LastStartedRun": "Última ejecución iniciada",
  "DataScienceJobs-Duration": "Duración",
  "DataScienceJobs-DurationRunning": "en curso",
  "DataScienceJobs-FilterJobType": "Tipo de trabajo",
  "DataScienceJobs-FilterStatus": "Estado",
  "DataScienceJobs-AllJobTypes": "Todos los tipos",
  "DataScienceJobs-FilterActiveAll": "Activos e inactivos",
  "DataScienceJobs-FilterActive": "Activos",
  "DataScienceJobs-FilterInactive": "Inactivos",
  "DataScienceJobs-FilterStatusAll": "Todos los estados",
  "DataScienceJobs-RecentExecutions": "Ejecuciones recientes",
  "DataScienceJobs-OpenJobType": "Abrir tipo de trabajo",
  "DataScienceJobs-ViewAllJobs": "Ver todos ({{count}})",
  "DataScienceJobs-ExecuteInactiveHelp": "Activá el trabajo antes de ejecutarlo",
  "DataScienceJobs-AllJobs": "Todos los trabajos",
  "DataScienceJobs-ActiveJobs": "Trabajos activos",
  "DataScienceJobs-RunningTasks": "Tareas en ejecución",
  "DataScienceJobs-FailedTasks": "Tareas fallidas",
  "DataScienceJobs-Active": "Activo",
  "DataScienceJobs-SearchJobName": "Buscar por nombre",
  "DataScienceJobs-JobsConfigured": "trabajos configurados",
  "DataScienceJobs-JobsConfiguredCount": "{{count}} trabajos configurados",
  "DataScienceJobs-SingletonSystemJobReady": "Listo para ejecutar manualmente",
  "DataScienceJobs-SingletonRunTitle": "Ejecutar",
  "DataScienceJobs-ExecutionHistory": "Historial de ejecuciones",
  "DataScienceJobs-ActiveJobsCount_one": "{{count}} activo",
  "DataScienceJobs-ActiveJobsCount_other": "{{count}} activos",
  "DataScienceJobs-Description":
    "Gestionar y monitorear los distintos procesos de análisis",
  "DataScienceJobs-ServiceStatus": "Estado del Servicio:",
  "DataScienceJobs-Refresh": "Actualizar",
  "DataScienceJobs-DemandForecastTitle": "Pronóstico de Demanda",
  "DataScienceJobs-DemandForecastDescription":
    "Predecir la demanda futura de productos",
  "DataScienceJobs-DemandForecastCleanupTitle":
    "Limpieza de pronóstico de demanda",
  "DataScienceJobs-DemandForecastCleanupDescription":
    "Elimina el historial de pronóstico de demanda a nivel categoría/marca con más de seis meses. Se ejecuta manualmente; no es programable. La próxima fecha prevista es seis meses después de la última corrida.",
  "DataScienceJobs-DemandForecastCleanupExecuteWarning":
    "Al ejecutar se eliminarán los pronósticos de categoría/marca de esta organización con más de seis meses de antigüedad.",
  "DataScienceJobs-DemandForecastJobsTitle":
    "Trabajos de Pronóstico de Demanda",
  "DataScienceJobs-AssortmentOptimizationTitle": "Optimización de Surtido",
  "DataScienceJobs-AssortmentOptimizationDescription":
    "Optimizar el surtido de productos para máximo beneficio",
  "DataScienceJobs-AssortmentOptimizationJobsTitle":
    "Trabajos de Optimización de Surtido",
  "DataScienceJobs-OutOfStockTitle": "Análisis de Quiebre de Stock",
  "DataScienceJobs-OutOfStockDescription":
    "Analizar y calcular productos sin stock",
  "DataScienceJobs-OutOfStockJobsTitle":
    "Trabajos de Análisis de Quiebre de Stock",
  "DataScienceJobs-RestockTitle": "Análisis de Reabastecimiento",
  "DataScienceJobs-RestockDescription":
    "Analizar y calcular recomendaciones de reabastecimiento",
  "DataScienceJobs-RestockJobsTitle":
    "Trabajos de Análisis de Reabastecimiento",
  "DataScienceJobs-RestockManualEvaluationTitle":
    "Evaluación de Reposición Manual",
  "DataScienceJobs-RestockManualEvaluationDescription":
    "Evaluar órdenes de reposición manual en un rango de fechas",
  "DataScienceJobs-SegmentsTitle": "Segmentación de Clientes",
  "DataScienceJobs-SegmentsDescription":
    "Generar y analizar segmentos de clientes a partir de comportamiento de compra",
  "DataScienceJobs-SegmentEngineTitle": "Motor de Segmentos",
  "DataScienceJobs-SegmentEngineDescription":
    "Generar segmentos sugeridos desde el motor interno de la API",
  "DataScienceJobs-ClientMetricsRefreshTitle": "Actualización de Métricas de Clientes",
  "DataScienceJobs-ClientMetricsRefreshDescription":
    "Actualiza la tabla client_metrics con datos de tickets. Programar de noche (ej. 03:00) acelera la generación de segmentos en recomendaciones.",
  "DataScienceJobs-ForecastManualPromotionsTitle":
    "Pronóstico de Promociones Manuales",
  "DataScienceJobs-ForecastManualPromotionsDescription":
    "Detectar promociones activas de descuento y pronosticar ventas considerando el descuento",
  "DataScienceJobs-PromotionsTitle": "Recomendación de Promociones",
  "DataScienceJobs-PromotionsDescription":
    "Evaluar distintos niveles de descuento y duraciones para recomendar promociones por categoría y marca según lift y ROI esperados",
  "DataScienceJobs-PromotionsExecuteWarning":
    "Al ejecutar se eliminarán las promociones sugeridas anteriores y sus recomendaciones, y se generarán nuevamente.",
  "Promotions-RevenueLift": "Lift ingresos",
  "Promotions-NetRoi": "ROI neto",
  "Promotions-Rank": "Rank",
  "Promotions-CompleteRecommendation": "Completar promoción",
  "Promotions-RecommendationMetricsTitle": "Métricas de la recomendación",
  "Promotions-RecommendationMissingSkus":
    "Esta promoción sugerida aún no tiene SKUs. Agregue artículos y complete la promoción para activarla.",
  "DataScienceJobs-PriceElasticityTitle": "Elasticidad de Precios",
  "DataScienceJobs-PriceElasticityDescription":
    "Estimar la elasticidad de corto plazo por categoría y marca usando ventas recientes y estacionalidad",
  "DataScienceJobs-PriceElasticityStartingDateHelp":
    "Fecha desde la cual iniciar la simulación. Se cargan datos históricos desde ~200 días antes hasta el día anterior.",
  "DataScienceJobs-PriceCrossElasticityTitle": "Elasticidad Cruzada",
  "DataScienceJobs-PriceCrossElasticityDescription":
    "Estimar cómo impacta en las ventas un cambio de precio de competidores directos",
  "DataScienceJobs-PriceCrossElasticityBrandsHelp":
    "Opcional. Dejar vacío usa todas las marcas. Se requieren ventas con precios de competidores en la misma categoría y tienda.",
  "DataScienceJobs-SeasonalForecastTitle": "Proyección de Demanda de Temporada",
  "DataScienceJobs-SeasonalForecastDescription":
    "Proyectar la demanda a largo plazo para la temporada completa, por marca, categoría y tienda",
  "DataScienceJobs-NextPurchaseTitle": "Próxima Compra",
  "DataScienceJobs-NextPurchaseDescription":
    "Estimar cuándo será aproximadamente la próxima compra de cada cliente usando modelos de supervivencia",
  "DataScienceJobs-MarketBasketTitle": "Arrastre",
  "DataScienceJobs-MarketBasketDescription":
    "Identificar patrones de compra y pares de categorías o marcas que suelen comprarse juntas",
  "DataScienceJobs-StoreTransferenceTitle": "Transferencia entre Tiendas",
  "DataScienceJobs-StoreTransferenceDescription":
    "Reacomodar stock entre tiendas para quitarlo de donde no debería estar y enviarlo a donde tiene mayores ventas esperadas",
  "DataScienceJobs-PropensityToBuyTitle": "Propensión a la Compra",
  "DataScienceJobs-PropensityToBuyDescription":
    "Calcular si clientes o segmentos son propensos a comprar una categoría, marca o combinación categoría-marca",
  "DataScienceJobs-ClientElasticityTitle": "Elasticidad de Clientes",
  "DataScienceJobs-ClientElasticityDescription":
    "Calcular métricas de respuesta de clientes a incentivos (descuentos, puntos, etc.)",
  "DataScienceJobs-RewardsTitle": "Recompensas",
  "DataScienceJobs-RewardsDescription":
    "Genera incentivos sugeridos a partir de segmentos, uso histórico y ticket promedio. Se ejecuta en la API; no es programable.",
  "DataScienceJobs-RewardsExecuteWarning":
    "Al ejecutar se eliminarán los incentivos sugeridos anteriores (sin campaña) y se generarán nuevamente.",
  "DataScienceJobs-CommercialOpportunitiesTitle":
    "Detectar oportunidades comerciales",
  "DataScienceJobs-CommercialOpportunitiesDescription":
    "Detecta oportunidades comerciales (baja performance, puntos, exceso de stock por talle, banco emisor, renovación infantil) y genera segmentos sugeridos. Se ejecuta manualmente; no es programable.",
  "DataScienceJobs-CommercialOpportunitiesExecuteWarning":
    "Al ejecutar se eliminarán las oportunidades comerciales sugeridas anteriores y se generarán nuevamente.",
  "DataScienceJobs-ActivationActionsTitle": "Acciones de activación",
  "DataScienceJobs-ActivationActionsDescription":
    "Genera acciones de activación sugeridas a partir de los segmentos sugeridos. Se ejecuta manualmente; no es programable.",
  "DataScienceJobs-ActivationActionsExecuteWarning":
    "Al ejecutar se eliminarán las acciones de activación sugeridas sin campaña y se generarán nuevamente.",
  "DataScienceJobs-NewJob": "Nuevo Trabajo",
  "DataScienceJobs-EditJob": "Editar Trabajo",
  "DataScienceJobs-JobName": "Nombre del Trabajo",
  "DataScienceJobs-JobType": "Tipo de Trabajo",
  "DataScienceJobs-OriginLabel": "Origen",
  "DataScienceJobs-Organization": "Organización",
  "DataScienceJobs-IsActive": "Activo",
  "DataScienceJobs-CronExpression": "Expresión Cron",
  "DataScienceJobs-Parameters": "Parámetros",
  "DataScienceJobs-LastExecution": "Última Ejecución",
  "DataScienceJobs-NextExecution": "Próxima Ejecución",
  "DataScienceJobs-ExecutionCount": "Contador de Ejecuciones",
  "DataScienceJobs-LastStatus": "Último Estado",
  "DataScienceJobs-LastError": "Último Error",
  "DataScienceJobs-CreatedAt": "Creado",
  "DataScienceJobs-UpdatedAt": "Actualizado",
  "DataScienceJobs-Actions": "Acciones",
  "DataScienceJobs-Execute": "Ejecutar",
  "DataScienceJobs-Edit": "Editar",
  "DataScienceJobs-Delete": "Eliminar",
  "DataScienceJobs-View": "Ver",
  "DataScienceJobs-Status": "Estado",
  "DataScienceJobs-TaskId": "ID de Tarea",
  "DataScienceJobs-Progress": "Progreso",
  "DataScienceJobs-Message": "Mensaje",
  "DataScienceJobs-StartedAt": "Iniciado",
  "DataScienceJobs-CompletedAt": "Completado",
  "DataScienceJobs-Error": "Error",
  "DataScienceJobs-Result": "Resultado",
  "DataScienceJobs-HealthCheck": "Verificar Estado",
  "DataScienceJobs-ServiceHealthy": "Servicio Saludable",
  "DataScienceJobs-ServiceUnhealthy": "Servicio No Saludable",
  "DataScienceJobs-ServiceError": "Error del Servicio",
  "DataScienceJobs-NoJobsFound": "No se encontraron trabajos",
  "DataScienceJobs-NoTasksFound": "No se encontraron tareas",
  "DataScienceJobs-CreateJobSuccess": "Trabajo creado exitosamente",
  "DataScienceJobs-UpdateJobSuccess": "Trabajo actualizado exitosamente",
  "DataScienceJobs-DeleteJobSuccess": "Trabajo eliminado exitosamente",
  "DataScienceJobs-ExecuteJobSuccess": "Tarea iniciada",
  "DataScienceJobs-CreateJobError": "Error al crear el trabajo",
  "DataScienceJobs-UpdateJobError": "Error al actualizar el trabajo",
  "DataScienceJobs-DeleteJobError": "Error al eliminar el trabajo",
  "DataScienceJobs-ExecuteJobError": "Error al ejecutar el trabajo",
  "DataScienceJobs-LoadJobsError": "Error al cargar los trabajos",
  "DataScienceJobs-LoadTasksError": "Error al cargar las tareas",
  "DataScienceJobs-LoadRecommendationSelectionError":
    "Error al cargar el job seleccionado para recomendaciones",
  "DataScienceJobs-SetRecommendationSelectionSuccess":
    "Job seleccionado para recomendaciones",
  "DataScienceJobs-SetRecommendationSelectionError":
    "Error al seleccionar el job para recomendaciones",
  "DataScienceJobs-ClearRecommendationSelectionSuccess":
    "Job deseleccionado para recomendaciones",
  "DataScienceJobs-ClearRecommendationSelectionError":
    "Error al quitar el job de recomendaciones",
  "DataScienceJobs-RecommendationSelection": "Recomendaciones",
  "DataScienceJobs-SelectRecommendationJob":
    "Seleccioná el job que se usará para recomendaciones",
  "DataScienceJobs-SelectedForRecommendations":
    "Seleccionado para recomendaciones",
  "DataScienceJobs-NotSelectedForRecommendations":
    "Sin selección para recomendaciones",
  "DataScienceJobs-UseForRecommendations": "Usar para recomendaciones",
  "DataScienceJobs-RecommendationSelectionInactiveHelp":
    "Activá el job antes de usarlo para recomendaciones",
  "DataScienceJobs-FlowConfigTitle": "Flujo de recomendaciones",
  "DataScienceJobs-FlowConfigOpenButton": "Configurar flujo de recomendaciones",
  "DataScienceJobs-FlowConfigStepGeneratingSegments": "Generando segmentos",
  "DataScienceJobs-FlowConfigDescription":
    "Configurá qué etapas se ejecutan al generar recomendaciones. Las etapas deshabilitadas se omiten y conservan los datos sugeridos existentes.",
  "DataScienceJobs-FlowConfigSelectOrganization":
    "Seleccioná una organización de trabajo para configurar el flujo de recomendaciones.",
  "DataScienceJobs-FlowConfigLoadError":
    "Error al cargar la configuración del flujo de recomendaciones",
  "DataScienceJobs-FlowConfigSaveSuccess":
    "Configuración del flujo actualizada",
  "DataScienceJobs-FlowConfigSaveError":
    "Error al actualizar la configuración del flujo",
  "DataScienceJobs-FlowConfigAlwaysEnabled": "Siempre se ejecuta",
  "DataScienceJobs-FlowConfigJobConfigured": "Job configurado",
  "DataScienceJobs-FlowConfigJobMissing": "Sin job seleccionado",
  "DataScienceJobs-FlowConfigConfigureJob": "Configurar job",
  "DataScienceJobs-FlowConfigDisabledWhileRun":
    "No se puede modificar mientras hay una ejecución activa",
  "DataScienceJobs-Reconcile": "Chequear estado",
  "DataScienceJobs-ReconcileTask": "Chequear estado de la tarea con ECS",
  "DataScienceJobs-ReconcileError": "Error al chequear el estado de la tarea",
  "DataScienceJobs-ReconcileSuccess":
    "Estado de la tarea verificado exitosamente",
  "DataScienceJobs-CancelTaskSuccess": "Tarea cancelada",
  "DataScienceJobs-CancelTaskError": "Error al cancelar la tarea",
  "DataScienceJobs-ConfirmCancelTask":
    "¿Está seguro de que desea cancelar esta tarea?",
  "DataScienceJobs-Logs": "Logs",
  "DataScienceJobs-ViewLogs": "Ver logs de la tarea",
  "DataScienceJobs-TaskLogs": "Logs de la Tarea",
  "DataScienceJobs-LoadMoreLogs": "Cargar más logs",
  "DataScienceJobs-LoadingMoreLogs": "Cargando más logs...",
  "DataScienceJobs-LoadLogsError": "Error al cargar los logs",
  "DataScienceJobs-DownloadLogsError": "Error al descargar los logs",
  "DataScienceJobs-NoLogsFound": "No se encontraron logs",
  "DataScienceJobs-DeleteJobConfirm":
    "¿Está seguro de que desea eliminar este trabajo?",
  "DataScienceJobs-ConfirmExecute":
    "¿Está seguro de que desea ejecutar este trabajo?",
  "DataScienceJobs-ExecuteJob": "Ejecutar Trabajo",
  "DataScienceJobs-ViewJob": "Ver Trabajo",
  "DataScienceJobs-DeleteJob": "Eliminar Trabajo",
  "DataScienceJobs-JobTypes": {
    demand_forecast: "Pronóstico de Demanda",
    assortment_optimization: "Optimización de Surtido",
    out_of_stock: "Quiebre de stock",
    restock: "Reabastecimiento",
    restock_manual_evaluation: "Evaluación de reposición",
    segments: "Segmentación de Clientes",
    segment_engine: "Motor de segmentos",
    client_metrics_refresh: "Actualización de métricas de clientes",
    forecast_manual_promotions: "Pronóstico de promociones",
    promotions: "Recomendación de promociones",
    price_elasticity: "Elasticidad de precios",
    price_cross_elasticity: "Elasticidad cruzada",
    seasonal_forecast: "Demanda de temporada",
    next_purchase: "Próxima compra",
    market_basket: "Arrastre",
    store_transference: "Transferencia entre tiendas",
    propensity_to_buy: "Propensión a la compra",
    client_elasticity: "Elasticidad de clientes",
    rewards: "Recompensas",
    commercial_opportunities: "Detectar oportunidades comerciales",
    activation_actions: "Acciones de activación",
    demand_forecast_cleanup: "Limpieza de pronóstico de demanda",
  },
  "DataScienceJobs-OriginShort": {
    data_science: "DS",
    api: "Backend",
    api_ecs: "Backend ECS",
  },
  "DataScienceJobs-Origin": {
    data_science: "Data Science",
    api: "Backend",
    api_ecs: "Backend ECS (Fargate)",
  },
  "DataScienceJobs-Statuses": {
    pending: "Pendiente",
    running: "Ejecutando",
    success: "Exitoso",
    completed: "Completado",
    failed: "Fallido",
    PENDING: "Pendiente",
    RUNNING: "Ejecutando",
    SUCCESS: "Exitoso",
    COMPLETED: "Completado",
    FAILED: "Fallido",
  },
  "DataScienceJobs-CronExamples": "Ejemplos de expresiones cron:",
  "DataScienceJobs-CronExamples.daily_2am": "Diario a las 2:00 AM",
  "DataScienceJobs-CronExamples.daily_930am": "Diario a las 9:30 AM",
  "DataScienceJobs-CronExamples.daily_2pm": "Diario a las 2:00 PM",
  "DataScienceJobs-CronExamples.weekly_sunday":
    "Semanal los domingos a medianoche",
  "DataScienceJobs-CronExamples.weekly_monday":
    "Semanal los lunes a las 9:00 AM",
  "DataScienceJobs-CronExamples.monthly_1st": "Mensual el día 1 a medianoche",
  "DataScienceJobs-CronExamples.monthly_15th": "Mensual el día 15 a medianoche",
  "DataScienceJobs-CronExamples.hourly": "Cada hora (0 * * * *)",
  "DataScienceJobs-CronExamples.every_hour": "Cada hora (0 * * * *)",
  "DataScienceJobs-CronExamples.every_6_hours": "Cada 6 horas",
  "DataScienceJobs-CronExamples.every_5_minutes": "Cada 5 minutos",
  "DataScienceJobs-CronExamples.every_10_minutes": "Cada 10 minutos",
  "DataScienceJobs-CronExamples.every_15_minutes": "Cada 15 minutos",
  "DataScienceJobs-CronExamples.every_30_minutes": "Cada 30 minutos",
  "DataScienceJobs-CronExamples.weekdays": "Días laborables a medianoche",
  "NavBar-DataScienceJobs": "Análisis",
  "DataScienceJobs-TabJobs": "Trabajos",
  "FaissIndexes-TabTitle": "Índices FAISS",
  "DemandForecastArtifacts-TabTitle": "Pronóstico",
  "DemandForecastArtifacts-Title": "Archivos de pronóstico de demanda",
  "DemandForecastArtifacts-Description":
    "Suba el pipeline, el modelo y la configuración que usa cada pronóstico de la organización.",
  "DemandForecastArtifacts-PairNote":
    "El pipeline y el modelo deben ser el par entrenado junto. Los tres archivos deben estar activos; si falta alguno, la ejecución no comienza.",
  "DemandForecastArtifacts-Pipeline": "Pipeline",
  "DemandForecastArtifacts-Model": "Modelo",
  "DemandForecastArtifacts-Config": "Configuración",
  "DemandForecastArtifacts-PipelineHint": "Archivo .joblib del pipeline.",
  "DemandForecastArtifacts-ModelHint": "Archivo .joblib del modelo.",
  "DemandForecastArtifacts-ConfigHint": "Archivo .json de configuración.",
  "DemandForecastArtifacts-Upload": "Subir archivo",
  "DemandForecastArtifacts-UploadSuccess": "Archivo subido",
  "DemandForecastArtifacts-UploadError": "No se pudo subir el archivo",
  "DemandForecastArtifacts-SetActive": "Usar en las próximas ejecuciones",
  "DemandForecastArtifacts-SetActiveSuccess": "Archivo activo actualizado",
  "DemandForecastArtifacts-Deactivate": "Dejar de usar",
  "DemandForecastArtifacts-DeactivateSuccess": "Archivo desactivado",
  "DemandForecastArtifacts-Active": "Activo",
  "DemandForecastArtifacts-Inactive": "Inactivo",
  "DemandForecastArtifacts-DeleteConfirm": "¿Eliminar este archivo?",
  "DemandForecastArtifacts-DeleteSuccess": "Archivo eliminado",
  "DemandForecastArtifacts-DownloadError": "No se pudo descargar el archivo",
  "DemandForecastArtifacts-Rename": "Renombrar",
  "DemandForecastArtifacts-RenameSuccess": "Nombre actualizado",
  "DemandForecastArtifacts-RenameFilename": "Nombre del archivo",
  "DemandForecastArtifacts-Empty": "Todavía no hay archivos",
  "DemandForecastArtifacts-SelectOrganizationFirst":
    "Seleccione una organización en el encabezado",
  "DemandForecastArtifacts-Organization": "Organización",
  "DemandForecastArtifacts-SelectionTitle": "Selección para la próxima ejecución",
  "DemandForecastArtifacts-SelectionNone": "Ninguno",
  "DemandForecastArtifacts-Filename": "Archivo",
  "DemandForecastArtifacts-Size": "Tamaño",
  "DemandForecastArtifacts-UploadedAt": "Subido",
  "DemandForecastArtifacts-Status": "Estado",
  "DataScienceJobs-ArtifactsUsed": "Archivos usados",
  "DataScienceJobs-ArtifactImageDefault": "incluidos en la imagen",
  "DataScienceJobs-ArtifactPipeline": "Pipeline",
  "DataScienceJobs-ArtifactModel": "Modelo",
  "DataScienceJobs-ArtifactConfig": "Configuración",
  "Common-PaginationItems": "elementos",
  "Common-PaginationOf": "de",
  "Common-PaginationPerPage": "por página",
  "Common-PaginationGoTo": "Ir a",
  "Common-PaginationPage": "Página",
  "Common-AverageTicket": "Ticket promedio",
  "Common-Behaviour": "Comportamiento",
  "Common-BelongsShoppingCenter": "¿Pertenece a centro comercial?",
  "Common-Bin": "Bines",
  "Common-BinLength": "Ingrese una bin de 6 caracteres",
  "Common-BinMinLength": "Debe tener un largo de 6 caracteres",
  "Common-BinRangeMax": "Bines hasta",
  "Common-BinRangeMin": "Bines desde",
  "Common-Birthdate": "Fecha de nacimiento",
  "Common-BirthDate": "Fecha de nacimiento",
  "Common-BirthdayBetween": "Fecha de cumpleaños entre",
  "Common-BranchOffice": "Tienda",
  "Common-BranchOfficeDeposit": "Tienda/Deposito",
  "Common-BranchOffices": "Tiendas",
  "Common-Brand": "Marca",
  "Common-Brands": "Marcas",
  "Common-Material": "Material",
  "Common-BusinessUnit": "Unidad de negocio",
  "Common-BuyInSquare": "Compra en plaza",
  "Common-BuyProbability": "Probabilidad de compra",
  "Common-BuyTogether": "Comprar juntos",
  "Common-Cancel": "Cancelar",
  "Common-Close": "Cerrar",
  "Common-CancelPromotionConfirm":
    "¿Está seguro que quiere cancelar la promocion?",
  "Common-Capacity": "Capacidad",
  "Common-CapacityDispatchUnits": "Capacidad despacho (unidades/día)",
  "Common-CapacityInVolume": "Capacidad en volumen",
  "Common-CapacityMaxInUnits": "Capacidad máxima de carga en unidades",
  "Common-CapacityReception": "Capacidad recepción",
  "Common-CapacityStorageInmt3": "Capacidad de almacenaje en mt3",
  "Common-CapacityStorageInUnits": "Capacidad de almacenaje en unidades",
  "Common-Car": "Auto",
  "Common-Catalogue": "Catalogo",
  "Common-CatalogueSupplier": "Catálogo de Proveedor",
  "Common-PurchasedCategories": "CATEGORÍAS COMPRADAS",
  "Common-Categories": "Categorías",
  "Common-Category": "Categoría",
  "Common-Classification": "Clasificación",
  "Common-Cellphone": "Celular",
  "Common-ChangePassword": "Cambiar contraseña",
  "Common-ChangeStatus": "Cambiar estado",
  "Common-ChangeOfPrice": "Cambio de precio",
  "Common-Channel": "Canal",
  "Common-Channels": "Canales",
  "Common-Characters": "Caracteres",
  "Common-City": "Ciudad",
  "Common-Client": "Cliente",
  "Common-ClientLevel": "Nivel de cliente",
  "Common-ClientLevels": "Niveles de clientes",
  "ClientLevel-EmptyTitle": "No hay niveles de cliente",
  "ClientLevel-EmptyDescription":
    "No se han creado niveles de cliente aún. Comienza creando el primero.",
  "ClientLevel-EmptyButton": "Crear primer nivel",
  "ClientLevel-EmptyFilterTitle": "No se encontraron resultados",
  "ClientLevel-EmptyFilterDescription":
    "No hay niveles de cliente que coincidan con los filtros aplicados. Intenta ajustar los criterios de búsqueda.",
  "ClientLevel-EmptyFilterButton": "Limpiar filtros",
  "AccumulationUnit-EmptyTitle": "No hay unidades de acumulación",
  "AccumulationUnit-EmptyDescription":
    "Aún no configuraste unidades de acumulación. Crea la primera para comenzar.",
  "AccumulationUnit-EmptyButton": "Crear primera unidad",
  "AccumulationUnit-EmptyFilterTitle": "No se encontraron resultados",
  "AccumulationUnit-EmptyFilterDescription":
    "No hay unidades que coincidan con los filtros aplicados. Intenta ajustar la búsqueda.",
  "Common-ClientRut": "Rut",
  "Common-Clients": "Clientes",
  "Common-ClientId": "ID",
  "Common-AddClients": "Agregar Clientes",
  "Common-AddNewClients": "Agregar nuevos\nclientes",
  "Common-SearchClients": "Buscar clientes por documento",
  "Common-Remove": "Eliminar",
  "Client-EmptyTitle": "No hay clientes",
  "Client-EmptyDescription":
    "No se encontraron clientes en el sistema. Crea un nuevo cliente para comenzar.",
  "Client-EmptyButton": "Crear primer cliente",
  "Client-EmptyFilterTitle": "No se encontraron resultados",
  "Client-EmptyFilterDescription":
    "No hay clientes que coincidan con los filtros aplicados. Intenta ajustar los criterios de búsqueda.",
  "Common-ClientSegment": "Segmento de cliente",
  "Common-ClientSegments": "Segmentos de clientes",
  "Common-ClientsFromIncentive": "Incluye los mismos clientes que el incentivo {{name}} ({{count}} clientes)",
  "Common-ViewClients": "Ver clientes",
  "ClientSegment-Tab-General": "General",
  "ClientSegment-Tab-Clients": "Clientes",
  "ClientSegment-Tab-Composition": "Composición",
  "ClientSegment-LinkedReward": "Incentivo sugerido",
  "ClientSegment-LinkedActivation": "Acción de activación",
  "ClientSegment-SearchClients": "Buscar clientes",
  "ClientSegment-OpportunityFamily": "Tipo Oportunidad",
  "ClientSegment-TpMin": "TP mín",
  "ClientSegment-TpMax": "TP máx",
  "ClientSegment-UntilPresent": "Hasta actualidad",
  "ClientSegment-FromDate": "Desde",
  "ClientSegment-Min": "Mínimo",
  "ClientSegment-Max": "Máximo",
  "ClientSegment-EmptyComposition": "Sin datos de composición",
  "ClientSegment-EmptyCompositionDescription":
    "Este segmento aún no tiene datos de composición de cluster.",
  "ClientSegment-Composition-AvgAge": "Edad promedio",
  "ClientSegment-Composition-PercentWoman": "Porcentaje de mujeres",
  "ClientSegment-Composition-TopBrand": "Marca principal",
  "ClientSegment-Composition-TopCategory": "Categoría principal",
  "ClientSegment-Composition-AvgTicketValue": "Ticket promedio",
  "ClientSegment-Composition-MedianTicketValue": "Ticket mediano",
  "ClientSegment-Composition-AvgTicketCount": "Cantidad de compras promedio",
  "ClientSegment-Composition-MedianTicketCount": "Cantidad de compras mediana",
  "ClientSegment-Composition-MostFrequentBranch": "Sucursal más frecuente",
  "SegmentFamily-EconomicReactivation": "RFM / reactivación",
  "SegmentFamily-CategoryAffinity": "Categorías compradas",
  "SegmentFamily-AttributeBuyers": "Atributos de producto",
  "SegmentFamily-BrandAffinity": "Marcas compradas",
  "SegmentFamily-LowPerformance": "Baja performance",
  "SegmentFamily-StockOpportunity": "Oportunidad de stock",
  "SegmentFamily-Loyalty": "Fidelidad",
  "SegmentFamily-Financial": "Financiera",
  "ClientSegment-EmptyClients": "No hay clientes en este segmento",
  "ClientSegment-EmptyClientsDescription":
    "Este segmento no tiene clientes asociados actualmente.",
  "ClientSegment-EmptyPreviewDynamic":
    "Configura los criterios y presiona 'Cargar' para ver los clientes",
  "ClientSegment-EmptyPreviewStatic":
    "Selecciona clientes de la lista para ver la vista previa",
  "ClientSegment-PreviewTimeout":
    "La vista previa tardó demasiado. Ajusta los criterios e inténtalo de nuevo",
  "ClientSegment-EmptyTitle": "No hay segmentos de cliente",
  "ClientSegment-EmptyDescription":
    "No se han creado segmentos de cliente aún. Comienza creando el primero.",
  "ClientSegment-EmptyButton": "Crear primer segmento",
  "ClientSegment-EmptyFilterTitle": "No se encontraron resultados",
  "ClientSegment-EmptyFilterDescription":
    "No hay segmentos de cliente que coincidan con los filtros aplicados. Intenta ajustar los criterios de búsqueda.",
  "RewardType-EmptyTitle": "No hay tipos de incentivo",
  "RewardType-EmptyDescription":
    "No se han creado tipos de incentivo aún. Comienza creando el primero.",
  "RewardType-EmptyButton": "Crear primer tipo",
  "RewardType-EmptyFilterTitle": "No se encontraron resultados",
  "RewardType-EmptyFilterDescription":
    "No hay tipos de incentivo que coincidan con los filtros aplicados. Intenta ajustar los criterios de búsqueda.",
  "RewardValueType-Nominal": "Nominal",
  "RewardValueType-Percentage": "Porcentual (%)",
  "RewardValueType-ValueKind": "Tipo de valor",
  "ArticleGroup-EmptyFilterTitle": "No se encontraron resultados",
  "ArticleGroup-EmptyFilterDescription":
    "No hay grupos de artículos que coincidan con los filtros aplicados. Intenta ajustar los criterios de búsqueda.",
  "ClientSegment-EmptyArticlesSelected": "No hay artículos seleccionados",
  "ClientSegment-EmptyArticlesSearch":
    "No se encontraron artículos con los criterios de búsqueda",
  "Common-Cluster": "Cluster",
  "Common-Clusters": "Clusters",
  "Common-Code": "Código",
  "Common-CodeNotEntered": "Debe ingresar un código",
  "Common-CodeLength": "Largo de código",
  "Common-CodeType": "Tipo de código",
  "Common-CodePrefix": "Prefijo código",
  "Common-CodeConfiguration": "Configuración de Código",
  "Unit-EmptyTitle": "No hay unidades",
  "Unit-EmptyDescription":
    "No se encontraron unidades en el sistema. Crea una nueva unidad para comenzar.",
  "NavBar-Recommendations": "Recomendaciones",
  "NavBar-RewardTypes": "Tipos de incentivo",
  "NavBar-Rewards": "Incentivos",
  "NavBar-Units": "Unidades",
  "Recommendation-EmptyTitle": "No hay recomendaciones",
  "Recommendation-EmptyDescription":
    "No se encontraron recomendaciones en el sistema. Crea una nueva recomendación para comenzar.",
  "Recommendation-EmptyFilterTitle": "No se encontraron resultados",
  "Recommendation-EmptyFilterDescription":
    "No hay recomendaciones que coincidan con los filtros aplicados. Intenta ajustar los criterios de búsqueda.",
  "Common-CategoriesAndSegments": "Categorías y Segmentos",
  "Common-ValuesAndLimits": "Valores y Límites",
  "Common-Collapse": "Colapsar",
  "Common-Color": "Color",
  "Common-Colour": "Color",
  "Common-Colours": "Colores",
  "Common-Comments": "Comentarios",
  "Common-EnterActivePoints": "Ingrese puntos activos",
  "Common-EnterPendingPoints": "Ingrese puntos pendientes",
  "Common-EnterPoints": "Ingrese puntos",
  "Common-EnterComments": "Ingrese comentarios",
  "Common-SearchByClient": "Cliente",
  "Common-SelectType": "Seleccione tipo",
  "Common-Select": "Seleccionar",
  "CommercialDateAnalysis-Diagnostic": "Diagnóstico Comercial",
  "CommercialDateAnalysis-Title": "Fechas comerciales",
  "CommercialDateAnalysis-Search": "Buscar fecha comercial",
  "CommercialDateAnalysis-Year": "Año",
  "CommercialDateAnalysis-View": "Vista",
  "CommercialDateAnalysis-ViewAll": "Vista: todas las fechas",
  "CommercialDateAnalysis-Sale": "Venta",
  "CommercialDateAnalysis-Units": "Unidades",
  "CommercialDateAnalysis-MarginPct": "% Margen",
  "CommercialDateAnalysis-AverageTicket": "Ticket promedio",
  "CommercialDateAnalysis-BasketSize": "Tamaño cesta",
  "CommercialDateAnalysis-AnnualSalesMoney": "% venta anual en $",
  "CommercialDateAnalysis-AnnualSalesUnits": "% venta anual en unidades",
  "CommercialDateAnalysis-ComparePrevEdition": "Comparativa vs edición anterior",
  "CommercialDateAnalysis-MixAnnualMoney": "Mix anual $",
  "CommercialDateAnalysis-MixAnnualUnits": "Mix anual uds",
  "CommercialDateAnalysis-ViewDetail": "Ver detalle",
  "CommercialDateAnalysis-NoResults": "No hay fechas comerciales para los filtros seleccionados",
  "CommercialDateDetail-NotFound": "Fecha comercial no encontrada",
  "CommercialDateDetail-GrossSales": "Venta bruta",
  "CommercialDateDetail-Units": "Unidades",
  "CommercialDateDetail-UniqueClients": "Clientes únicos",
  "CommercialDateDetail-UniqueClientsSub": "Compradores únicos",
  "CommercialDateDetail-NewClients": "Clientes nuevos",
  "CommercialDateDetail-NewClientsSub": "Primera compra",
  "CommercialDateDetail-MarginPct": "% Margen",
  "CommercialDateDetail-VsPrevEdition": "vs edición anterior",
  "CommercialDateDetail-NoPriorComparison": "Sin comparativa (edición anterior no registrada)",
  "CommercialDateDetail-PerformanceByStore": "Desempeño por tienda",
  "CommercialDateDetail-PerformanceByChannel": "Desempeño por canal",
  "CommercialDateDetail-Store": "Tienda",
  "CommercialDateDetail-Channel": "Canal",
  "CommercialDateDetail-Sale": "Venta",
  "CommercialDateDetail-Tickets": "Tickets",
  "CommercialDateDetail-AvgTicket": "Ticket prom.",
  "CommercialDateDetail-Margin": "Margen",
  "CommercialDateDetail-EventSalesPct": "% evento",
  "CommercialDateDetail-Products": "Productos",
  "CommercialDateDetail-AllProducts": "Todos",
  "CommercialDateDetail-Roi": "ROI",
  "CommercialDateDetail-NoPromotions": "No hay promociones vigentes en este período",
  "CommercialDateDetail-ForecastPending": "Pendiente",
  "CommercialDateDetail-TopProducts": "Productos más vendidos",
  "CommercialDateDetail-BottomProducts": "Productos menos vendidos",
  "CommercialDateDetail-Product": "Producto",
  "CommercialDateDetail-Category": "Categoría",
  "CommercialDateDetail-TopCategories": "Categorías más vendidas",
  "CommercialDateDetail-BottomCategories": "Categorías menos vendidas",
  "CommercialDateDetail-ActivePromotions": "Promociones activas y desempeño",
  "CommercialDateDetail-Promotion": "Promoción",
  "CommercialDateDetail-Type": "Tipo",
  "CommercialDateDetail-Uplift": "Uplift",
  "CommercialDateDetail-CompareYears": "Comparativa con años anteriores",
  "CommercialDateDetail-BehaviorKpis": "KPIs de comportamiento",
  "CommercialDateDetail-SelectedEdition": "Edición seleccionada",
  "CommercialDateDetail-AverageTicket": "Ticket promedio",
  "CommercialDateDetail-BasketSize": "Tamaño de la cesta",
  "CommercialDateDetail-AnnualSalesMoney": "% de venta anual en $",
  "CommercialDateDetail-AnnualSalesUnits": "% de venta anual en unidades",
  "CommercialDateDetail-ForecastProducts": "Forecast por producto",
  "CommercialDateDetail-ForecastCategories": "Forecast por categoría",
  "CommercialDateDetail-Forecast": "Forecast",
  "CommercialDateDetail-Confidence": "Confianza",
  "CommercialDateDetail-ConfidenceHigh": "Alta",
  "CommercialDateDetail-ConfidenceMedium": "Media",
  "CommercialDateDetail-ConfidenceLow": "Baja",
  "CommercialSummary-Title": "Resumen Comercial",
  "CommercialSummary-LastUpdated": "Última actualización: {{date}}",
  "CommercialSummary-Loading": "Cargando datos...",
  "CommercialSummary-Export": "Exportar resumen",
  "CommercialSummary-Filter-Period": "Período",
  "CommercialSummary-Filter-Channel": "Canal",
  "CommercialSummary-Filter-Channel-Placeholder": "Todos",
  "CommercialSummary-Filter-Store": "Tienda",
  "CommercialSummary-Filter-Store-Placeholder": "Todas",
  "CommercialSummary-Filter-Category": "Categoría",
  "CommercialSummary-Filter-Category-Placeholder": "Todas",
  "CommercialSummary-Filter-Brand": "Marca",
  "CommercialSummary-Filter-Brand-Placeholder": "Todas",
  "CommercialSummary-Kpi-GrossSales": "Venta bruta",
  "CommercialSummary-Kpi-Units": "Unidades",
  "CommercialSummary-Kpi-Tickets": "Tickets",
  "CommercialSummary-Kpi-AverageTicket": "Ticket promedio",
  "CommercialSummary-Kpi-Margin": "Margen",
  "CommercialSummary-Kpi-VsLastYear": "vs mismo período LY",
  "CommercialSummary-PeriodStatus-Title": "Estado del período",
  "CommercialSummary-PeriodStatus-Text":
    "El período cerró con una venta de {{grossSales}}, {{variation}} vs LY. El crecimiento estuvo impulsado por {{growthStores}} y {{growthCategories}}, mientras que {{declineCategories}} y {{declineStores}} mostraron deterioro.",
  "CommercialSummary-NoData": "sin datos suficientes",
  "CommercialSummary-Channels-Title": "Canales que explicaron el resultado",
  "CommercialSummary-Stores-Title": "Resultados por tienda",
  "CommercialSummary-CategoriesPositive-Title": "Categorías con mayor contribución positiva",
  "CommercialSummary-CategoriesNegative-Title": "Categorías con mayor contribución negativa",
  "CommercialSummary-Products-TopTitle": "Productos que impulsaron la venta",
  "CommercialSummary-Products-BottomTitle": "Productos con peor desempeño",
  "ActiveSeasons-Label": "Temporada activa hoy:",
  "ActiveSeasons-None": "ninguna",
  "ActiveSeasons-Hint": "· Se excluyen artículos de otras temporadas (los artículos sin temporada se incluyen).",
  "CommercialSummary-Clients-Title": "Clientes",
  "CommercialSummary-Client-Unique": "Clientes únicos",
  "CommercialSummary-Client-New": "Clientes nuevos",
  "CommercialSummary-Client-AverageTicket": "Ticket medio por cliente",
  "CommercialSummary-Client-Frequency": "Frecuencia media",
  "CommercialSummary-Segments-Title": "Segmentos",
  "CommercialSummary-Campaigns-Title": "Impacto de campañas y promociones",
  "CommercialSummary-SuggestedFocus-Title": "Focos sugeridos para el próximo período",
  "CommercialSummary-Drivers-Title": "Drivers detectados",
  "CommercialSummary-Drivers-Empty": "Sin drivers detectados en este período.",
  "CommercialSummary-Driver-ChannelGrowth": "{{channel}} explica el {{pct}}% del crecimiento del negocio.",
  "CommercialSummary-Driver-CategoryGrowth": "{{category}} explica el {{pct}}% del crecimiento del negocio.",
  "CommercialSummary-Driver-BrandGrowth": "{{brand}} explica el {{pct}}% del crecimiento del negocio.",
  "CommercialSummary-Driver-StoreGrowth": "{{store}} explica el {{pct}}% del crecimiento del negocio.",
  "CommercialSummary-Driver-AverageTicketGrowth":
    "El ticket promedio crece {{x}}% y supera el crecimiento de unidades ({{y}}%).",
  "CommercialSummary-Driver-VolumeGrowth":
    "Las unidades vendidas crecen {{x}}% y superan el crecimiento del ticket promedio ({{y}}%).",
  "CommercialSummary-Driver-MixShift": "{{category}} gana {{pct}} puntos de participación dentro del mix comercial.",
  "CommercialSummary-Driver-RecentRecovery":
    "Las ventas de las últimas dos semanas superan en {{pct}}% al período anterior.",
  "CommercialSummary-Insights-Title": "Insights",
  "CommercialSummary-Insights-Empty": "Sin insights detectados en este período.",
  "CommercialSummary-Insight-DominantChannel": "{{channel}} representa el {{pct}}% de la venta total",
  "CommercialSummary-Insight-DominantCategory": "{{category}} concentra el {{pct}}% de la facturación",
  "CommercialSummary-Insight-GrowthByVolume": "El crecimiento está impulsado por mayor volumen de unidades",
  "CommercialSummary-Insight-GrowthByTicket": "El crecimiento está impulsado por ticket promedio",
  "CommercialSummary-Insight-PromotionsDrivingSales": "Las promociones representan el {{pct}}% de la venta",
  "CommercialSummary-Insight-CategoryGainsShare": "{{category}} gana {{pct}} puntos de participación frente a LY",
  "CommercialSummary-Alerts-Title": "Alertas activas",
  "CommercialSummary-Alerts-Empty": "Sin alertas activas en este período.",
  "CommercialSummary-Alert-SalesDropVsLY": "Caída relevante de venta vs año anterior",
  "CommercialSummary-Alert-MarginDecline": "Margen deteriorado respecto al año anterior",
  "CommercialSummary-Alert-PromoDependency": "Más del {{pct}}% de la venta ocurre bajo promociones",
  "CommercialSummary-Alert-ChannelDependency": "{{channel}} concentra el {{pct}}% de la venta total",
  "CommercialSummary-Alert-CategoryDependency": "{{category}} concentra el {{pct}}% de la facturación",
  "CommercialSummary-Alert-Top10ProductsDependency":
    "Los 10 productos más vendidos concentran el {{pct}}% de la venta",
  "CommercialSummary-Alert-LowCatalogDispersion": "Solo el {{pct}}% del catálogo tuvo venta en el período",
  "CommercialSummary-Alert-CategoryStructuralDecline":
    "{{category}} con {{weight}}% de peso cae {{pct}}% en participación.",
  "CommercialSummary-Alert-AverageTicketDecline": "Ticket promedio deteriorado vs año anterior",
  "CommercialSummary-Alert-LowActivity": "Caída relevante en cantidad de tickets",
  "CommercialSummary-Column-Channel": "Canal",
  "CommercialSummary-Column-Store": "Tienda",
  "CommercialSummary-Column-Category": "Categoría",
  "CommercialSummary-Column-Sales": "Venta",
  "CommercialSummary-Column-PctSales": "% Venta",
  "CommercialSummary-Column-Tickets": "Tickets",
  "CommercialSummary-Column-Units": "Unidades",
  "CommercialSummary-Column-AverageTicket": "Ticket promedio",
  "CommercialSummary-Column-Margin": "Margen",
  "CommercialSummary-Column-Product": "Producto",
  "CommercialSummary-Column-TicketCount": "Cantidad de tickets",
  "CommercialSummary-Column-Clients": "Clientes",
  "CommercialSummary-Column-Segment": "Segmento",
  "CommercialSummary-Column-Campaign": "Campaña",
  "CommercialSummary-Column-Type": "Tipo",
  "CommercialSummary-Column-Status": "Estado",
  "CommercialSummary-Column-Validity": "Vigencia",
  "CommercialSummary-Column-ROI": "ROI",
  "CommercialSummary-Column-IncrementalSales": "Venta incremental",
  "CommercialSummary-Column-Cost": "Costo",
  "CommercialSummary-Column-SalesLY": "Venta año anterior",
  "CommercialSummary-Column-Variation": "Variación %",
  "CommercialSummary-Column-ExternalId": "Código externo",
  "CommercialSummary-Column-ValidityStart": "Inicio vigencia",
  "CommercialSummary-Column-ValidityEnd": "Fin vigencia",
  "Common-CommercialDate": "Fecha Comercial",
  "Common-CommercialDateEditions": "Ediciones",
  "CommercialDate-ChannelsHint": "Dejar vacío para que aplique a todos los canales",
  "CommercialDate-ChannelsPlaceholder": "Todos los canales",
  "Common-CommercialDates": "Fechas Comerciales",
  "Common-AddEdition": "Agregar edición",
  "Common-EditEdition": "Editar edición",
  "Common-EndDateBeforeStartDate": "La fecha de fin debe ser posterior o igual a la fecha de inicio",
  "Common-NoEditionsYet": "Todavía no hay ediciones cargadas para esta fecha comercial",
  "Common-NotLoadedYet": "Sin cargar",
  "Common-Competitor": "Competidor",
  "Common-Competitors": "Competidores",
  "Common-Complete": "Completar",
  "Common-Completed": "Completada",
  "Common-Conditions": "Condiciones",
  "Common-Confirm": "Confirmar",
  "Common-ConsumedPoints": "Puntos consumidos",
  "Common-Consumption": "Consumo",
  "Common-Contact": "Contacto",
  "Common-ConversionFactor": "Factor de conversión",
  "Common-ConversionPercentage": "Conversión (%)",
  "Common-Cost": "Costo",
  "Common-ROI": "ROI",
  "Common-NotApplicableNoIncentive": "No aplica (sin incentivo)",
  "Common-Country": "País",
  "Common-CreateArticleSucessMessage":
    "Se ha creado un nuevo artículo correctamente.",
  "Common-CreatedDate": "Fecha de creación",
  "Common-CreateErrorMessage":
    "Hubo un problema, intentelo otra vez en un momento.",
  "Common-CreateSuccessMessage": "Se ha creado correctamente.",
  "Common-Currencies": "Monedas",
  "Common-CostCurrency": "Moneda del costo",
  "Common-Currency": "Moneda",
  "Common-Curve": "Curva",
  "Common-Curves": "Curvas",
  "Common-Date": "Fecha",
  "Common-Dates": "Fechas",
  "Common-Demographics": "Demografía",
  "Common-PurchaseBehavior": "Comportamiento de Compra",
  "Common-Preferences": "Preferencias",
  "Common-PurchaseHistory": "Historial de Compras",
  "Common-Configuration": "Configuración",
  "Common-DateLastPurchase": "Fecha de última compra",
  "Common-Day": "Día",
  "Common-Days": "Días",
  "Common-DaysSinceLastPurchase": "Dias desde la última compra",
  "Common-DefaultPrice": "Precio por defecto",
  "Common-Delete": "Eliminar",
  "Common-Demand": "Demanda",
  "Common-DeleteConfirm": "¿Está seguro que quiere eliminar?",
  "Common-DeleteScheduleConfirm":
    "¿Está seguro que quiere eliminar este cronograma?",
  "Common-DeleteErrorMessage":
    "Hubo un error al eliminar, intentelo más tarde.",
  "Common-DeleteSuccessMessage": "Se ha eliminado correctamente",
  "Common-DeliverTo": "Entrega en",
  "Common-Delivery": "Entrega",
  "Common-DeliveryTerm": "Lead time",
  "Common-Deposit": "Depósito",
  "Common-Deposits": "Depósitos",
  "Common-Description": "Descripción",
  "Common-DescriptionNotEntered": "Descripción",
  "Common-Destination": "Destino",
  "Common-DestinationDeposit": "Depósito de destino",
  "Common-DestinationBranchOffice": "Tienda de destino",
  "Common-DestinationType": "Tipo de destino",
  "Common-DestinationBranchOfficeNotSelected":
    "Seleccione una tienda de destino",
  "Common-DestinationDepositNotSelected": "Seleccione un depósito de destino",
  "Common-Destiny": "Destino",
  "Common-Discontinue": "Discontinuar",
  "Common-DiscontinueConfirm":
    "¿Está seguro que quiere discontinuar este artículo?",
  "Common-Discontinued": "Discontinuado",
  "Common-DiscountPercent": "Porcentaje de descuento",
  "Common-DiscountType": "Tipo de descuento",
  "Common-DiscountValue": "Valor de descuento",
  "Common-DispatchFrequency": "Frecuencia despacho",
  "Common-Distance": "Distancia",
  "Common-DistributeLines": "Distribuye entre lineas",
  "Common-Distribution": "Distribución",
  "Common-DocumentNumber": "Numero de documento",
  "Common-DocumentType": "Tipo de documento",
  "Common-Download": "Descargar",
  "Common-Visualize": "Visualizar",
  "Common-DownloadSuccessMessage": "Se ha descargado correctamente",
  "Common-ErrorDownloadingCsv":
    "Hubo un error al descargar el CSV, intentelo más tarde",
  "Common-DownloadCsv": "Descargar CSV",
  "Common-Downloading": "Descargando...",
  "Common-DownloadTemplate": "Descargar Plantilla",
  "Common-DownloadCampaignData": "Descargar datos de campaña",
  "Common-DownloadAudience": "Descargar audiencia",
  "Common-Edit": "Editar",
  "Common-EditErrorMessage": "Hubo un error al editar, intentelo más tarde",
  "Common-EditSuccessMessage": "Se ha editado correctamente",
  "Common-StagedChangesMessage":
    "Cambios aplicados localmente. Haga clic en Guardar para persistir.",
  "Common-Email": "Email",
  "Common-EmailNotEntered": "Ingrese su email",
  "Common-InvalidEmail": "Por favor ingrese un email válido",
  "Common-CreateNew": "Crear nuevo",
  "Common-Clear": "Limpiar",
  "Common-Saving": "Guardando...",
  "Common-BasicInformation": "Información básica",
  "Common-CapacityAndShoppingCenter": "Capacidad y centro comercial",
  "Common-PriceAndCosts": "Precios y costos",
  "Common-StockAndLocation": "Stock",
  "Common-AddressSection": "Ubicación",
  "Common-ChannelAndRestrictions": "Canal y restricciones",
  "Common-ShowAdvanced": "Mostrar avanzados",
  "Common-HideAdvanced": "Ocultar avanzados",
  "Common-ShowDocumentInList": "Ver documento",
  "Common-HideDocumentInList": "Ver id. externo",
  "Common-EnterOrganization":
    "Ingresa el nombre de tu organización para comenzar",
  "Common-SignInToContinue": "Inicia sesión para continuar",
  "Common-Welcome": "Bienvenido",
  "Common-Or": "O",
  "Common-DontHaveAccount": "¿No tienes una cuenta?",
  "Common-End": "Fin",
  "Common-EndDate": "Fecha de fin",
  "Common-EndDateBirthdate": "Fecha nacimiento hasta",
  "Common-EndDateRegister": "Fecha registro hasta",
  "Common-EndTime": "Hora de fin",
  "Common-EnterABin": "Ingrese el numero de bines de 6 caracteres.",
  "Common-EnterPossibleValues": "Escriba los valores posibles",
  "Common-ErrorMessage": "Ocurrio un error, intentelo mas tarde",
  "Common-ErrorOnExcelFile":
    "Se detectaron los siguientes errores en el archivo seleccionado:",
  "Common-ErrorOnExcelFileLineText":
    "- Hoja: {{sheet}}, Fila {{row}}, Columna {{column}}, error: {{errorMessage}}",
  "Common-EstablishRecurrence": "Establecer recurrencia",
  "Common-EstimatedDeliveryDate": "Fecha estimada",
  "Common-EstimatedStockBreak": "Quiebre estimado",
  "Common-EstimatedDemand": "Demanda estimada",
  "Common-Every": "Cada",
  "Common-exampleURL": "http://ejemplo.com",
  "Common-ExhibitionSpace": "Espacio exhibición",
  "Common-ExpectedResult": "Resultado esperado",
  "Common-Expired": "Expirados",
  "Common-ExpiredDate": "Fecha de vencimiento",
  "Common-ExpirationDateHint":
    "Si se deja vacío, se usa la validez configurada por la organización (si existe).",
  "Common-ExpirationDateOptional": "Fecha de vencimiento (opcional)",
  "Common-ExpiresOn": "Fecha de vencimiento",
  "Common-ExternalId": "Id externo",
  "Common-FeeMaxRange": "Máximo de cuotas",
  "Common-FeeMinRange": "Mínimo de cuotas",
  "Common-FeeRange": "Rango de cuotas",
  "Common-FeeRangePlaceHolder": "Ej: 1-12",
  "Common-FidelityId": "Id de fidelidad",
  "Common-Filters": "Filtros",
  "Common-Flavour": "Sabor",
  "Common-ForgotPassword": "¿Olvidó su contraseña?",
  "Common-ForTotalArticles":
    "Distribuye el total a los artículos que llevan el descuento",
  "Common-FreeShipping": "Envio gratis",
  "Common-Friday": "Viernes",
  "Common-FuelConsumption": "Consumo de combustible por km",
  "Common-FullName": "Nombre completo",
  "Common-FutureExpirations": "Futuras expiraciones",
  "Common-Gender": "Género",
  "Common-Generated": "Generada",
  "Common-GeneratedOrders": "Ordenes a generar",
  "Common-GenerateOrder": "Generar orden",
  "Common-Gift": "Regalo",
  "Common-Go": "Ir",
  "Common-Goals": "Objetivos",
  "Common-GoBack": "Regresar",
  "Common-GroupBySupplier": "Agupar por proveedor",
  "Common-Height": "Altura",
  "Common-HeightWithPackaging": "Altura con empaque",
  "Common-HighPrice": "Aplica a mayor precio",
  "Common-HistoricalStock": "Historial de stock",
  "Common-HistoricPricings": "Histórico de precios",
  "Common-Hour": "Hora",
  "Common-Id": "Id",
  "Common-Identifier": "Documento",
  "Common-IDNumber": "Número de documento",
  "Common-Import": "Importar",
  "Common-ImportedArticle": "Articulo importado",
  "Common-ImportEntity": "Importar {{entity}}",
  "Common-ImportSuccess": "Se importaron correctamente {{quantity}} filas.",
  "Common-StockMovementImport": "Importar stock",
  "Common-TicketImport": "Importar tickets",
  "Common-TicketImportDescription":
    "Subir archivos JSONL o ZIP que contengan datos de tickets para importación masiva.",
  "Common-RewardImport": "Importar recompensas",
  "Common-RewardImportDescription":
    "Subir archivos JSONL o ZIP que contengan datos de recompensas para importación masiva.",
  "Common-PricingImport": "Importar pricing",
  "Common-PricingImportDescription":
    "Subir archivos JSONL o ZIP que contengan datos de pricing para importación masiva.",
  "Common-ClientImport": "Importar clientes",
  "Common-ClientImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es un cliente con operation create o update.",
  "Common-SkuImport": "Importar artículos y SKUs",
  "Common-SkuImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es un artículo con marca, categorías y SKUs.",
  "Common-ArticleSeasonImport": "Importar temporadas de artículos",
  "Common-ArticleSeasonImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es un artículo con los nombres de sus temporadas y reemplaza las que tenía (lista vacía las quita).",
  "Common-PaymentMethodImport": "Importar medios de pago",
  "Common-PaymentMethodImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es un medio de pago.",
  "Common-PromotionImport": "Importar promociones",
  "Common-PromotionImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es una promoción regular con sus SKUs.",
  "Common-PointsMovementImport": "Importar movimientos de puntos",
  "Common-PointsMovementImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es un movimiento de puntos de un cliente.",
  "Common-BranchOfficeImport": "Importar sucursales",
  "Common-BranchOfficeImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es una sucursal. Si ya existe, se omite.",
  "Common-PurchaseOrderImport": "Importar órdenes de compra",
  "Common-PurchaseOrderImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es una orden de compra de la unidad de negocio seleccionada.",
  "Common-RepositionOrderImport": "Importar órdenes de reposición",
  "Common-RepositionOrderImportDescription":
    "Subir un archivo JSONL o ZIP. Cada línea es una orden de reposición de la unidad de negocio seleccionada.",
  "Common-IncorrectRows": "Incorrectos",
  "Import-BusinessUnitRequired":
    "Seleccioná una unidad de negocio en el encabezado antes de subir el archivo.",
  "Import-BusinessUnitHint":
    "La carga usa la unidad de negocio seleccionada en el encabezado.",
  "Common-PricingDataFormat": "Datos de pricing en formato JSONL",
  "Common-PricingJsonlFormatExample": "Ejemplo de formato JSONL:",
  "Common-PricingJsonlFormatSample": `{"name": "Pricing Example", "description": "Sample pricing", "value": 1000.0, "endPrice": "NEW_PRICE", "newPrice": 1200.0, "pricingTypeExternalId": "TYPE001", "brandExternalId": "BRAND001", "branchOfficeExternalIds": ["BRANCH001"], "categoryExternalIds": ["CAT001"], "articlesIds": [{"articleId": 1, "demand": 100, "optimalPrice": 1100.0, "priceCompetition": 1050.0}], "articleGroups": [{"articleGroupId": 1, "demand": 50, "optimalPrice": 1150.0, "priceCompetition": 1100.0}]}`,
  "Common-PricingJsonlKeyFields": "Campos clave:",
  "Common-PricingJsonlKeyFieldName": "<code>name</code>: Nombre del pricing",
  "Common-PricingJsonlKeyFieldDescription":
    "<code>description</code>: Descripción del pricing",
  "Common-PricingJsonlKeyFieldValue":
    "<code>value</code>: Valor base del pricing",
  "Common-PricingJsonlKeyFieldEndPrice":
    "<code>endPrice</code>: Tipo de precio final (NEW_PRICE, CURRENT_PRICE)",
  "Common-RequiredFields": "Datos de tickets en formato JSONL",
  "Common-ImportInstructions": "Instrucciones de Importación",
  "Common-ImportDescription":
    "Sube un archivo CSV o ZIP que contenga datos de stock para importar movimientos de stock masivamente.",
  "Common-SupportedFormats": "Formatos soportados",
  "Common-RequiredColumns": "Columnas requeridas",
  "Common-MaxFileSize": "Tamaño máximo de archivo",
  "Common-SelectFile": "Seleccionar Archivo",
  "Common-SelectVehicle": "Seleccionar vehículo",
  "Common-SelectDestinationBranchOffice": "Seleccionar tienda de destino",
  "Common-SelectDestinationDeposit": "Seleccionar depósito de destino",
  "Common-SelectRecurrence": "Seleccionar recurrencia",
  "Common-AutoStartEnabled": "Inicio automático habilitado",
  "Common-AutoStartDisabled": "Inicio automático deshabilitado",
  "Common-ImportHistory": "Historial de Importaciones",
  "Common-Refresh": "Actualizar",
  "ImportDashboard-Title": "Resumen de importaciones",
  "ImportDashboard-Description":
    "Consulta el último resultado de cada tipo de importación y explora el historial reciente.",
  "ImportDashboard-Overview": "Resumen",
  "ImportDashboard-CorrectRows": "Filas correctas",
  "ImportDashboard-ErrorRows": "Filas con errores",
  "ImportDashboard-ByTypeTitle": "Último proceso por tipo de importación",
  "ImportDashboard-ExpandCard": "Mostrar detalles de {{type}}",
  "ImportDashboard-CollapseCard": "Ocultar detalles de {{type}}",
  "ImportDashboard-ResultSummaryCompleted":
    "Importación completada: {{correct}} correctas, {{errors}} con errores ({{mode}})",
  "ImportDashboard-BatchMode": "proceso por lotes",
  "ImportDashboard-BulkMode": "procesamiento masivo",
  "ImportDashboard-Type": "Tipo de importación",
  "ImportDashboard-ProcessCount": "{{value}} procesos históricos",
  "ImportDashboard-LastProcess": "Último proceso",
  "ImportDashboard-LastDate": "Fecha",
  "ImportDashboard-LastDuration": "Duración",
  "ImportDashboard-NoProcess": "Todavía no hay procesos de este tipo.",
  "ImportDashboard-SourceUnavailable": "No disponible",
  "ImportDashboard-DownloadOriginal": "Descargar archivo",
  "ImportDashboard-DownloadErrors": "Descargar archivo de errores",
  "ImportDashboard-DownloadFailed": "No se pudo descargar el archivo.",
  "ImportDashboard-VisualizeFile": "Visualizar último archivo",
  "ImportDashboard-VisualizeTitle": "Vista previa: {{filename}}",
  "ImportDashboard-Action": "Acción",
  "ImportDashboard-OpenImports": "Abrir historial",
  "ImportDashboard-RecentTitle": "Importaciones recientes",
  "ImportDashboard-File": "Archivo",
  "ImportDashboard-Status": "Estado",
  "ImportDashboard-Date": "Fecha",
  "ImportDashboard-ProcessedRows": "Leídas / total",
  "ImportDashboard-Progress": "Progreso",
  "ImportDashboard-Warnings": "Advertencias",
  "ImportDashboard-Search": "Buscar por archivo",
  "ImportDashboard-FilterType": "Filtrar por tipo",
  "ImportDashboard-FilterStatus": "Filtrar por estado",
  "ImportDashboard-NoImports": "No hay importaciones para mostrar.",
  "ImportDashboard-TableTotal": "{{count}} importaciones",
  "ImportDashboard-Refresh": "Actualizar",
  "ImportDashboard-RecentScope":
    "Cada tarjeta muestra el último proceso y el total histórico de su tipo. La tabla reúne hasta {{count}} procesos recientes por tipo.",
  "ImportDashboard-SelectBusinessUnit":
    "Seleccioná una unidad de negocio en el encabezado para ver las importaciones.",
  "ImportDashboard-PartialError":
    "No se pudo consultar el historial de {{count}} tipo(s). Las tarjetas muestran esos tipos como no disponibles.",
  "ImportDashboard-StatusCompleted": "Completada",
  "ImportDashboard-StatusProcessing": "Procesando",
  "ImportDashboard-StatusError": "Error",
  "ImportDashboard-StatusCancelled": "Cancelada",
  "ImportDashboard-StatusPending": "Pendiente",
  "ImportDashboard-Seconds": "{{value}} s",
  "ImportDashboard-Minutes": "{{value}} min",
  "ImportDashboard-SourceTickets": "Tickets",
  "ImportDashboard-SourceRewards": "Recompensas",
  "ImportDashboard-SourceStockMovements": "Movimientos de stock",
  "ImportDashboard-SourcePricings": "Pricing",
  "ImportDashboard-SourceClients": "Clientes",
  "ImportDashboard-SourceSkus": "Artículos y SKUs",
  "ImportDashboard-SourceArticleSeasons": "Temporadas de artículos",
  "ImportDashboard-SourcePaymentMethods": "Medios de pago",
  "ImportDashboard-SourcePromotions": "Promociones",
  "ImportDashboard-SourcePointsMovements": "Movimientos de puntos",
  "ImportDashboard-SourceBranchOffices": "Sucursales",
  "ImportDashboard-SourcePurchaseOrders": "Órdenes de compra",
  "ImportDashboard-SourceRepositionOrders": "Órdenes de reposición",
  "Common-Search": "Buscar",
  "Common-Uptade-Success": "Se ha guardado con éxito",
  "Common-Filename": "Nombre del archivo",
  "Common-DownloadErrors": "Descargar Errores",
  "Common-ConfirmDelete": "Confirmar Eliminación",
  "Common-DeleteWarning":
    "¿Está seguro de que desea eliminar esta importación? Esta acción no se puede deshacer.",
  "Common-Deleted": "Eliminado",
  "Common-Cancelled": "Cancelado",
  "Common-Processing": "Procesando",
  "Common-UpcomingExpirations": "Próximos vencimientos",
  "Common-Upload": "Cargar",
  "Common-UploadFailed": "falló al subir",
  "Common-UploadSuccess": "subido exitosamente",
  "Common-AutoStart": "Inicio automático",
  "Common-Correct": "Correctos",
  "Common-Error": "Error",
  "Common-Errors": "Errores",
  "Common-PaginationInfo": "{{from}}-{{to}} de {{total}} elementos",
  "Common-ItemsPerPage": "elementos por página",
  "Common-GoTo": "Ir a",
  "Common-Page": "Página",
  "Common-SelectBusinessUnit": "Por favor seleccione una unidad de negocio",
  "Common-PreparingDownload": "Preparando descarga...",
  "Common-DownloadStarted": "Descarga iniciada",
  "Common-NoErrorsToDownload": "No hay errores para descargar",
  "Common-NoFileToDownload": "No hay archivo para descargar",
  "Error-LoadingImports": "Error al cargar las importaciones",
  "Error-UploadFailed": "Error al subir el archivo",
  "Error-CancelFailed": "Error al cancelar la importación",
  "Error-DeleteFailed": "Error al eliminar la importación",
  "Error-DownloadFailed": "Error al descargar el archivo de errores",
  "Error-NoErrorFile": "Archivo de errores no encontrado",
  "Error-FileNotFound": "Archivo no encontrado",
  "Error-FileTooLarge": "El archivo es demasiado grande para descargar",
  "Error-DownloadTimeout":
    "Tiempo de descarga agotado - el archivo puede ser muy grande",
  "Error-RequestTimeout": "Tiempo de solicitud agotado - intente de nuevo",
  "Import-ActiveImport": "Importación activa",
  "Import-LatestImport": "Última importación",
  "Import-PhaseQueued": "En cola",
  "Import-PhaseStarting": "Preparando proceso",
  "Import-PhaseReading": "Leyendo archivo",
  "Import-PhaseValidating": "Validando datos",
  "Import-PhaseApplying": "Aplicando cambios",
  "Import-PhaseFinalizing": "Finalizando",
  "Import-PhaseCompleted": "Importación completada",
  "Import-PhaseCancelled": "Importación cancelada",
  "Import-PhaseFailed": "La importación encontró un error",
  "Import-RowsRead": "Filas leídas",
  "Import-Elapsed": "Tiempo transcurrido",
  "Import-Remaining": "Tiempo restante aprox.",
  "Import-Calculating": "Calculando…",
  "Import-CurrentPhase": "Etapa actual",
  "Import-BackgroundTitle": "El proceso continúa en segundo plano",
  "Import-BackgroundDescription":
    "Puedes salir de esta página y volver más tarde. La importación no se interrumpirá.",
  "Import-CompletedSummary":
    "Finalizó con {{correct}} filas correctas y {{errors}} errores.",
  "Import-FailedSummary":
    "No se pudo completar la importación. Si hay errores de datos disponibles, puedes descargarlos para revisarlos.",
  "Import-CancelledSummary": "La importación fue cancelada.",
  "Import-DownloadOriginal": "Descargar original",
  "StockImport-ActiveImport": "Importación activa",
  "StockImport-LatestImport": "Última importación",
  "StockImport-PhaseQueued": "En cola",
  "StockImport-PhaseStarting": "Preparando proceso",
  "StockImport-PhaseReading": "Leyendo archivo",
  "StockImport-PhaseValidating": "Validando datos",
  "StockImport-PhaseApplying": "Actualizando stock",
  "StockImport-PhaseFinalizing": "Finalizando",
  "StockImport-PhaseCompleted": "Importación completada",
  "StockImport-PhaseCancelled": "Importación cancelada",
  "StockImport-PhaseFailed": "La importación encontró un error",
  "StockImport-RowsRead": "Filas leídas",
  "StockImport-Elapsed": "Tiempo transcurrido",
  "StockImport-Remaining": "Tiempo restante aprox.",
  "StockImport-Calculating": "Calculando…",
  "StockImport-CurrentPhase": "Etapa actual",
  "StockImport-LastActivity": "Última actividad",
  "StockImport-NoActivityYet": "Esperando la primera actualización",
  "StockImport-ActivityNow": "Actividad registrada ahora",
  "StockImport-ActivitySeconds": "Última actividad hace {{count}} s",
  "StockImport-ActivityMinutes": "Última actividad hace {{count}} min",
  "StockImport-ActivityHours": "Última actividad hace {{count}} h",
  "StockImport-BackgroundTitle": "El proceso continúa en segundo plano",
  "StockImport-BackgroundDescription":
    "Puedes salir de esta página y volver más tarde. La importación no se interrumpirá.",
  "StockImport-CompletedSummary":
    "Finalizó con {{correct}} filas correctas y {{errors}} errores.",
  "StockImport-FailedSummary":
    "No se pudo completar la importación. Si hay errores de datos disponibles, puedes descargarlos para revisarlos.",
  "StockImport-CancelledSummary": "La importación fue cancelada.",
  "StockImport-CancelTitle": "¿Cancelar la importación?",
  "StockImport-CancelDescription":
    "El proceso aislado se detendrá y no se aplicarán las filas restantes.",
  "StockImport-DownloadOriginal": "Descargar original",
  "Common-InDays": "en {{count}} días",
  "Common-Inactive": "Inactivo",
  "Common-Inactives": "Inactivos",
  "Common-InstructionsForUse": "Instrucciones de uso",
  "Common-InOrders": "En ordenes",
  "Common-InProgress": "En progreso",
  "Common-InAction": "En ejecución",
  "Common-Interval": "Intervalo",
  "Common-InventoryLevelOptimal": "Nivel de inventario óptimo",
  "Common-IsKit": "¿Es kit?",
  "Common-Iva": "Iva",
  "Common-Kit": "Kit",
  "Common-LastName": "Apellido",
  "Common-Latitude": "Latitud",
  "Common-LeadTime": "Lead Time",
  "Common-Length": "Largo",
  "Common-LengthWithPackaging": "Largo con empaque",
  "Common-Level": "Nivel",
  "Common-LicensePlate": "Matricula",
  "Common-Lines": "Lineas",
  "Common-List": "Lista",
  "Common-LimitGlobal": "Límite global",
  "Common-LimitMember": "Límite por miembro",
  "Common-LimitMemberUse": "Límite de uso por miembro",
  "Common-Load": "Cargar",
  "Common-Locality": "Localidad",
  "Common-Location": "Ubicación",
  "Common-Login": "Login",
  "Common-Longitude": "Longitud",
  "Common-Marketplace": "Marketplace",
  "Common-Margin": "Margen",
  "Common-Manual": "Manual",
  "Common-PurchasedBrands": "MARCAS COMPRADAS",
  "Common-MaxAge": "Edad máxima",
  "Common-MaximumPrice": "Precio máximo",
  "Common-MaximumStock": "Stock máximo",
  "Common-MaximumTicket": "Monto máximo ticket",
  "Common-MaxMustBeGreaterThanMin":
    "El mínimo de cuotas no puede ser mayor al máximo.",
  "Common-MaxPricePerArticle": "Precio máximo por artículo",
  "Common-Metrics": "Métricas",
  "Common-MinAge": "Edad mínima",
  "Common-MinimumMargin": "Margen mínimo",
  "Common-MinimumOrder": "Pedido mínimo",
  "Common-MinimumPrice": "Precio mínimo",
  "Common-MinimumStock": "Stock mínimo",
  "Common-MinimumTicket": "Monto mínimo ticket",
  "Common-Mobile": "Celular",
  "Common-Mode": "Modo",
  "Common-Model": "Modelo",
  "Common-Monday": "Lunes",
  "Common-Month": "Mes",
  "Common-Monthly": "Mensual",
  "Common-MonthsInProgram": "Meses desde que se unio al programa",
  "Common-MoreOptions": "Más opciones",
  "Common-MoreText": "{{quantity}} más...",
  "Common-Motive": "Motivo",
  "Common-Motorcycle": "Moto",
  "Common-mtcube": "mt3",
  "Common-mtsquare": "mt2",
  "Common-MustBeGreaterEqual0": "Debe ser un numero igual o mayor a 0",
  "Common-MyProfile": "Mi Perfil",
  "Common-Menu": "Menú",
  "Common-Name": "Nombre",
  "Common-NameNotEntered": "Debe ingresar un nombre",
  "Common-New": "Nueva",
  "Common-NewAcceptedPaymentMethod": "Nuevo medio de pago aceptado",
  "Common-NewArticle": "Nuevo artículo",
  "Common-NewArticleGroup": "Nuevo grupo de artículos",
  "Common-NewAttribute": "Nuevo atributo",
  "Common-NewBranchOffice": "Nueva tienda",
  "Common-NewBrand": "Nueva marca",
  "Common-NewClient": "Nuevo cliente",
  "Common-NewClientLevel": "Nuevo nivel de cliente",
  "Common-NewClientSegment": "Nuevo segmento",
  "Common-NewCluster": "Nuevo cluster",
  "Common-NewColour": "Nuevo color",
  "Common-NewCommercialDate": "Nueva Fecha Comercial",
  "Common-NewCompetitor": "Nuevo competidor",
  "Common-NewCurve": "Nueva curva",
  "Common-NewDeposit": "Nuevo depósito",
  "Common-NewOrder": "Nueva orden",
  "Common-NewPassword": "Nueva contraseña",
  "Common-NewPrice": "Nuevo precio",
  "Common-NewPricing": "Nuevo pricing",
  "Common-NewPricingType": "Nuevo tipo de pricing",
  "Common-NewPromotion": "Nueva promoción",
  "Common-NewPromotionType": "Nuevo tipo de promoción",
  "Common-NewPurchaseOrder": "Nueva orden de compra",
  "Common-NewPurchaseUnit": "Nueva unidad de compra",
  "Common-NewRepositionOrder": "Nueva orden de reposición",
  "Common-NewRewardType": "Nuevo tipo de incentivo",
  "Common-NewReward": "Nuevo incentivo",
  "Common-Campaign": "Campaña",
  "Common-CampaignPromotionOrRewardError":
    "Una campaña solo puede tener una promoción o un incentivo asociado, no ambos",
  "Common-EditCampaign": "Editar campaña",
  "Common-NewCampaign": "Nueva campaña",
  "Common-NewSalePoint": "Nuevo punto de venta",
  "Common-NewSeason": "Nueva Temporada",
  "Common-NewSku": "Nuevo sku",
  "Common-NewSupplierPaymentMethod": "Nuevo método de pago de proveedor",
  "Common-NewTicket": "Nuevo ticket",
  "Common-NewVehicle": "Nuevo vehículo",
  "Common-No": "No",
  "Common-NoArticleApplyingData":
    "No se esta aplicando a ningun artículo actualmente",
  "Common-NotCompleted": "No cumplida",
  "Common-Numbers": "Números",
  "Common-ObligatoryPaymentMethods": "Medios de pagos obligatorios",
  "Common-Observation": "Observación",
  "Common-Observations": "Observaciones",
  "Common-ObtainedResult": "Resultado obtenido",
  "Common-On": "En",
  "Common-OnWay": "En camino",
  "Common-OptimalStock": "Stock óptimo",
  "Common-Order": "Orden",
  "Common-OrdersFulfillment": "Cumplimientos de orden",
  "Common-OrganizationName": "Nombre de organización",
  "Common-OrganizationNameNotEntered": "Ingrese el nombre de su organización",
  "Common-OrganizationNameSpecialCharacters":
    "Ingrese un nombre sin caracteres especiales.",
  "Common-Origin": "Origen",
  "Common-OriginPlace": "Lugar de origen",
  "Common-OriginType": "Procedencia",
  "Common-OwnInventory": "Inventario propio",
  "Common-Parameter": "Parámetro",
  "Common-Parameters": "Parametrizaciones",
  "Common-Partial": "Parcial",
  "Common-Password": "Contraseña",
  "Common-PasswordLength": "Ingrese una contraseña de 8 caracteres",
  "Common-PasswordNotEntered": "Ingrese su contraseña",
  "Common-PaymentMethod": "Método de pago",
  "Common-PaymentMethods": "Metodos de pago",
  "Common-Pending": "Pendiente",
  "Common-Pendings": "Pendientes",
  "Common-Percentage": "Porcentaje",
  "Common-Period": "Periodo",
  "Common-PersonalInfo": "Datos Personales",
  "Common-Phone": "Teléfono",
  "Common-Photo": "Foto",
  "Common-Place": "Lugar",
  "Common-Points": "Puntos",
  "Common-PointsValue": "Valor en puntos",
  "Common-PointsMovement": "Movimiento de puntos",
  "Common-PointsBenefit": "Puntos del programa de beneficio",
  "Common-PointsLimit": "Límite de puntos del cliente",
  "Common-Movements": "Movimientos",
  "Common-PointsUntilLimit": "Puntos que faltan hasta llegar al límite",
  "Common-PossibleValues": "Valores posibles",
  "Common-PresentationM3": "Presentación",
  "Common-PresentationType": "Tipo presentación",
  "Common-Preview": "Vista previa",
  "Common-Price": "Precio",
  "Common-PriceDate": "Fecha del Precio",
  "Common-PriceVigency": "Vigencia del Precio",
  "Common-PriceRestriction": "Restricción de precio",
  "Common-Prices": "Precios",
  "Common-PriceVariation": "Variación de precio",
  "Common-Pricing": "Precio",
  "Common-PricingEvent": "Evento de pricing",
  "Common-Pricings": "Precios",
  "Common-PricingsTitle": "Fijación de precios",
  "Common-PricingsNoDate": "Precios sin agendar",
  "Common-PricingType": "Tipo de pricing",
  "Common-PricingTypes": "Tipos de pricing",
  "Common-Priority": "Prioridad",
  "Common-ProcessSuccessMessage": "Se ha procesado correctamente.",
  "Common-ProgramRegistrationDateBetween":
    "Fecha de registro en el programa entre",
  "Common-Promotion": "Promoción",
  "Common-Promotions": "Promociones",
  "Common-PromotionsUsed": "Promociones usadas",
  "Common-PromotionsNoDate": "Promociones sin agendar",
  "Common-PromotionType": "Tipo de promoción",
  "Common-PromotionTypes": "Tipos de promoción",
  "Common-PurchaseCount": "Cantidad de compras",
  "Common-PurchaseCountDays": "Compras en los últimos X días",
  "Common-PurchaseInfo": "Información de las compras",
  "Common-PurchaseOrder": "Orden de compra ",
  "Common-PurchaseOrders": "Ordenes de compras",
  "Common-PurchaseUnit": "Unidad de compra",
  "Common-PurchaseUnits": "Unidades de compra",
  "Common-Quantity": "Cantidad",
  "Common-QuantityApplications": "Cantidad de aplicaciones",
  "Common-QuantityArticles": "Cantidad Artículos",
  "Common-QuantityForPromotion": "Cantidad artículos a comprar",
  "Common-QuantityFrom": "Cantidad desde",
  "Common-QuantityInDraft": "Cantidad en actual borrador",
  "Common-QuantityMax": "Cantidad maxima a recibir: {{max}}",
  "Common-QuantityPerArticle": "Cantidad por artículo",
  "Common-QuantityPerBranchOffice": "Cantidad por tienda",
  "Common-QuantityPerClient": "Cantidad por cliente",
  "Common-QuantityTo": "Cantidad  hasta",
  "Common-QuantityWithDiscount": "Cantidad con descuento",
  "Common-Range": "Rango",
  "Common-Reason": "Razón",
  "Common-Recommendation": "Recomendación",
  "Common-ClientDiagnosis": "Diagnóstico del cliente",
  "Common-Receive": "Marcar recepción",
  "Common-ReceivedDate": "Fecha recepción",
  "Common-ReceivedQuantity": "Cantidad recibida",
  "Common-Reception": "Recepción",
  "Common-Recurrence": "Recurrencia",
  "Common-RecurrenceType": "Tipo de recurrencia",
  "Common-Register": "Registrar",
  "Common-RegisterDate": "Fecha de registro",
  "Common-RegisterNow": "Registra una ahora!",
  "Common-Repeat": "Repetir",
  "Common-Replenish": "Reponer",
  "Common-RepositionOrder": "Orden de reposición ",
  "Common-RepositionOrders": "Ordenes de reposición ",
  "Common-RequestDate": "Fecha Solicitud",
  "Common-Requests": "Solicitudes",
  "Common-RestrictedArticles": "Artículos restringidos",
  "Common-RestrictedCategories": "Categorias restringidas",
  "Common-RestrictedPaymentMethods": "Medios de pagos restringidos",
  "Common-Restrictions": "Restricciones",
  "Common-ReturnCount": "Cantidad de devoluciones",
  "Common-ReturnLogin": "Volver al inicio de sesión",
  "Common-ReviewDraft": "Revisión Orden de Resposición",
  "Common-ReviewDraftPurchaseOrder": "Revisión Orden de Compra",
  "Common-RewardTypes": "Tipos de incentivos",
  "Common-RewardType": "Tipo de incentivo",
  "Common-Reward": "Incentivo",
  "Common-Rewards": "Incentivos",
  "Common-Rol": "Rol",
  "Common-Roles": "Roles",
  "Common-RoomSpace": "Capacidad en salón",
  "Common-RoundingType": "Tipo de redondeo",
  "Common-Rule": "Regla",
  "Common-Rule1Description":
    "Crear ordenes de reposición para todas las tiendas con stock 0",
  "Common-Rule2Description":
    "Crear ordenes de reposición para todas las tiendas con stock por debajo del mínimo",
  "Common-RuleQuantity": "Valor para la regla",
  "Common-RulesSuccessMessage": "Operación exitosa",
  "Common-RuleType": "Tipo de regla",
  "Common-Rules": "Reglas",
  "Common-RunRules": "Correr reglas",
  "Common-SalePoint": "Punto de venta",
  "Common-SalesPoints": "Puntos de venta",
  "Common-SalesTickets": "Tickets de venta",
  "Common-SalesUnit": "Unidad venta",
  "Common-Saturday": "Sabado",
  "Common-Save": "Guardar",
  "Common-Schedule": "Agendar",
  "Common-Scheduled": "Agendada",
  "Common-Schedules": "Cronogramas",
  "Common-SearchArticleTextPlaceholder": "Buscar artículo por nombre",
  "Common-SearchBranchOfficeDepositTextPlaceholder":
    "Buscar tiendas/depositos por nombre",
  "Common-SearchBranchOfficeDestinyTextPlaceholder":
    "Buscar por tienda destino",
  "Common-SearchBranchOfficeOriginTextPlaceholder": "Buscar por tienda origen",
  "Common-SearchBranchOfficeTextPlaceholder": "Buscar tiendas por nombre",
  "Common-SearchBusinessUnitTextPlaceholder":
    "Buscar unidad de negocio por nombre",
  "Common-SearchByArticle": "Buscar por artículo",
  "Common-SearchByAttribute": "Buscar por atributo",
  "Common-SearchByBranchOffice": "Buscar por tienda",
  "Common-SearchByBrand": "Buscar por marca",
  "Common-SearchByCategory": "Buscar por categoría",
  "Common-SearchByCluster": "Buscar por cluster",
  "Common-SearchByCode": "Buscar por código",
  "Common-SearchByEmail": "Buscar por email",
  "Common-SearchByExternalId": "Buscar por id externo",
  "Common-SearchById": "Buscar por id",
  "Common-SearchByLevel": "Buscar por nivel",
  "Common-SearchByName": "Buscar por nombre",
  "Common-SearchByPrivilege": "Buscar por permiso",
  "Common-SearchByRol": "Buscar por rol",
  "Common-SearchBySkuName": "Buscar por nombre de sku",
  "Common-SearchByState": "Buscar por estado",
  "Common-SearchByType": "Buscar por tipo",
  "Common-SearchByValue": "Buscar por valor",
  "Common-SearchDepositTextPlaceholder": "Buscar depositos por nombre",
  "Common-SearchSkuPlaceholder": "Buscar sku por nombre",
  "Common-SearchSuppliersextPlaceholder": "Buscar proveedores por nombre",
  "Common-Season": "Temporada",
  "Common-Seasons": "Temporadas",
  "Common-Segments": "Segmentos",
  "Common-SelectArriveDate": "Selecciona la fecha estimada de arribo:",
  "Common-SelectBranchOfficeError": "Debes seleccionar una tienda para buscar.",
  "Common-SelectOneOrMore": "Selecciona uno o más",
  "Common-SelectAll": "Seleccionar todos",
  "Common-SelectSupplier": "Seleccione un proveedor",
  "Common-SelectDate": "Seleccione una fecha",
  "Common-Send": "Enviar",
  "Common-SendCampaign": "Enviar campaña",
  "Common-ChannelType": "Tipo de canal",
  "Common-SelectChannelType": "Seleccione el tipo de canal",
  "Common-ChannelTypeEmail": "Email",
  "Common-ChannelTypeSMS": "SMS",
  "Common-ChannelTypeWhatsApp": "WhatsApp",
  "Common-ScheduleSend": "Programar envío",
  "Common-SelectScheduleDateTime": "Seleccione fecha y hora de envío",
  "Common-ScheduledAtRequired":
    "Debe seleccionar una fecha y hora para programar el envío",
  "Common-ScheduledAtFuture":
    "La fecha y hora programadas deben ser en el futuro",
  "Common-Next": "Siguiente",
  "Common-MessageBody": "Mensaje",
  "Common-EnterMessageBody": "Escriba el mensaje que desea enviar",
  "Common-MessageBodyRequired":
    "Debe ingresar un mensaje para enviar la campaña",
  "Common-Template": "Plantilla",
  "Common-SelectTemplate": "Seleccionar plantilla",
  "Common-SelectTemplateRequired": "Debe seleccionar una plantilla",
  "Common-WhatsAppTemplates": "Plantillas Whatsapp",
  "Common-SaveDraft": "Guardar borrador",
  "Common-SaveAndSubmit": "Guardar y enviar a revisión",
  "Common-SubmitForReview": "Enviar a revisión",
  "Common-SubmitSuccessMessage": "Enviada a revisión correctamente",
  "Common-SubmitErrorMessage": "Error al enviar a revisión",
  "Common-CreateWhatsAppTemplate": "Crear plantilla de WhatsApp",
  "Common-CreateWhatsAppTemplateHelp":
    "Cree un borrador o envíe la plantilla a revisión para aprobación.",
  "Common-SaveDraftSuccess": "Borrador guardado correctamente",
  "Common-SaveAndSubmitSuccess": "Plantilla creada y enviada a revisión",
  "Common-GeneralInformation": "Información general",
  "Common-Content": "Contenido",
  "Common-TemplateName": "Nombre de plantilla",
  "Common-TemplateNamePlaceholder": "ej. pedido_entrega",
  "Common-TemplateNameRule": "Solo se permiten minúsculas, números y guiones bajos.",
  "Common-TemplateBodyPlaceholder": "Escriba el contenido del mensaje",
  "Common-PreviewEmpty": "La vista previa aparecerá aquí.",
  "Common-Year": "Año",
  "Common-YourPhoneNumber": "Tu número de teléfono",
  "Common-TemplatePreview": "Vista previa de plantilla",
  "Common-EditWhatsAppTemplate": "Editar plantilla de WhatsApp",
  "Common-ConfirmSendToNumbers_one":
    "¿Está seguro que quiere enviar el mensaje a {{count}} número?",
  "Common-ConfirmSendToNumbers_other":
    "¿Está seguro que quiere enviar el mensaje a {{count}} números?",
  "Common-ViewSends": "Ver envíos",
  "Common-CampaignSentsTitle": "Envíos de campaña",
  "Common-TrackingId": "ID de tracking",
  "Common-SelectClientsToSend": "Seleccione al menos un cliente para enviar",
  "Common-CampaignSentSuccess": "Campaña enviada correctamente",
  "Common-CampaignSentError": "Error al enviar la campaña",
  "Common-SelectedCount": "{{count}} seleccionados",
  "Common-ErrorLoadingData": "Error al cargar los datos",
  "Common-NoPermission": "No tiene permiso para realizar esta acción",
  "Common-Sent": "Enviada",
  "Common-TotalRecipients": "Total de destinatarios",
  "Common-Sex": "Sexo",
  "Common-ShoppingCenter": "Centro comercial",
  "Common-Size": "Talle",
  "Common-SizeEnd": "Talle fin",
  "Common-SizeStart": "Talle Inicio",
  "Common-Sku": "Sku",
  "Common-Skus": "Skus",
  "Common-PurchasedSkus": "SKUS COMPRADOS",
  "Common-Spent": "Gastados",
  "Common-SpentAverage": "Gasto promedio",
  "Common-Start": "Inicio",
  "Common-StartDate": "Fecha de inicio",
  "Common-StartDateBirthdate": "Fecha nacimiento desde",
  "Common-StartDateRegister": "Fecha registro desde",
  "Common-StartTime": "Hora de inicio",
  "Common-Progress": "Progreso",
  "Common-Results": "Resultados",
  "Common-Started": "Iniciado",
  "Common-Finished": "Finalizado",
  "Common-Status": "Estado",
  "Common-MessageStatusDelivered": "Entregado",
  "Common-MessageStatusRead": "Leído",
  "Common-MessageStatusSent": "Enviado",
  "Common-MessageStatusQueued": "En cola",
  "Common-MessageStatusFailed": "Fallido",
  "Common-MessageStatusUndelivered": "No entregado",
  "Common-Stock": "Stock",
  "Common-StockAdjustments": "Ajustes de Stock",
  "Common-StockBetween": "Stock entre",
  "Common-StockBreaks": "Quiebres de stock",
  "Common-StockCurrent": "Stock actual",
  "Common-StockInTransit": "En camino",
  "Common-StockMovements": "Movimientos de Stock",
  "Common-StorageCostPerUnit": "Costo de almacenamiento por unidad",
  "Common-StorageUnit": "Unidad almacenamiento",
  "Common-Strategy": "Estrategia",
  "Common-SubTotal": "Subtotal",
  "Common-SuccessMessage": "Se ha realizado correctamente",
  "Common-Suggested": "Sugerida",
  "Common-Suggestion": "Sugerencia",
  "Common-Sunday": "Domingo",
  "Common-Supplier": "Proveedor",
  "Common-Suppliers": "Proveedores",
  "Common-Suppliers-Payment-Methods": "Métodos de pago de proveedores",
  "Common-Supply": "Abastecer",
  "Common-TargetMargin": "Margen objetivo",
  "Common-Telephone": "Teléfono",
  "Common-TermsConditions": "Términos y condiciones",
  "Common-StoreOnlyContactValidation": "Guardar solo validación de contacto",
  "Common-StoreOnlyContactValidationTooltip":
    "Si está activo, teléfono, celular y email se validan pero no se guardan en la base de datos.",
  "Common-ValidationStatusValid": "Válido",
  "Common-ValidationStatusInvalid": "Inválido",
  "Common-ValidationStatusNotChecked": "Sin validar",
  "Common-ThisOrder": "Esta orden",
  "Common-Thursday": "Jueves",
  "Common-Ticket": "Ticket",
  "Common-TicketAverage": "Promedio ticket",
  "Common-TicketAverageMax": "Ticket promedio máx",
  "Common-TicketAverageMin": "Ticket promedio mín",
  "Common-Tickets": "Tickets",
  "Common-Time": "Hora",
  "Common-TimeLine": "Timeline",
  "Common-Today": "Hoy",
  "Common-Total": "Total",
  "Common-TotalAccumulationUnits": "Total unidades de acumulación",
  "Common-TotalClients": "Total de clientes",
  "Common-TotalFrom": "Total desde",
  "Common-TotalGeneratedPoints": "Total de puntos generados",
  "Common-TotalReceived": "Recepción total",
  "Common-TotalReturns": "Total de devoluciones",
  "Common-TotalSpent": "Total gastado",
  "Common-TotalTo": "Total hasta",
  "Common-TransactionsAverage": "Número promedio de transacciones",
  "Common-Transfer": "Traslado",
  "Common-Transmitter": "Emisor",
  "Common-Truck": "Camion",
  "Common-Tuesday": "Martes",
  "Common-Type": "Tipo",
  "Common-UnitPrice": "Precio unitario",
  "Common-OptimalPrice": "Precio óptimo",
  "Common-PriceCompetition": "Precio competencia",
  "Common-Units": "Unidades",
  "Common-Url": "Url",
  "Common-UrlNotEntered": "Ingrese una url valida",
  "Common-Users": "Usuarios",
  "Common-AdditionalInformation": "Información adicional",
  "Common-Associations": "Asociaciones",
  "Common-Valid": "Validez",
  "Common-Validity": "Validez",
  "Common-ValidFrom": "Valido desde",
  "Common-ValidTo": "Valido hasta",
  "Common-ValidityStartDate": "Fecha inicio vigencia",
  "Common-ValidityEndDate": "Fecha fin vigencia",
  "Common-ClearFilters": "Limpiar filtros",
  "Common-Value": "Valor",
  "Common-ValuedInventory": "Inventario Valorizado",
  "Common-Van": "Camioneta",
  "Common-VariationNotAvailable": "N/D",
  "Common-Variety": "Variedad",
  "Common-Vehicle": "Vehículo",
  "Common-Vehicles": "Vehículos",
  "Common-View": "Ver",
  "Common-ViewSummary": "Ver resumen",
  "Common-Volumen": "Volumen",
  "Common-WebDescription": "Descripción Web",
  "Common-Website": "Sitio web",
  "Common-Wednesday": "Miércoles",
  "Common-Warnings": "Advertencias",
  "Common-Week": "Semana",
  "Common-Weekly": "Semanal",
  "Common-Weight": "Peso",
  "Common-WeightWithPackaging": "Peso con empaque",
  "Common-WhoReceived": "Recibido por",
  "Common-Width": "Ancho",
  "Common-WidthWithPackaging": "Ancho con empaque",
  "Common-XDays": "X días",
  "Common-Yes": "Si",
  "Common-CurrentMargin": "Margen actual",
  "Common-CurrentPrice": "Precio actual",
  "Common-FutureDate": "Fecha futura",
  "Common-FutureMargin": "Margen futuro",
  "Common-FuturePrice": "Precio futuro",
  "Common-PromotionalMargin": "Margen promocional",
  "Common-PromotionalPrice": "Precio promocional",
  "Common-SearchByArticleGroup": "Buscar por grupo de artículos",
  "Common-SuggestedMargin": "Margen sugerido",
  "Common-SuggestedPrice": "Precio sugerido",
  "Common-ViewArticle": "Ver artículo",
  "Common-ViewPricing": "Ver pricing",
  "EditArticle-Supplier": "Editar proveedor",
  "EditSupplier-Contact": "Editar contacto",
  "Error-CommonError": "Hubo un error, intentalo nuevamente.",
  "Error-IncorrectCredentials": "Las credenciales no son correctas",
  "ForgotPassword-Description":
    "Ingrese su correo electronico y le enviaremos un enlace.",
  "ForgotPassword-SendEmail": "Enviar enlace de acceso",
  "ForgotPassword-SendErrorMessage":
    "Hubo un problema al enviar el correo, intentelo en un momento",
  "ForgotPassword-SendSuccesMessage":
    "Se ha enviado correctamente. Revise su casilla de correo electronico.",
  "ForgotPassword-Title": "¿Olvidó su contraseña?",
  "ForgotPassword-SuccessTitle": "¡Correo enviado!",
  "ForgotPassword-SuccessMessage":
    "Hemos enviado un enlace de recuperación a tu correo.",
  "ForgotPassword-CheckEmailMessage":
    "Revisa tu bandeja de entrada y sigue las instrucciones para restablecer tu contraseña.",
  "FormatDate-ddmmyy": "dd/mm/yyyy",
  "LoginForm-NotFoundOrganization": "No existe una organización con ese nombre",
  "AdminShell-SelectOrganizationTitle": "Seleccioná una organización",
  "AdminShell-SelectOrganizationDescription":
    "La organización admin es solo de control. Para ver menús y trabajar con datos, elegí una organización real desde el selector superior.",
  "AdminNavigation-Overview": "Inicio de administración",
  "AdminNavigation-Organizations": "Clientes",
  "AdminNavigation-AdminUsers": "Usuarios de Admin",
  "AdminOverview-AdminOrganization": "Organización Admin",
  "AdminOverview-Title": "Centro de administración global",
  "AdminOverview-Description":
    "Estás trabajando en la organización Admin. Desde aquí podés administrar configuraciones globales y los usuarios propios de Admin sin entrar a una organización cliente.",
  "AdminOverview-NoOrganizationTitle": "No hay una organización cliente seleccionada",
  "AdminOverview-NoOrganizationDescription":
    "Este es el estado seguro de administración global. Para gestionar catálogo, tiendas, clientes u otros datos de una organización, seleccionala en el encabezado.",
  "AdminOverview-SelectorHint":
    "Cuando selecciones una organización, el encabezado indicará claramente cuál estás gestionando y podrás volver a Admin desde el mismo lugar.",
  "AdminOverview-OrganizationsTitle": "Clientes",
  "AdminOverview-OrganizationsDescription":
    "Configurá la validación de clientes y ejecutá migraciones de datos de contacto por organización.",
  "AdminOverview-OrganizationsAction": "Administrar clientes",
  "AdminOverview-UsersTitle": "Usuarios de la organización Admin",
  "AdminOverview-UsersDescription":
    "Creá y administrá los usuarios de Admin. Todos tienen acceso completo automáticamente.",
  "AdminOverview-UsersAction": "Administrar usuarios de Admin",
  "AdminOrganizations-Title": "Clientes",
  "AdminOrganizations-Description":
    "Configuraciones y operaciones globales aplicadas a las organizaciones de Bright Market.",
  "AdminUsers-Title": "Usuarios de la organización Admin",
  "AdminUsers-Description":
    "Estos usuarios pertenecen exclusivamente a la organización Admin y tienen acceso completo.",
  "NavBar-AdminOrganization": "Organización Admin · Administración global",
  "NavBar-ManagingOrganization": "Gestionando: {{organization}}",
  "NavBar-ActiveOrganizationLabel": "Organización activa",
  "NavBar-AdminModeLabel": "Administración global",
  "NavBar-SelectOrganization": "Seleccionar organización cliente",
  "NavBar-BackToAdmin": "Volver a Admin",
  "NavBar-OrganizationSwitchError":
    "No se pudo cambiar la organización. Intentá nuevamente.",
  "NavBar-AcceptedPaymentMethods": "Medios de pagos aceptados",
  "NavBar-Admin": "Admin",
  "NavBar-ArticleGroups": "Grupos de Artículos",
  "NavBar-Articles": "Artículos",
  "NavBar-Assertment": "Assertment",
  "NavBar-Attributes": "Atributos",
  "NavBar-BranchOffices": "Tiendas",
  "NavBar-Brands": "Marcas",
  "NavBar-Calendar": "Calendario",
  "NavBar-Campaigns": "Campañas",
  "NavBar-Catalogue": "Catalogo",
  "NavBar-Categories": "Categorías",
  "NavBar-Channels": "Canales",
  "NavBar-Clients": "Clientes",
  "NavBar-ClientSegments": "Segmentos de clientes",
  "NavBar-ClientLevels": "Niveles de clientes",
  "NavBar-Clusters": "Clusters",
  "NavBar-Colours": "Colores",
  "NavBar-Company": "Empresa",
  "NavBar-ClientValidationStats": "Validación de clientes",
  "NavBar-Wholesalers": "Mayoristas",
  "NavBar-CompanySettings": "Configuración",
  "NavBar-Competitors": "Competidores",
  "NavBar-Curves": "Curvas",
  "NavBar-Dashboard": "Dashboard",
  "NavBar-Deposits": "Depósitos",
  "NavBar-Fidelity": "Fidelidad",
  "NavBar-Home": "Home",
  "NavBar-Logout": "Cerrar sesión",
  "NavBar-Versions": "Versiones",
  "NavBar-VersionsLoading": "Cargando versiones...",
  "NavBar-VersionApi": "API",
  "NavBar-VersionWeb": "Web",
  "NavBar-VersionDataScience": "Data science",
  "NavBar-VersionDataScienceShort": "Data science",
  "NavBar-Loyalty": "Fidelidad",
  "NavBar-Management": "Gestion",
  "NavBar-Parameter": "Parametros",
  "NavBar-Parameters": "Parametrizaciones",
  "NavBar-Pricings": "Precios",
  "NavBar-PricingTypes": "Tipos de pricing",
  "NavBar-Promotions": "Promociones",
  "NavBar-CommercialIntelligence": "Inteligencia Comercial",
  "NavBar-Opportunities": "Oportunidades",
  "NavBar-Incentives": "Incentivos",
  "NavBar-ActivationActions": "Acciones de activación",
  "NavBar-Configuration": "Configuración",
  "NavBar-PromotionTypes": "Tipos de promociones",
  "NavBar-PurchaseOrders": "Órdenes de Compra",
  "NavBar-Statistics": "Estadísticas",
  "NavBar-Reports": "Reportes",
  "NavBar-RepositionOrders": "Órdenes de Reposición",
  "NavBar-Requests": "Solicitudes",
  "NavBar-Roles": "Roles",
  "NavBar-SearchInput": "Busca lo que quieras...",
  "NavBar-Shopping": "Compras",
  "NavBar-SimilarArticles": "Artículos similares",
  "NavBar-StockBreaks": "Quiebres de stock",
  "NavBar-Suppliers": "Proveedores",
  "NavBar-Surtido": "Surtido",
  "NavBar-UsersAndRoles": "Usuarios y Roles",
  "NavBar-Vehicles": "Vehículos",
  "NavBar-CommercialAnalysis": "Análisis Comercial",
  "NavBar-BrightPulse": "Bright Pulse",
  "NavBar-BrightActions": "Bright Actions",
  "NavBar-BrightClub": "Bright Club",
  "NavBar-CommercialSummary": "Resumen Comercial",
  "NavBar-DailyControl": "Control diario de venta",
  "NavBar-CategoryAnalysis": "Análisis por Categorías",
  "NavBar-ProductAnalysis": "Análisis por Productos",
  "NavBar-BrandAnalysis": "Análisis por Marcas",
  "NavBar-ChannelAnalysis": "Análisis por Canales",
  "NavBar-StoreAnalysis": "Análisis por Tiendas",
  "NavBar-CommercialDateAnalysis": "Análisis por Fechas Comerciales",
  "NavBar-ProductMixAnalysis": "Análisis por Mix de Producto",
  "NavBar-ClientAnalysis": "Análisis por Clientes",
  "NavBar-PromotionAnalysis": "Análisis por Promociones",
  "NavBar-CampaignAnalysis": "Análisis por Campañas",
  "NavBar-LoyaltyProgramAnalysis": "Análisis del programa",
  "NavBar-WholesaleAnalysis": "Análisis venta mayorista",
  "NavBar-GenerateRecommendations": "Generar recomendaciones",
  "NavBar-RecommendationsGenerating": "Generando...",
  "NavBar-GenerateRecommendationsConfirm":
    "Se van a limpiar las sugerencias actuales y se ejecutará una nueva generación global. ¿Querés continuar?",
  "NavBar-GenerateRecommendationsConfirmOk": "Generar",
  "NavBar-CancelRecommendationsTitle": "Cancelar generación",
  "NavBar-CancelRecommendationsWarning":
    "Se intentará detener la ejecución en curso. Cancelarla puede dejar datos sugeridos en un estado inconsistente o parcialmente regenerado. ¿Querés continuar?",
  "NavBar-CancelRecommendationsConfirmOk": "Cancelar generación",
  "RecommendationRun-Title": "Generación de recomendaciones",
  "RecommendationRun-Preparing": "Preparando ejecución",
  "RecommendationRun-StepDetail": "Detalle",
  "RecommendationRun-InProgress": "En progreso",
  "RecommendationRun-Finished": "Finalizado",
  "RecommendationRun-Failed": "Con error",
  "RecommendationRun-Cancelled": "Cancelado",
  "RecommendationRun-Segments": "Segmentos",
  "RecommendationRun-CommercialOpportunities": "Oportunidades",
  "RecommendationRun-Rewards": "Incentivos",
  "RecommendationRun-Promotions": "Promociones",
  "RecommendationRun-Actions": "Acciones",
  "RecommendationRun-Cancel": "Cancelar",
  "RecommendationRun-ViewHistory": "Ver historial",
  "RecommendationRun-ShowMore": "ver más",
  "RecommendationRunsHistory-Title": "Historial de recomendaciones",
  "RecommendationRunsHistory-Description":
    "Acá podés revisar todas las ejecuciones de recomendaciones de la organización, su progreso final y los resultados generados.",
  "RecommendationRunsHistory-Empty":
    "Todavía no hay ejecuciones de recomendaciones registradas.",
  "RecommendationRunsHistory-LoadError":
    "No se pudo cargar el historial de recomendaciones.",
  "RecommendationRunsHistory-Step": "Etapa",
  "RecommendationRunsHistory-StepDetail": "Detalle de etapa",
  "RecommendationRunsHistory-StepPending": "Preparando ejecución",
  "RecommendationRunsHistory-Progress": "Progreso",
  "RecommendationRunsHistory-Segments": "Segmentos",
  "RecommendationRunsHistory-CommercialOpportunities": "Oportunidades",
  "RecommendationRunsHistory-Rewards": "Incentivos",
  "RecommendationRunsHistory-Promotions": "Promociones",
  "RecommendationRunsHistory-Actions": "Acciones",
  "RecommendationRunsHistory-Results": "Resultados",
  "RecommendationRunsHistory-MetricShort-Segments": "Seg.",
  "RecommendationRunsHistory-MetricShort-Opportunities": "Oport.",
  "RecommendationRunsHistory-MetricShort-Rewards": "Inc.",
  "RecommendationRunsHistory-MetricShort-Promotions": "Promo.",
  "RecommendationRunsHistory-MetricShort-Actions": "Acc.",
  "RecommendationRunsHistory-CreatedAt": "Creado",
  "RecommendationRunsHistory-StartedAt": "Iniciado",
  "RecommendationRunsHistory-FinishedAt": "Finalizado",
  "RecommendationRunsHistory-Time": "Horario",
  "RecommendationRunsHistory-StartedAtShort": "Inicio",
  "RecommendationRunsHistory-FinishedAtShort": "Fin",
  "RecommendationRunsHistory-Error": "Mensaje",
  "RecommendationRunsHistory-Status-Pending": "Pendiente",
  "RecommendationRunsHistory-Status-Running": "En progreso",
  "RecommendationRunsHistory-Status-Success": "Finalizado",
  "RecommendationRunsHistory-Status-Failed": "Con error",
  "RecommendationRunsHistory-Status-Cancelled": "Cancelado",
  "NewSupplier-ContactEmail": "Email",
  "NewSupplier-ContactEmailNotEntered": "Ingrese el email de contacto",
  "NewSupplier-ContactName": "Nombre",
  "NewSupplier-ContactNameNotEntered": "Ingrese el nombre de contacto",
  "NewSupplier-ContactNumber": "Número",
  "NewSupplier-ContactNumberNotEntered": "Ingrese el número de contacto",
  "NewSupplier-Contacts": "Contactos",
  "NewSupplier-CreateSupplierSucessMessage":
    "Se ha creado un nuevo proveedor correctamente.",
  "NewSupplier-DeliveryTerm": "Lead Time",
  "NewSupplier-MinimumOrder": "Pedido mínimo",
  "NewSupplier-NewSupplier": "Nuevo proveedor",
  "NewSupplier-PaymentMethod": "Método de pago",
  "NewSupplier-Principal": "Principal",
  "NewSupplier-PurchaseUnit": "Unidad de compra",
  "NewSupplierPaymentMethod-PaymentDeadline": "Plazo de pago",
  "NewSupplierPaymentMethod-PaymentDeadlineError":
    "Debe ingresar un número de días",
  "NotFound-Title": "Esta página no está disponible",
  "Roles-CreateErrorMessage":
    "Hubo un problema, intentelo otra vez en un momento.",
  "Roles-CreateSuccesMessage": "Se ha creado el rol correctamente.",
  "Roles-DeleteConfirm": "¿Está seguro que quiere eliminar el rol?",
  "Roles-DeleteRolErrorMessage":
    "Hubo un error al eliminar, intentelo en un momento.",
  "Roles-DeleteRolSuccessMessage": "Se ha elminado el rol correctamente.",
  "Roles-Description": "Descripción",
  "Roles-EditRol": "Editar rol",
  "Roles-EditRolErrorMessage":
    "Hubo un error al editar, intentelo en un momento.",
  "Roles-EditSuccesMessage": "Se ha editado el rol correctamente.",
  "Roles-NewRol": "Nuevo rol",
  "Roles-Privileges": "Permisos",
  "Roles-PrivilegesNotEntered": "Debe seleccionar al menos un permiso",
  "Roles-Rol": "Rol",
  "Roles-RolesSettings": "Configuración de roles y permisos",
  "Roles-SelectPrivileges": "Selecciona uno o más",
  "SimilarArticles-Column-Image": "Imagen",
  "SimilarArticles-Column-Sales": "Unidades vendidas (30 días)",
  "SimilarArticles-Disabled": "La organización no tiene un índice de similitud activo, por lo que no se pueden buscar artículos similares.",
  "SimilarArticles-EmptyResults": "No se encontraron artículos similares para este SKU",
  "SimilarArticles-Error": "No se pudieron obtener los artículos similares. Intentá nuevamente.",
  "SimilarArticles-OriginalArticle": "Artículo original",
  "SimilarArticles-SearchSkuPlaceholder": "Buscar SKU por código o nombre",
  "SimilarArticles-SelectSku": "Seleccioná un SKU para ver sus artículos similares",
  "StoreAnalysis-ActiveAlerts": "Alertas activas",
  "StoreAnalysis-Alert-AvgTicketDecline": "Ticket promedio deteriorado vs año anterior",
  "StoreAnalysis-Alert-LowTicketActivity": "Caída relevante en cantidad de tickets",
  "StoreAnalysis-Alert-MarginDecline": "Margen deteriorado respecto al año anterior",
  "StoreAnalysis-Alert-Overstock": "Exceso de cobertura de stock en tienda",
  "StoreAnalysis-Alert-PromoDependency": "Tienda altamente dependiente de promociones",
  "StoreAnalysis-Alert-SalesDropVsLY": "Caída sostenida de venta vs año anterior",
  "StoreAnalysis-Alert-SustainedDecline": "Tienda con performance negativa sostenida",
  "StoreAnalysis-Alert-Top3CategoryConcentration":
    "La venta de la tienda está concentrada en pocas categorías",
  "StoreAnalysis-Alerts": "Alertas",
  "StoreAnalysis-Article": "Artículo",
  "StoreAnalysis-AvgTicket": "Ticket promedio",
  "StoreAnalysis-BackToStores": "Volver a tiendas",
  "StoreAnalysis-BasketSize": "Tamaño de cesta",
  "StoreAnalysis-Brand": "Marca",
  "StoreAnalysis-Category": "Categoría",
  "StoreAnalysis-Clients": "Clientes",
  "StoreAnalysis-CompareStores": "Comparar tiendas",
  "StoreAnalysis-DaysWithoutStock": "Días sin stock",
  "StoreAnalysis-DetectedDrivers": "Drivers detectados",
  "StoreAnalysis-Driver-CategoryDecline": "{{category}} explica el {{pct}}% de la caída de la tienda.",
  "StoreAnalysis-Driver-CategoryGrowth":
    "{{category}} explica el {{pct}}% del crecimiento de la tienda.",
  "StoreAnalysis-Driver-DominantBrand": "{{brand}} concentra el {{pct}}% de la venta de la tienda.",
  "StoreAnalysis-Driver-DominantProduct":
    "{{product}} concentra el {{pct}}% de la venta de la tienda.",
  "StoreAnalysis-ExclusiveClients": "Clientes exclusivos",
  "StoreAnalysis-GeoLocation": "Ubicación geográfica",
  "StoreAnalysis-Global": "Global",
  "StoreAnalysis-GlobalStock": "Stock global",
  "StoreAnalysis-GrossSales": "Venta bruta",
  "StoreAnalysis-Growth": "Crecimiento",
  "StoreAnalysis-Historical": "Histórico",
  "StoreAnalysis-Insight-CategoryShareGain": "{{category}} gana relevancia dentro de la tienda",
  "StoreAnalysis-Insight-DeclineCategories":
    "La caída se explica principalmente por {{category1}} y {{category2}}",
  "StoreAnalysis-Insight-GrowthCategories":
    "El crecimiento se concentra en {{category1}} y {{category2}}",
  "StoreAnalysis-Insight-PromoDependency": "Más de la mitad de la venta ocurre bajo promociones",
  "StoreAnalysis-Insight-PromoDependencyIncrease": "La tienda incrementa su dependencia promocional",
  "StoreAnalysis-Insight-SalesConcentration":
    "{{count}} categorías concentran el {{pct}}% de la venta total",
  "StoreAnalysis-Insights": "Insights",
  "StoreAnalysis-Last180Days": "Últimos 180 días",
  "StoreAnalysis-Last30Days": "Últimos 30 días",
  "StoreAnalysis-Last60Days": "Últimos 60 días",
  "StoreAnalysis-Last90Days": "Últimos 90 días",
  "StoreAnalysis-Location": "Ubicación",
  "StoreAnalysis-Margin": "Margen",
  "StoreAnalysis-Month": "Mes",
  "StoreAnalysis-NewClientsByMonth": "Clientes nuevos por mes",
  "StoreAnalysis-NoAlertsDetected": "Sin alertas activas en este período.",
  "StoreAnalysis-NoDriversDetected": "Sin drivers detectados en este período.",
  "StoreAnalysis-NoInsightsDetected": "Sin insights detectados en este período.",
  "StoreAnalysis-NoSales": "Sin ventas en el período",
  "StoreAnalysis-NoStockouts": "Sin quiebres",
  "StoreAnalysis-NoStores": "Sin tiendas",
  "StoreAnalysis-NotFound": "Tienda no encontrada",
  "StoreAnalysis-Period": "Período",
  "StoreAnalysis-PurchaseFrequency": "Frecuencia compra",
  "StoreAnalysis-Quantity": "Cantidad",
  "StoreAnalysis-RecurringClients": "Clientes recurrentes",
  "StoreAnalysis-SalesEvolution": "Evolución de ventas",
  "StoreAnalysis-SalesMix": "Mix de ventas",
  "StoreAnalysis-Search": "Buscar",
  "StoreAnalysis-SelectedStores": "{{count}} tiendas seleccionadas",
  "StoreAnalysis-Sort": "Orden",
  "StoreAnalysis-SortName": "Nombre",
  "StoreAnalysis-SortPerformance": "Performance",
  "StoreAnalysis-Stockouts": "Quiebres de stock",
  "StoreAnalysis-Store": "Tienda",
  "StoreAnalysis-StoreClients": "Clientes de la tienda",
  "StoreAnalysis-StoreSalesPct": "% venta tienda",
  "StoreAnalysis-Stores": "Tiendas",
  "StoreAnalysis-Supply": "Abastecimiento",
  "StoreAnalysis-Tickets": "Tickets",
  "StoreAnalysis-TopArticles": "Top artículos",
  "StoreAnalysis-TopBrands": "Top marcas",
  "StoreAnalysis-TopCategories": "Top categorías",
  "StoreAnalysis-UniqueClients": "Clientes únicos",
  "StoreAnalysis-Units": "Unidades",
  "StoreAnalysis-View": "Vista",
  "StoreAnalysis-ViewComparison": "Ver comparación",
  "Suppliers-CatalogueLink": "Link de catalogo",
  "Suppliers-CataloguePdf": "Catálogo en PDF",
  "Suppliers-Payment-Methods-deadlines": "Plazo de pagos (días)",
  "Ticket-EmptyTitle": "No hay tickets",
  "Ticket-EmptyDescription": "No se encontraron tickets en el sistema.",
  "Ticket-EmptyFilterTitle": "No se encontraron resultados",
  "Ticket-EmptyFilterDescription":
    "No hay tickets que coincidan con los filtros aplicados.",
  "Reward-EmptyTitle": "No hay incentivos",
  "Reward-EmptyDescription": "No se encontraron incentivos en el sistema.",
  "Reward-EmptyFilterTitle": "No se encontraron resultados",
  "Reward-EmptyFilterDescription":
    "No hay incentivos que coincidan con los filtros aplicados.",
  "Reward-EmptyButton": "Crear primer incentivo",
  "Incentivo-EmptyTitle": "No hay incentivos",
  "Incentivo-EmptyDescription": "No se encontraron incentivos en el sistema.",
  "Incentivo-EmptyFilterTitle": "No se encontraron resultados",
  "Incentivo-EmptyFilterDescription":
    "No hay incentivos que coincidan con los filtros aplicados.",
  "Incentivo-EmptyButton": "Crear nuevo incentivo",
  "Suppliers-Suppliers": "Proveedores",
  "Users-AddUser": "Agregar nuevo usuario",
  "Users-CreateErrorMessage":
    "Hubo un problema, intentelo otra vez en un momento.",
  "Users-CreateSuccesMessage": "Se ha creado el usuario correctamente.",
  "Users-Edit": "Editar usuario",
  "Users-EditRol": "Editar roles de usuario",
  "Users-NewUser": "Nuevo usuario",
  "Users-Rol": "Rol",
  "Users-RolNotEntered": "Seleccione por lo menos un rol",
  "Users-UsersSettings": "Configuración de usuarios",
  "ValidateEmail-NewPasswordDescription": "Ingrese su nueva contraseña.",
  "ValidateEmail-NewPasswordTitle": "Elija una contraseña",
  "ValidateEmail-UserConfirmed":
    "Usuario confirmado, click aquí para ir al inicio de sesión",
  "Common-PriceSimulator": "Simulador de precios",
  "Common-PricingDetail": "Detalle de precios",
  "Common-ArticleConfiguration": "Configuración del artículo",
  "Common-CurrentInformation": "Información actual",
  "Common-InPromotion": "En promoción",
  "Common-AverageMargin": "Margen promedio",
  "Common-AveragePrice": "Precio promedio",
  "Common-TimeInPromotion": "Tiempo en promoción",
  "Common-TotalRevenue": "Ingresos totales",
  "Common-ActivePromotions": "Promociones activas",
  "Common-Discount": "Descuento",
  "Common-PriceHistory": "Historial de precios",
  "Common-PriceEvolution": "Evolución de precios",
  "Common-SalesImpact": "Impacto en ventas",
  "Common-Note": "Nota",
  "Common-SalesImpactNote":
    "El análisis de impacto en ventas muestra la correlación entre cambios de precio y volumen de ventas.",
  "Common-BestPerformingPrice": "Precio con mejor rendimiento",
  "Common-HighestSales": "Mayores ventas",
  "Common-PriceElasticity": "Elasticidad de precio",
  "Common-Elasticity": "Elasticidad",
  "Common-PriceOptimizationRecommendations":
    "Recomendaciones de optimización de precios",
  "Common-ExpectedMargin": "Margen esperado",
  "Common-ElasticDemand": "Demanda elástica",
  "Common-InelasticDemand": "Demanda inelástica",
  "Common-RecommendPriceIncrease":
    "Se recomienda aumentar el precio para maximizar el margen",
  "Common-RecommendPriceDecrease":
    "Se recomienda reducir el precio para aumentar las ventas",
  "Common-Sales": "Ventas",
  "Common-KPIs": "KPIs",
  "Common-PromotionEfficiency": "Eficiencia de la Promoción",
  "Common-ProjectedSales": "Ventas Proyectadas",
  "Common-ActualSales": "Ventas Actuales",
  "Common-ProjectedProfit": "Ganancia Proyectada",
  "Common-ActualProfit": "Ganancia Actual",
  "Common-ProjectedTotalCost": "Costo Total Proyectado",
  "Common-ActualTotalCost": "Costo Total Actual",
  "Common-ProjectedMarginPerSale": "Margen por Venta Proyectado",
  "Common-ActualMarginPerSale": "Margen por Venta Actual",
  "Common-EfficiencyPercentage": "% de Eficiencia",
  "Common-RecommendedPromotion": "Promoción Recomendada",
  "Common-OptimizablePromotion": "Promoción Optimizable",
  "Common-NotRecommendedPromotion": "Promoción No Recomendada",
  "Common-ConflictingPromotions": "Promociones en Conflicto",
  "Common-SimilarPromotionsHistory": "Histórico de Promociones Similares",
  "Common-SalesWithPromotion": "Ventas con Promoción",
  "Common-InteractionsWithOtherPromotions":
    "Interacciones con Otras Promociones",
  "Common-Conflict": "Conflicto",
  "Common-Impact": "Impacto",
  "Common-EstimatedReach": "Alcance estimado",
  "Common-EstimatedImpact": "Impacto estimado ($)",
  "Common-EstimatedCost": "Costo estimado ($)",
  "Common-EstimatedROI": "ROI estimado",
  "Common-EstimatedAudience": "Audiencia estimada",
  "Campaigns-AssignedClients": "Clientes asignados",
  "Campaigns-AssignedClientsTooltip":
    "Cantidad real de clientes vinculados a la campaña.",
  "Campaigns-EstimatedAudienceTooltip":
    "Estimación manual de alcance cargada en la campaña; puede diferir de los clientes asignados.",
  "Common-IncrementalSales": "Venta incremental ($)",
  "Common-AccumulatedImpact": "Impacto acumulado ($)",
  "Common-AccumulatedCost": "Costo acumulado ($)",
  "Common-HistoricalROI": "ROI histórico",
  "Common-CampaignTypeIncentive": "Incentivo",
  "Common-CampaignTypePromotion": "Promoción",
  "Common-CampaignTypeSegment": "Segmento",
  "Common-CampaignTypeActivation": "Activación",
  "Common-CampaignStatusFuture": "Futura",
  "Common-CampaignStatusActive": "Activa",
  "Common-CampaignStatusFinished": "Finalizada",
  "Common-CampaignStatusCreating": "Creando...",
  "Common-CampaignStatusError": "Error",
  "Common-CampaignCreatingMessage": "La campaña se está creando. Los clientes se procesarán en segundo plano.",
  "Common-CampaignCreatingAlert": "Los clientes de esta campaña se están procesando. Por favor, espere.",
  "Common-Efficiency": "Eficiencia",
  "Common-Profit": "Ganancia",
  "Common-RealSales": "Ventas Reales",
  "Common-ProjectedData": "Datos Proyectados",
  "Common-ImportDetails": "Detalles de importación",
  "Common-JsonlFormatExample": "Ejemplo de formato JSONL:",
  "JsonlViewer-LineNumber": "#",
  "JsonlViewer-ParseError": "Error de parseo",
  "JsonlViewer-TotalLines": "Total de líneas",
  "JsonlViewer-ValidLines": "Líneas válidas",
  "JsonlViewer-InvalidLines": "Líneas inválidas",
  "JsonlViewer-NumericSummaries": "Resumen numérico",
  "JsonlViewer-Sum": "Suma",
  "JsonlViewer-Avg": "Promedio",
  "JsonlViewer-Min": "Mín",
  "JsonlViewer-Max": "Máx",
  "JsonlViewer-Count": "Cantidad",
  "JsonlViewer-SearchPlaceholder": "Buscar en el contenido del archivo...",
  "JsonlViewer-LineDetail": "Detalle de línea",
  "JsonlViewer-RawLine": "Línea original",
  "JsonlViewer-ColumnSummary": "Resumen de columna",
  "JsonlViewer-ColumnSummaryHint": "Hacé clic en el nombre de una columna para ver su resumen (suma, promedio, valores distintos, etc.).",
  "JsonlViewer-ColumnSummaryUnavailable": "El resumen de esta columna no está disponible.",
  "JsonlViewer-NullCount": "Valores nulos",
  "JsonlViewer-DistinctCount": "Valores distintos",
  "JsonlViewer-Value": "Valor",
  "Common-JsonlFormatSample": `{"code": 100001, "date": "2024-01-01T00:00:00", "subtotal": 1000.0, "iva": 210.0, "total": 1210.0, "documentType": "CASH_TICKET", "accumulatePoints": 10, "consumedPoints": 0, "currencyId": 1, "channelId": 2, "salePointExternalId": "SP001", "skusWithPrice": [{"skuExternalId": "SKU123", "unitPrice": 1000.0, "quantity": 1}], "acceptedPaymentMethodExternalIds": [101], "promotionExternalIds": [], "fidelity": 555001, "controlStock": true}\n{"code": 100002, "date": "2024-01-02T00:00:00", "subtotal": 2000.0, "iva": 420.0, "total": 2420.0, "documentType": "CASH_TICKET", "accumulatePoints": 20, "consumedPoints": 5, "currencyId": 1, "channelId": 2, "salePointExternalId": "SP002", "skusWithPrice": [{"skuExternalId": "SKU124", "unitPrice": 1200.0, "quantity": 1}, {"skuExternalId": "SKU125", "unitPrice": 800.0, "quantity": 1}], "acceptedPaymentMethodExternalIds": [102, 103], "promotionExternalIds": [201], "fidelity": 555002, "controlStock": false}`,
  "Common-JsonlKeyFields": "Campos clave:",
  "Common-JsonlKeyFieldSalePoint":
    "<code>salePointExternalId</code>: ID externo del punto de venta",
  "Common-JsonlKeyFieldSkus":
    "<code>skusWithPrice</code>: Arreglo de SKUs con precios y cantidades",
  "Common-JsonlKeyFieldPayments":
    "<code>acceptedPaymentMethodExternalIds</code>: Arreglo de IDs de métodos de pago",
  "Common-JsonlKeyFieldPromotions":
    "<code>promotionExternalIds</code>: Arreglo de IDs de promociones (opcional)",
  "AdminDashboard-KpiTotalSales": "Ventas totales",
  "AdminDashboard-KpiSameStoreSalesGrowth": "Crecimiento ventas comparables",
  "AdminDashboard-ConfigurationProgress": "Progreso de configuración",
  "AdminDashboard-LastLoads": "Últimas cargas",
  "AdminDashboard-KpiGrossMargin": "Margen bruto",
  "AdminDashboard-KpiNetProfitMargin": "Margen neto",
  "AdminDashboard-KpiAverageTransactionValue": "Ticket promedio (ATV)",
  "AdminDashboard-KpiUnitsPerTransaction": "Unidades por transacción (UPT)",
  "AdminDashboard-KpiInventoryTurnover": "Rotación de inventario",
  "AdminDashboard-KpiDaysSalesInventory": "Días de inventario (DSI)",
  "AdminDashboard-SalesTrend": "Tendencia de ventas",
  "AdminDashboard-AccountStatus": "Estado general de la cuenta",
  "AdminDashboard-ConfigCompleted": "% de configuración completado",
  "AdminDashboard-SalesLoaded": "% de ventas cargado",
  "AdminDashboard-LastItemLoaded": "Último artículo cargado",
  "AdminDashboard-LastPurchaseLoaded": "Última compra cargada",
  "AdminDashboard-LastSalesLoad": "Última carga de ventas",
  "AdminDashboard-PendingTasksTitle": "Tareas pendientes de configuración",
  "AdminDashboard-AlertsTitle": "Alertas principales",
  "AdminDashboard-SeeAll": "Ver todo",
  "AdminDashboard-Sales": "Ventas",
  "AdminClientValidationStats-Title": "Estadísticas de validación de clientes",
  "AdminClientValidationStats-ManagementDescription":
    "Administrá el cálculo de estadísticas y la migración de datos de contacto para cada organización.",
  "AdminClientValidationStats-SelectOrgTitle": "Seleccionar organización",
  "AdminClientValidationStats-SelectOrgHelp":
    "Busca una organización y configura si se calculan las estadísticas y con qué frecuencia.",
  "AdminClientValidationStats-SearchPlaceholder":
    "Buscar por nombre (mín. 2 letras)",
  "AdminClientValidationStats-SelectPlaceholder": "Selecciona una organización",
  "AdminClientValidationStats-SettingsTitle": "Configuración",
  "AdminClientValidationStats-NoOrgSelected":
    "Selecciona una organización para ver y editar la configuración.",
  "AdminClientValidationStats-SelectedOrg": "Organización:",
  "AdminClientValidationStats-Enabled": "Habilitado",
  "AdminClientValidationStats-Frequency": "Frecuencia",
  "AdminClientValidationStats-Org": "Organización",
  "AdminClientValidationStats-Schedule": "Horario",
  "AdminClientValidationStats-FrequencyHourly": "Cada hora",
  "AdminClientValidationStats-FrequencyDaily": "Diario",
  "AdminClientValidationStats-DailyHour": "Hora diaria",
  "AdminClientValidationStats-DailyMinute": "Minuto diario",
  "AdminClientValidationStats-DailyTime": "Hora (HH:mm)",
  "AdminClientValidationStats-HourlyMinute": "Minuto (cada hora)",
  "AdminClientValidationStats-TimezoneNote":
    "La hora diaria usa la zona horaria del servidor.",
  "AdminClientValidationStats-ComputeNow": "Calcular ahora",
  "AdminClientValidationStats-ComputeNow-Started":
    "Cálculo iniciado. Esto puede demorar unos minutos.",
  "AdminClientValidationStats-ComputeNow-Success":
    "Cálculo encolado/realizado correctamente.",
  "AdminClientValidationStats-ComputeNow-Error": "No se pudo calcular ahora.",
  "AdminClientValidationStats-ComputeNow-Disabled":
    "Primero debes habilitar las estadísticas para esta organización.",
  "AdminClientValidationStats-ComputeNow-Status": "Estado del cálculo:",
  "AdminClientValidationStats-Migration-Action": "Migrar datos de contacto",
  "AdminClientValidationStats-Migration-Title":
    "Migrar contactos de {{organization}}",
  "AdminClientValidationStats-Migration-WarningTitle":
    "Esta acción no se puede deshacer",
  "AdminClientValidationStats-Migration-Warning":
    "Se calculará y conservará únicamente si cada mail, teléfono y celular es válido. Luego se eliminarán definitivamente los datos de contacto originales. Revisa el resumen antes de confirmar.",
  "AdminClientValidationStats-Migration-TotalClients": "Clientes totales",
  "AdminClientValidationStats-Migration-AffectedClients":
    "Clientes con datos que se eliminarán",
  "AdminClientValidationStats-Migration-Emails": "Mails almacenados",
  "AdminClientValidationStats-Migration-Phones": "Teléfonos almacenados",
  "AdminClientValidationStats-Migration-Mobiles": "Celulares almacenados",
  "AdminClientValidationStats-Migration-Valid": "válidos",
  "AdminClientValidationStats-Migration-TypeOrgName":
    "Para confirmar, escribe exactamente {{organization}}.",
  "AdminClientValidationStats-Migration-ConfirmAction":
    "Migrar y eliminar datos",
  "AdminClientValidationStats-Migration-NothingToDo":
    "Esta organización ya no tiene datos de contacto almacenados.",
  "AdminClientValidationStats-Migration-PreviewError":
    "No se pudo cargar el resumen de la migración.",
  "AdminClientValidationStats-Migration-Error":
    "No se pudo completar la migración.",
  "AdminClientValidationStats-Migration-Success":
    "Se migraron {{count}} clientes a almacenamiento de solo validación.",
  "AdminClientValidationStats-Migration-Queued":
    "La migración se inició y continuará en segundo plano.",
  "AdminClientValidationStats-Migration-Running":
    "Migrando datos de contacto",
  "AdminClientValidationStats-Migration-Progress":
    "{{processed}} de {{total}} clientes procesados",
  "AdminClientValidationStats-Migration-Failed":
    "La migración no pudo completarse. Puedes volver a intentarlo.",
  "ClientValidationStats-Disabled-Title": "Estadísticas deshabilitadas",
  "ClientValidationStats-Disabled-Description":
    "Estas estadísticas están deshabilitadas para tu organización. Un administrador debe habilitarlas desde el panel de Admin.",
  "ClientValidationStats-NoDataAvailable": "No hay datos disponibles",
  "ClientValidationStats-Title": "Salud de Datos de Clientes",
  "ClientValidationStats-Subtitle": "Monitoreo de calidad por campo, conflictos de contacto y salud de ingestión por canal.",
  "ClientValidationStats-Last7Days": "Últimos 7 días",
  "ClientValidationStats-Last30Days": "Últimos 30 días",
  "ClientValidationStats-Last90Days": "Últimos 90 días",
  "ClientValidationStats-FilterPlaceholder": "Filtrar por tienda / canal...",
  "ClientValidationStats-Update": "Actualizar",
  "ClientValidationStats-ActiveClients": "CLIENTES ACTIVOS",
  "ClientValidationStats-Last24Months": "últimos 24 meses",
  "ClientValidationStats-Activables": "% ACTIVABLES",
  "ClientValidationStats-ValidMailOrCell": "mail o cel válidos",
  "ClientValidationStats-WithConflict": "% CON CONFLICTO",
  "ClientValidationStats-ConflictFormula": "= 100% - {{percentage}}% activables",
  "ClientValidationStats-LastUpdate": "ÚLTIMA ACTUALIZACIÓN",
  "ClientValidationStats-Today": "Hoy",
  "ClientValidationStats-TabOverview": "Overview",
  "ClientValidationStats-CompletenessByField": "Completitud por Campo × Canal",
  "ClientValidationStats-TopProblems": "Top problemas (últimos cambios)",
  "ClientValidationStats-TableField": "Campo",
  "ClientValidationStats-TableChannel": "Canal",
  "ClientValidationStats-TableDelta7d": "Δ 7d",
  "ClientValidationStats-TableValidPercent": "% válido",
  "ClientValidationStats-TableAffected": "Afectados",
  "ClientValidationStats-TableAction": "Acción",
  "ClientValidationStats-View": "Ver",
  "ClientValidationStats-TabConflicts": "Conflictos",
  "ClientValidationStats-DataConflicts": "Conflictos de Datos",
  "ClientValidationStats-ConflictsDescription": "Listado unificado de registros con problemas: contacto compartido, documento inválido, fechas imposibles, valores fuera de catálogo, campos críticos vacíos, etc.",
  "ClientValidationStats-ConflictsAvailable": "Los conflictos se mostrarán aquí cuando estén disponibles.",
  "ClientValidationStats-TabChannels": "Canales",
  "ClientValidationStats-ChannelHealth": "Salud de Canales (últimas 24 h)",
  "ClientValidationStats-AlertRules": "Reglas de alertas",
  "ClientValidationStats-ChannelHealthDescription": "Estado de cada origen: operativo, eventos enviados, latencia y última carga. Sirve para detectar interrupciones o demoras de ingestión.",
  "ClientValidationStats-Source": "Fuente: dwh_customer_quality_daily • dwh_customer_quality_checks • dwh_channel_health",
  "ClientValidationStats-TableStatus": "Status",
  "ClientValidationStats-TableEvents1h": "Eventos 1h",
  "ClientValidationStats-TableExpected1h": "Esperados 1h",
  "ClientValidationStats-TableLatency": "Latencia",
  "ClientValidationStats-TableLastOK": "Último OK",
  "ClientValidationStats-PercentagePoints": "p.p.",
    "AdminDashboard-Alert-MissingSalesData":
    "No se ha cargado datos de venta en 3 días",
  "AdminDashboard-Alert-PromotionsEnding": "Promociones por finalizar",
  "AdminDashboard-Alert-LowRedemption": "Baja tasa de canje de incentivos",
  "AdminDashboard-Alert-ImpendingStockout":
    "Quiebre de stock próximo en tienda X",
  "AdminDashboard-Alert-RewardsOutOfStock": "Incentivo popular agotado",
  "AdminDashboard-Task-CatalogLoad": "Carga de catálogo",
  "AdminDashboard-Task-HistoricalSalesLoad": "Carga de ventas histórica",
  "AdminDashboard-Task-BranchesLoad": "Carga de sucursales",
  "AdminDashboard-Task-PromotionsLoad": "Carga de promociones",
  "AdminDashboard-Task-PricesLoad": "Carga de precios",
  "AdminValidation-AccessDenied": "Acceso Denegado",
  "AdminValidation-NoPermission":
    "No tienes permisos para acceder a esta funcionalidad.",
  "AdminValidation-AdminOnly":
    "Esta funcionalidad solo está disponible para organizaciones administradoras.",
  "AdminValidation-GoToDashboard": "Ir al Dashboard",
  "Common-Redirecting": "Redirigiendo...",
  "DataScienceJobs-TotalJobs": "Total de Trabajos",
  "DataScienceJobs-JobNotFound": "Trabajo no encontrado",
  "DataScienceJobs-JobNotFoundDescription":
    "El trabajo solicitado no existe o ha sido eliminado.",
  "DataScienceJobs-JobDetails": "Detalles del Trabajo",
  "DataScienceJobs-LoadJobError": "Error al cargar el trabajo",
  "DataScienceJobs-ConfirmDelete":
    "¿Está seguro de que desea eliminar este trabajo?",
  "Common-Loading": "Cargando...",
  "DataScienceJobs-NoOrganizationsFound": "No se encontraron organizaciones",
  "DataScienceJobs-TypeToSearch": "Escribe para buscar...",
  "DataScienceJobs-NoArticlesFound": "No se encontraron artículos",
  "DataScienceJobs-TypeToSearchArticles": "Escribe para buscar artículos...",
  "DataScienceJobs-Schedule": "Programación",
  "DataScienceJobs-EnableSchedule": "Programar ejecución automática",
  "DataScienceJobs-EnableScheduleHelp":
    "Desactivá esta opción si el job solo se ejecutará desde recomendaciones.",
  "DataScienceJobs-Unscheduled": "Sin programación",
  "Common-Daily": "Diario",
  "Common-Advanced": "Avanzado",
  "Common-DayOfMonth": "Día del mes",
  "Common-EveryHour": "Cada hora",
  "Common-AtMinute": "en el minuto",
  "Common-Unknown": "Desconocido",
  "Common-DaysOfWeek": {
    SUN: "Dom",
    MON: "Lun",
    TUE: "Mar",
    WED: "Mié",
    THU: "Jue",
    FRI: "Vie",
    SAT: "Sáb",
  },
  "Common-Now": "Ahora",
  "Common-Ok": "Aceptar",
  "Common-SelectTime": "Seleccionar hora",
  "DataScienceJobs-ForecastPeriods": "Períodos de Pronóstico",
  "DataScienceJobs-ForecastPeriodsHelp":
    "Número de días para predecir la demanda",
  "DataScienceJobs-StartingDate": "Fecha de Inicio",
  "DataScienceJobs-StartingDateHelp":
    "Fecha desde la cual comenzar el pronóstico",
  "DataScienceJobs-DemandForecastStartingDateHelp":
    "Fecha desde la cual comenzar el pronóstico.",
  "DataScienceJobs-SplitBySku": "Dividir por SKU",
  "DataScienceJobs-SplitBySkuHelp":
    "Generar pronósticos separados para cada SKU",
  "DataScienceJobs-OptimizationObjective": "Objetivo de Optimización",
  "DataScienceJobs-MaximizeMargin": "Maximizar Margen",
  "DataScienceJobs-MaximizeQuantity": "Maximizar Cantidad",
  "DataScienceJobs-OptimizationObjectiveHelp":
    "Objetivo de optimización: 'profit' para maximizar margen, 'rotation' para maximizar cantidad",
  "DataScienceJobs-RestockDays": "Días de Reposición",
  "DataScienceJobs-RestockDaysHelp":
    "Número de días de reposición a considerar",
  "DataScienceJobs-EndingDate": "Fecha de Fin",
  "DataScienceJobs-RestockManualEvaluationStartingDateHelp":
    "Fecha inicial del rango de órdenes de reposición a evaluar.",
  "DataScienceJobs-RestockManualEvaluationEndingDateHelp":
    "Fecha final del rango de órdenes de reposición a evaluar.",
  "DataScienceJobs-SeasonalForecastStartingDateHelp":
    "Fecha de inicio de la proyección de demanda de temporada.",
  "DataScienceJobs-SeasonalForecastBrandIdHelp":
    "Seleccioná marcas para segmentar el cálculo. Dejar vacío calcula todas las marcas.",
  "DataScienceJobs-SeasonalForecastPeriodsHelp":
    "Cantidad de días a proyectar. Por defecto se usan 182 días.",
  "DataScienceJobs-NextPurchaseStartingDateHelp":
    "Fecha desde la cual traer datos históricos para entrenar y actualizar la predicción de próxima compra.",
  "DataScienceJobs-MarketBasketStartingDateHelp":
    "Fecha desde la cual traer transacciones para calcular asociaciones de compra.",
  "DataScienceJobs-AnalysisType": "Tipo de Análisis",
  "DataScienceJobs-AnalysisTypeHelp":
    "Define si el análisis se calcula a nivel categoría o marca. Por ahora se recomienda usar categoría.",
  "DataScienceJobs-AnalysisType.multiproduct_category": "Categoría",
  "DataScienceJobs-AnalysisType.multiproduct_brand": "Marca",
  "DataScienceJobs-StoreTransferenceOutputTypeHelp":
    "Dónde guardar el resultado del proceso. 'none' solo ejecuta el cálculo sin persistirlo.",
  "DataScienceJobs-ExcludeArticles": "Artículos a Excluir",
  "DataScienceJobs-ExcludeArticlesHelp":
    "Lista de artículos que se excluirán del cálculo de reposición",
  "DataScienceJobs-Brands": "Marcas",
  "DataScienceJobs-BrandsHelp":
    "Seleccioná las marcas a calcular. El sistema guardará sus IDs. Dejar vacío calcula todas las marcas, pero puede tardar mucho.",
  "DataScienceJobs-SelectBrands": "Buscar y seleccionar marcas",
  "DataScienceJobs-NoBrandsFound": "No se encontraron marcas",
  "DataScienceJobs-Clients": "Clientes",
  "DataScienceJobs-Segments": "Segmentos",
  "DataScienceJobs-Categories": "Categorías",
  "DataScienceJobs-SelectItems": "Seleccionar",
  "DataScienceJobs-SearchItems": "Buscar por nombre o ID",
  "DataScienceJobs-ConfirmSelection": "Confirmar selección",
  "DataScienceJobs-NoSelection": "Sin selección. Se incluirán todos los registros del alcance.",
  "DataScienceJobs-SelectedCount": "{{count}} seleccionados",
  "DataScienceJobs-PopulationType": "Tipo de población",
  "DataScienceJobs-PopulationType.client": "Clientes",
  "DataScienceJobs-PopulationType.segment": "Segmentos",
  "DataScienceJobs-PopulationTypeHelp":
    "Define si la propensión se calcula a nivel cliente o segmento.",
  "DataScienceJobs-ClientIds": "IDs de clientes",
  "DataScienceJobs-ClientIdsHelp":
    "Seleccioná clientes específicos. El sistema guardará sus IDs. Dejar vacío incluye todos los clientes del alcance.",
  "DataScienceJobs-SelectClients": "Buscar y seleccionar clientes",
  "DataScienceJobs-NoClientsFound": "No se encontraron clientes",
  "DataScienceJobs-SegmentIds": "IDs de segmentos",
  "DataScienceJobs-SegmentIdsHelp":
    "Seleccioná segmentos específicos. El sistema guardará sus IDs. Se usa cuando el tipo de población es segmento.",
  "DataScienceJobs-SelectSegments": "Buscar y seleccionar segmentos",
  "DataScienceJobs-NoSegmentsFound": "No se encontraron segmentos",
  "DataScienceJobs-AggregationLevel": "Nivel de análisis",
  "DataScienceJobs-AggregationLevel.all": "Todos",
  "DataScienceJobs-AggregationLevel.category": "Categoría",
  "DataScienceJobs-AggregationLevel.brand": "Marca",
  "DataScienceJobs-AggregationLevel.category_brand": "Categoría y marca",
  "DataScienceJobs-AggregationLevelHelp":
    "Determina si el análisis se realiza por categoría, marca, categoría-marca o todos secuencialmente.",
  "DataScienceJobs-CategoryIds": "IDs de categorías",
  "DataScienceJobs-CategoryIdsHelp":
    "Seleccioná categorías específicas. El sistema guardará sus IDs. Dejar vacío incluye todas las categorías.",
  "DataScienceJobs-SelectCategories": "Buscar y seleccionar categorías",
  "DataScienceJobs-NoCategoriesFound": "No se encontraron categorías",
  "DataScienceJobs-BrandIds": "IDs de marcas",
  "DataScienceJobs-BrandIdsHelp":
    "Seleccioná marcas específicas. El sistema guardará sus IDs. Dejar vacío incluye todas las marcas.",
  "DataScienceJobs-DaysInAdvance": "Días de anticipación",
  "DataScienceJobs-DaysInAdvanceHelp":
    "Cantidad mínima de días antes de poder ejecutar la promoción. La promo empieza en hoy + días de anticipación.",
  "DataScienceJobs-Discounts": "Descuentos (%)",
  "DataScienceJobs-DiscountsHelp":
    "Listado de descuentos porcentuales a evaluar, separados por coma. Ejemplo: 10,20,30",
  "DataScienceJobs-Durations": "Duraciones (días)",
  "DataScienceJobs-DurationsHelp":
    "Listado de duraciones en días a evaluar, separadas por coma. Ejemplo: 7,14,30",
  "DataScienceJobs-PromotionsBrandIdHelp":
    "IDs de marcas a evaluar, separados por coma. Dejar vacío corre todas las marcas.",
  "DataScienceJobs-PromotionsCategoryIdHelp":
    "IDs de categorías a evaluar, separados por coma. Dejar vacío corre todas las categorías.",
  "DataScienceJobs-TopN": "Top N",
  "DataScienceJobs-TopNHelp":
    "Opcional. Limita la cantidad de recomendaciones a persistir (las de mayor ranking).",
  "DataScienceJobs-AdaptToCommercialDates": "Adaptar a fechas comerciales",
  "DataScienceJobs-AdaptToCommercialDatesHelp":
    "Ajusta el inicio y la duración de la promoción para alinearla con fechas comerciales vigentes.",
  "DataScienceJobs-OutputType": "Destino de resultados",
  "DataScienceJobs-OutputType.database": "Guardar en base de datos",
  "DataScienceJobs-OutputType.none": "No guardar (solo ejecutar)",
  "DataScienceJobs-OutputType.csv": "Exportar a CSV",
  "DataScienceJobs-OutputTypeHelp":
    "Dónde guardar el resultado del proceso. 'none' solo ejecuta el cálculo sin persistirlo.",
  "DataScienceJobs-TaskProfile": "Perfil del contenedor",
  "DataScienceJobs-TaskProfile.standard": "Estándar (1 vCPU, 2 GB RAM)",
  "DataScienceJobs-TaskProfile.high_memory": "Alto consumo (4 vCPU, 8 GB RAM)",
  "DataScienceJobs-TaskProfile.xlarge": "Extra grande (8 vCPU, 16 GB RAM)",
  "DataScienceJobs-TaskProfile.2xlarge": "Máximo (16 vCPU, 32 GB RAM)",
  "DataScienceJobs-TaskProfile.recommended": "— Recomendado",
  "DataScienceJobs-TaskProfileHelp":
    "Perfil recomendado para {{jobType}}: {{profile}}.",
  "DataScienceJobs-TaskProfile.nonRecommendedWarning":
    "Este job usa un perfil distinto al recomendado para {{jobType}}.",
  "DataScienceJobs-TaskProfile.HighResourceConfirmTitle":
    "Confirmar contenedor de alto consumo",
  "DataScienceJobs-TaskProfile.HighResourceConfirmContent":
    "Estás seleccionando un contenedor de alto consumo de recursos ({{profile}}). Puede tener un costo significativamente mayor. ¿Deseás continuar?",
  "DataScienceJobs-TaskProfile.HighResourceConfirmOk": "Usar este perfil",
  "DataScienceJobs-TaskProfile.HighResourceConfirmCancel": "Cancelar",
  "DataScienceJobs-ExecutionEnd": "Fin de ejecución",
  "Common-SelectMonth": "Seleccionar mes",
  "Common-SelectYear": "Seleccionar año",
  "Common-SelectDecade": "Seleccionar década",
  "Common-PreviousMonth": "Mes anterior",
  "Common-NextMonth": "Mes siguiente",
  "Common-NextPointsToExpire": "Próximos puntos a vencer",
  "Common-PreviousYear": "Año anterior",
  "Common-NextYear": "Año siguiente",
  "Common-PreviousDecade": "Década anterior",
  "Common-NextDecade": "Década siguiente",
  "Common-PreviousCentury": "Siglo anterior",
  "Common-NextCentury": "Siglo siguiente",
  "DataScienceJobs-CronExpressions": {
    EveryXMinutes: "Cada {{interval}} minutos",
    EveryXMinutesAtHour: "Cada {{interval}} minutos a la hora {{hour}}",
    EveryHourAtMinute0: "cada hora en el minuto 0",
    EveryXMinutesPattern: "cada {{interval}} minutos",
    EveryHourAtMinute: "cada hora en el minuto {{minute}}",
    AtTime: "a las {{time}}",
    AllDays: "Todos los días",
    DayOfMonth: "El día {{day}} de cada mes",
    InMonth: "En el mes {{month}} el día {{day}}",
    EveryWeekOn: "Cada semana los {{days}}",
    EveryXHours: "Cada {{interval}} horas en el minuto {{minute}}",
    EveryHourBetween:
      "Cada hora entre {{start}} y {{end}} en el minuto {{minute}}",
    AllDaysAtTimes: "Todos los días a las {{times}}",
  },
  "BranchOffice-Tab-General": "General",
  "BranchOffice-Tab-Schedules": "Cronogramas",
  "BranchOffice-Tab-SalesPoints": "Puntos de venta",
  "BranchOffice-Tab-Stock": "Stock",
  "BranchOffice-Tab-HistoricalStock": "Stock histórico",
  "BranchOffice-EmptySchedules": "No hay cronograma configurado",
  "BranchOffice-EmptySchedulesDescription":
    "Agrega el primer cronograma para esta sucursal",
  "BranchOffice-EmptySalesPoints": "No hay puntos de venta",
  "BranchOffice-EmptySalesPointsDescription":
    "Crea el primer punto de venta para empezar",
  "BranchOffice-EmptyHistoricalStock": "No hay datos históricos",
  "BranchOffice-EmptyHistoricalStockDescription":
    "Los datos aparecerán cuando haya movimientos de stock",
  "BranchOffice-AddFirstSchedule": "Agregar primer cronograma",
  "BranchOffice-AddFirstSalesPoint": "Crear punto de venta",
  "Common-EditSalePoint": "Editar punto de venta",
  "Common-ValidationErrorMessage":
    "Por favor, completa todos los campos requeridos",
  "Common-Static": "Estático",
  "Common-Dynamic": "Dinámico",
  "Common-SegmentConditions": "Condiciones del Segmento",
  "Common-ClientList": "Listado de clientes",
  "Common-ClickToUploadFile": "Click para subir archivo",
  "Common-BirthDateFrom": "Fecha nacimiento desde",
  "Common-BirthDateTo": "Fecha nacimiento hasta",
  "Common-RegisterDateFrom": "Fecha registro desde",
  "Common-RegisterDateTo": "Fecha registro hasta",
  "Common-ClientInfo": "Información del Cliente",
  "Common-FinancialSummary": "Resumen Financiero",
  "Common-Products": "Productos",
  "Common-NoProductsInTicket": "No hay productos en este ticket",
  "Common-NoArticlesInTicket": "No hay artículos en este ticket",
  "Common-NoPromotionsApplied": "No hay promociones aplicadas",
  "Common-NotAvailable": "N/A",
  "Common-Processed": "Procesado",
  "Common-PrintingTicket": "Imprimiendo ticket...",
  "Common-DownloadingTicket": "Descargando ticket...",
  "Common-SharingTicket": "Compartiendo ticket...",
  "Common-Print": "Imprimir",
  "Common-ProgressiveDiscount": "Descuento progresivo",
  "Common-Share": "Compartir",
  "Common-Created": "Creada",
  "Common-Regular": "Regular",
  "Common-BOGO": "BOGO",
  "Common-MxN": "MxN",
  "Promotion-EmptyTitle": "No hay promociones",
  "Promotion-EmptyDescription":
    "No se encontraron promociones en el sistema. Crea una nueva promoción para comenzar.",
  "Promotion-EmptyButton": "Crear primera promoción",
  "Promotion-EmptyFilterTitle": "No se encontraron resultados",
  "Promotion-EmptyFilterDescription":
    "No hay promociones que coincidan con los filtros aplicados. Intenta ajustar los criterios de búsqueda.",
  "CommercialIntelligence-Action": "Accionar",
  "CommercialIntelligence-ActiveCampaigns": "Campañas activas",
  "CommercialIntelligence-AlertNoContact": "{{pct}}% de clientes sin canal válido (celular o email).",
  "CommercialIntelligence-AlertTicketsNoClient": "{{pct}}% de tickets sin cliente asociado.",
  "CommercialIntelligence-Alerts": "Alertas",
  "CommercialIntelligence-Attention": "Atención",
  "CommercialIntelligence-Audience": "Audiencia",
  "CommercialIntelligence-Campaign": "Campaña",
  "CommercialIntelligence-Communications": "Comunicaciones",
  "CommercialIntelligence-CreateCampaign": "Crear campaña",
  "CommercialIntelligence-CreateIncentive": "Crear incentivo",
  "CommercialIntelligence-CreatePromotion": "Crear promoción",
  "CommercialIntelligence-DataHealth": "Salud de datos",
  "CommercialIntelligence-DataHealthContactable": "Clientes contactables",
  "CommercialIntelligence-DataHealthContactableHint": "Clientes con email o celular validado",
  "CommercialIntelligence-DataHealthEmail": "Email válido",
  "CommercialIntelligence-DataHealthEmailHint": "Clientes con email validado",
  "CommercialIntelligence-DataHealthHistory": "Historial suficiente",
  "CommercialIntelligence-DataHealthHistoryHint": "Clientes con tickets, con departamento, país, sexo, nacimiento y al menos un contacto",
  "CommercialIntelligence-DataHealthMobile": "Celular válido",
  "CommercialIntelligence-DataHealthMobileHint": "Clientes con celular validado",
  "CommercialIntelligence-EstimatedImpact": "Impacto estimado",
  "CommercialIntelligence-FeaturedResult": "Resultado destacado",
  "CommercialIntelligence-FeaturedSales": "Venta",
  "CommercialIntelligence-GeneralStatus": "Estado general",
  "CommercialIntelligence-Incentives": "Incentivos",
  "CommercialIntelligence-Last7Days": "Últimos 7 días",
  "CommercialIntelligence-NoActiveCampaigns": "No hay campañas activas",
  "CommercialIntelligence-NoFeaturedResult": "No hay campañas finalizadas en el período seleccionado",
  "CommercialIntelligence-NoOpportunities": "No hay oportunidades sugeridas",
  "CommercialIntelligence-Open": "Abrir",
  "CommercialIntelligence-Opportunities": "Oportunidades",
  "CommercialIntelligence-PeriodLast30Days": "Últimos 30 días",
  "CommercialIntelligence-PeriodLast3Months": "Últimos 3 meses",
  "CommercialIntelligence-PeriodLast6Months": "Últimos 6 meses",
  "CommercialIntelligence-PeriodLastYear": "Último año",
  "CommercialIntelligence-Promotions": "Promociones",
  "CommercialIntelligence-ReviewOpportunities": "Revisar oportunidades",
  "CommercialIntelligence-StatusDescription": "Datos saludables. Potencial fuerte en retención (incentivos). Campañas activas en curso.",
  "CommercialIntelligence-Suggested": "Sugeridos",
  "CommercialIntelligence-ViewCampaign": "Ver campaña",
  "CommercialIntelligence-ViewCampaigns": "Ver campañas",
  "CommercialIntelligence-ViewCommunications": "Ver comunicaciones",
  "CommercialIntelligence-ViewDataHealth": "Ver salud de datos",
  "CommercialIntelligence-ViewIncentives": "Ver incentivos",
  "CommercialIntelligence-ViewOpportunities": "Ver oportunidades",
  "CommercialIntelligence-ViewPromotions": "Ver promociones",
  "Common-Info": "Info",
  "ActivationAction-Title": "Acciones de activación",
  "ActivationAction-Status-Suggested": "Sugerida",
  "ActivationAction-Status-Approved": "Aprobada",
  "ActivationAction-Audience": "Audiencia",
  "ActivationAction-EstimatedConversion": "Conversión estimada",
  "ActivationAction-Action": "Acción",
  "ActivationAction-ConvertToCampaign": "Convertir en campaña",
  "ActivationAction-ConvertingToCampaign": "Convirtiendo a campaña…",
  "ActivationAction-ConvertSuccess": "Acción convertida en campaña exitosamente",
  "ActivationAction-DeleteConfirm": "¿Está seguro de eliminar esta acción de activación?",
  "ActivationAction-DeleteError-HasCampaign": "No se puede eliminar una acción asociada a una campaña ejecutada",
  "ActivationAction-ViewDetail": "Ver detalle",
  "ActivationAction-RuleType": "Tipo de regla",
  "ActivationAction-SourceSegment": "Segmento origen",
  "ActivationAction-EmptyTitle": "No hay acciones de activación",
  "ActivationAction-EmptyDescription":
    "Las acciones de activación se generan automáticamente al ejecutar el motor. Cuando haya segmentos que cumplan las reglas, aparecerán aquí.",
  "ActivationAction-EmptyFilterTitle": "No se encontraron resultados",
  "ActivationAction-EmptyFilterDescription":
    "No hay acciones de activación que coincidan con los filtros aplicados. Intentá con otros criterios.",
  "ActivationAction-RunEngine": "Ejecutar motor",
  "ActivationAction-EngineSuccess":
    "Motor ejecutado. Se generaron {{count}} acciones de activación.",

  "ActivationAction-DetailTitle": "Detalle de acción",
  "ActivationAction-TabSummary": "Resumen",
  "ActivationAction-TabArticles": "Artículos",
  "ActivationAction-TabClients": "Clientes",
  "ActivationAction-NoArticles": "No hay artículos para mostrar",
  "ActivationAction-NoClients": "No hay clientes para mostrar",
  "ActivationAction-Campaign": "Campaña",

  "ActivationParam-SectionTitle": "Parámetros de acciones de activación",
  "ActivationParam-MinAudience": "Mínimo de clientes para generar una acción",
  "ActivationParam-CampaignExclusionDays":
    "Días para excluir clientes en campañas recientes",
  "ActivationParam-MinStockNovelty": "Stock mínimo por artículo",
  "ActivationParam-NewArticleDays": "Días para considerar un artículo \"nuevo\"",
  "ActivationParam-MinSharedAttributes":
    "Atributos compartidos para similaridad",
  "ActivationParam-RenewalMonths": "Meses para considerar renovación",
  "ActivationParam-MaxRecommendedArticles": "Máximo de artículos por acción",

  "ProductAnalysis-Title": "Productos",
  "ProductAnalysis-SearchPlaceholder":
    "Buscar producto, SKU, marca o categoría...",
  "ProductAnalysis-Period": "Período",
  "ProductAnalysis-Period-30": "Últimos 30 días",
  "ProductAnalysis-Period-60": "Últimos 60 días",
  "ProductAnalysis-Period-90": "Últimos 90 días",
  "ProductAnalysis-Period-180": "Últimos 180 días",
  "ProductAnalysis-Category": "Categoría",
  "ProductAnalysis-Season": "Temporada",
  "ProductAnalysis-Brand": "Marca",
  "ProductAnalysis-Store": "Tienda",
  "ProductAnalysis-Supplier": "Proveedor",
  "ProductAnalysis-SupplierExternalIdPlaceholder": "ID externo del proveedor",
  "ProductAnalysis-Stock": "Stock",
  "ProductAnalysis-Health": "Salud",
  "ProductAnalysis-AllOptions-F": "Todas",
  "ProductAnalysis-AllOptions-M": "Todos",
  "ProductAnalysis-Stock-Low": "Stock bajo",
  "ProductAnalysis-Stock-Break": "Con quiebre",
  "ProductAnalysis-Stock-Risk": "Riesgo de quiebre",
  "ProductAnalysis-Health-OK": "Salud OK",
  "ProductAnalysis-Health-Attention": "Atención",
  "ProductAnalysis-Health-Risk": "Riesgo",
  "ProductAnalysis-Health-Attention-ComingSoon": "Atención (próximamente)",
  "ProductAnalysis-Health-Risk-ComingSoon": "Riesgo (próximamente)",
  "ProductAnalysis-Column-Product": "Producto",
  "ProductAnalysis-Column-Category": "Categoría",
  "ProductAnalysis-Column-GrossSales": "Venta Bruta",
  "ProductAnalysis-Column-Units": "Unidades",
  "ProductAnalysis-Column-Margin": "Margen",
  "ProductAnalysis-Column-Stock": "Stock",
  "ProductAnalysis-Column-Health": "Salud",
  "ProductAnalysis-Column-Channel": "Canal",
  "ProductAnalysis-Column-Store": "Tienda",
  "ProductAnalysis-Column-Presence": "Presencia",
  "ProductAnalysis-Column-Tickets": "Tickets",
  "ProductAnalysis-Column-AvgTicket": "Ticket Prom.",
  "ProductAnalysis-Column-PctChannelSales": "% venta canal",
  "ProductAnalysis-Column-PctStoreSales": "% venta tienda",
  "ProductAnalysis-Column-ForecastSales": "Venta proy.",
  "ProductAnalysis-Column-Promotion": "Promoción",
  "ProductAnalysis-Column-Type": "Tipo",
  "ProductAnalysis-Column-Uplift": "Uplift",
  "ProductAnalysis-Column-ROI": "ROI",
  "ProductAnalysis-Column-Result": "Resultado",
  "ProductAnalysis-Column-Affinity": "Afinidad",
  "ProductAnalysis-Column-Similarity": "Similaridad",
  "ProductAnalysis-Column-Reason": "Motivo",
  "ProductAnalysis-Column-SalesVar": "Var. venta",
  "ProductAnalysis-Column-Article": "Artículo",
  "ProductAnalysis-Column-SKU": "Id externo",
  "ProductAnalysis-Column-Size": "Talle",
  "ProductAnalysis-Column-Color": "Color",
  "ProductAnalysis-Column-PctOfArticle": "% del producto",
  "ProductAnalysis-Column-Turnover": "Rotación",
  "ProductAnalysis-Column-Status": "Estado",
  "ProductAnalysis-Column-Recommendation": "Recomendación",
  "ProductAnalysis-Tag-WithBreak": "Con quiebre",
  "ProductAnalysis-Tag-Present": "Presente",
  "ProductAnalysis-Tag-NotPresent": "Sin presencia",
  "ProductAnalysis-Tag-OK": "OK",
  "ProductAnalysis-Tag-Pending": "Pendiente",
  "ProductAnalysis-Tag-AlertsCount": "{{count}} alertas",
  "ProductAnalysis-Suffix-DaysInventory": "días inv.",
  "ProductAnalysis-Empty-NoResults": "Sin resultados",
  "ProductAnalysis-Empty-NoProductFound": "No se encontró el producto",
  "ProductAnalysis-Empty-NoChannelData": "Sin datos por canal",
  "ProductAnalysis-Empty-NoStoreData": "Sin datos por tienda",
  "ProductAnalysis-Empty-NoPeriodData": "Sin datos en el período",
  "ProductAnalysis-Empty-NoPromotions": "Sin participación en promociones",
  "ProductAnalysis-Empty-NoComplementary": "Sin complementarios",
  "ProductAnalysis-Empty-NoSimilar": "No se encontraron artículos similares",
  "ProductAnalysis-Empty-NoSkus": "Sin SKUs cargados",
  "ProductAnalysis-Empty-AlertsPending":
    "Sin alertas activas en este período.",
  "ProductAnalysis-Alert-NoRecentSales": "Producto sin ventas recientes",
  "ProductAnalysis-Alert-SalesDropVsLY":
    "Producto con caída relevante vs año anterior",
  "ProductAnalysis-Alert-MarginDecline":
    "Margen deteriorado respecto al año anterior",
  "ProductAnalysis-Alert-VariantConcentration":
    "Venta concentrada en pocas variantes",
  "ProductAnalysis-Alert-PromoDependency": "Producto depende de promociones",
  "ProductAnalysis-Alert-StockoutRisk":
    "Producto con riesgo de quiebre de stock",
  "ProductAnalysis-Alert-LowRotationHighStock":
    "Producto con baja rotación y stock disponible",
  "ProductAnalysis-Alert-Overstock":
    "Producto con exceso de cobertura de stock",
  "ProductAnalysis-Empty-DriversPending":
    "Sin drivers destacados en este período.",
  "ProductAnalysis-Driver-ChannelGrowth":
    "{{channel}} explica el {{pct}}% del crecimiento del producto.",
  "ProductAnalysis-Driver-StoreConcentration":
    "{{store}} concentra el {{pct}}% de la demanda del producto.",
  "ProductAnalysis-Driver-DominantVariant":
    "{{sku}} concentra el {{pct}}% de la venta del producto.",
  "ProductAnalysis-Driver-VariantMixGain":
    "{{sku}} gana {{pp}} puntos de participación dentro del producto.",
  "ProductAnalysis-Driver-PriceBrake":
    "El precio promedio sube {{priceVar}}% mientras las unidades caen {{unitsVar}}% vs LY.",
  "ProductAnalysis-Opportunity-HighMarginLowVolume":
    "Producto con alto margen y bajo volumen",
  "ProductAnalysis-Opportunity-HealthyDemandLowPromo":
    "Producto con demanda sana sin dependencia promocional",
  "ProductAnalysis-Opportunity-AcceleratedGrowth": "Producto en fuerte crecimiento",
  "ProductAnalysis-Opportunity-RecentRecovery":
    "Producto mostrando recuperación comercial",
  "ProductAnalysis-Opportunity-HighDemandLowStock":
    "Producto con alta demanda y stock ajustado",
  "ProductAnalysis-Empty-OpportunitiesPending":
    "Sin oportunidades destacadas en este período.",
  "ProductDetail-Section-Opportunities": "Oportunidades detectadas",
  "ProductDetail-Section-ChannelPerformance": "Performance por canal",
  "ProductAnalysis-LoadError": "No se pudo cargar esta sección. Probá nuevamente.",
  "ProductAnalysis-Retry": "Reintentar",
  "ProductDetail-Section-StorePerformance": "Performance por tienda",
  "ProductDetail-Section-SalesEvolution": "Evolución de ventas y forecast",
  "ProductDetail-Section-ActiveAlerts": "Alertas activas",
  "ProductDetail-Section-Drivers": "Drivers detectados",
  "ProductDetail-Section-Promotions": "Promociones en las que participó",
  "ProductDetail-Section-Complementary": "Productos complementarios",
  "ProductDetail-Section-Similar": "Artículos similares / sustitutos",
  "ProductDetail-Section-SkuBreakdown": "Detalle por SKU",
  "ProductDetail-Header-SKU": "Id externo",
  "ProductDetail-Header-Brand": "Marca",
  "ProductDetail-Header-Category": "Categoría",
  "ProductDetail-Header-Season": "Temporada",
  "ProductDetail-Header-Price": "Precio",
  "ProductDetail-Header-Cost": "Costo",
  "ProductDetail-Filter-Channel": "Canal",
  "ProductDetail-Filter-Store": "Tienda",
  "ProductDetail-Kpi-GrossSales": "Venta Bruta",
  "ProductDetail-Kpi-Units": "Unidades",
  "ProductDetail-Kpi-Margin": "Margen",
  "ProductDetail-Kpi-Stock": "Stock",
  "ProductDetail-Kpi-Turnover": "Rotación",
  "ProductDetail-Kpi-PctGlobalSales": "% venta global",
  "ProductDetail-Chart-Observed": "Venta real",
  "ProductDetail-Chart-Forecast": "Forecast",

  "SegmentEngineParam-SectionTitle": "Parámetros del motor de segmentos",
  "SegmentEngineParam-InactivityDays":
    "Días para considerar un cliente inactivo",
  "SegmentEngineParam-InactivityDaysMid":
    "Días para considerar inactividad media",
  "SegmentEngineParam-InactivityDaysHigh":
    "Días para considerar inactividad alta",
  "SegmentEngineParam-FrequencyDropThreshold":
    "Ratio mínimo para detectar caída de frecuencia",
  "SegmentEngineParam-HighValuePercentile":
    "Percentil mínimo para clientes de alto valor",
  "SegmentEngineParam-LowTicketPercentile":
    "Percentil máximo de ticket bajo, calculado solo entre clientes con compras en 12 meses",
  "SegmentEngineParam-AffinityThreshold":
    "Afinidad mínima para segmentos por marca o categoría",
  "SegmentEngineParam-MinSegmentSize": "Tamaño mínimo de segmento",
  "SegmentEngineParam-MinSegmentContactableClients":
    "Mínimo de clientes contactables para mostrar un segmento (0 = mostrar todos)",
  "RewardsEngineParam-SectionTitle": "Parámetros del motor de incentivos",
  "RewardsEngineParam-TicketLookbackDays":
    "Días de historial de tickets para calcular el ticket promedio del cliente",
  "RewardsEngineParam-BucketsTitle": "Rangos de ticket promedio",
  "RewardsEngineParam-BucketsHelp":
    "El motor de incentivos agrupa clientes con estos rangos. Cada rango debe empezar donde termina el anterior.",
  "RewardsEngineParam-BucketsEmpty":
    "Sin rangos de ticket promedio, la generación de incentivos falla.",
  "RewardsEngineParam-BucketMinimum": "Mínimo",
  "RewardsEngineParam-BucketMaximum": "Máximo",
  "RewardsEngineParam-AddBucket": "Agregar rango",
  "RewardsEngineParam-SaveBuckets": "Guardar rangos",
  "RewardsEngineParam-TypeMinimum": "Valor mínimo",
  "RewardsEngineParam-TypeMaximum": "Valor máximo",
  "RewardsEngineParam-NoRewardTypes":
    "Creá al menos un tipo de incentivo para asignar valores a los rangos.",
  "RewardsEngineParam-BucketsSaved": "Rangos guardados",
  "RewardsEngineParam-OptionalType": "opcional",
  "RewardsEngineParam-RemoveBucket": "Quitar rango",
  "CommercialOpportunityParam-SectionTitle":
    "Parámetros de oportunidades comerciales",
  "CommercialOpportunityParam-LowPerformanceThreshold":
    "Variación de ventas (%) para marcar performance baja (NEEDS_BOOST)",
  "CommercialOpportunityParam-CriticalPerformanceThreshold":
    "Variación de ventas (%) para marcar performance crítica (CRITICAL)",
  "CommercialOpportunityParam-PerformanceReferenceDays":
    "Días del período actual comparado contra el período de referencia anterior",
  "CommercialOpportunityParam-StoreReactivationMinDays":
    "Días mínimos sin comprar para incluir un cliente en reactivación de tienda",
  "CommercialOpportunityParam-MinStockExcessUnits":
    "Unidades mínimas de stock para considerar exceso por talle",
  "CommercialOpportunityParam-MaxStockExcessSegments":
    "Cantidad máxima de segmentos para liquidar talles",
  "CommercialOpportunityParam-StockExcessWeeks":
    "Semanas de cobertura por encima de las cuales el stock se considera excedente",
  "CommercialOpportunityParam-StockSalesWindowDays":
    "Días de ventas recientes usados para calcular las semanas de cobertura de stock",
  "CommercialOpportunityParam-ChildRenewalMonths":
    "Meses desde la última compra infantil para sugerir el talle siguiente",
  "CommercialOpportunityParam-ChildCategoryIds":
    "Categorías infantiles (incluye subcategorías). Si queda vacío, no se sugieren segmentos de reposición infantil",
  "CommercialOpportunityParam-PointsExpirationWarningDays":
    "Días de aviso antes del vencimiento de puntos",
  "CommercialOpportunityParam-MinPointsToRedeem":
    "Puntos mínimos requeridos para canjear",
  "CommercialOpportunityParam-HighPointsThreshold":
    "Saldo de puntos a partir del cual se considera saldo alto",
  "CommercialOpportunityParam-LowPointsMargin":
    "Margen de puntos sobre el mínimo para el segmento de primer canje",
  "CategoryAnalysis-PageTitle": "Categorías",
  "CategoryAnalysis-SearchPlaceholder": "Buscar categoría...",
  "CategoryAnalysis-AllChannels": "Todos los canales",
  "CategoryAnalysis-AllStores": "Todas las tiendas",
  "CategoryAnalysis-Alerts": "Alertas",
  "CategoryAnalysis-AllAlerts": "Todas",
  "CategoryAnalysis-WithAlerts": "Con alertas",
  "CategoryAnalysis-WithoutAlerts": "Sin alertas",
  "CategoryAnalysis-Last30Days": "Últimos 30 días",
  "CategoryAnalysis-Last60Days": "Últimos 60 días",
  "CategoryAnalysis-Last90Days": "Últimos 90 días",
  "CategoryAnalysis-Last180Days": "Últimos 180 días",
  "CategoryAnalysis-GrossSales": "Venta Bruta",
  "CategoryAnalysis-Sales": "Venta",
  "CategoryAnalysis-Presence": "Presencia",
  "CategoryAnalysis-Variation": "Variación",
  "CategoryAnalysis-Product": "Producto",
  "CategoryAnalysis-Affinity": "Afinidad",
  "CategoryAnalysis-Uplift": "Uplift",
  "CategoryAnalysis-Rotation": "Rotación",
  "CategoryAnalysis-SalesEvolution": "Evolución de ventas",
  "CategoryAnalysis-ActualSales": "Venta real",
  "CategoryAnalysis-Forecast": "Proyección",
  "CategoryAnalysis-ActiveAlerts": "Alertas activas",
  "CategoryAnalysis-NoActiveAlerts": "Sin alertas activas",
  "CategoryAnalysis-DetectedDrivers": "Drivers detectados",
  "CategoryAnalysis-NoDrivers": "Sin drivers detectados",
  "CategoryAnalysis-PerformanceSummary": "Performance resumida",
  "CategoryAnalysis-Calculating": "Calculando...",
  "CategoryAnalysis-Alert-SalesDropVsLY":
    "Caída de ventas respecto al año anterior",
  "CategoryAnalysis-Alert-MarginDecline":
    "Deterioro de margen respecto al año anterior",
  "CategoryAnalysis-Alert-UnitsDropVsLY":
    "Caída de unidades respecto al año anterior",
  "CategoryAnalysis-Alert-LowRotation": "Rotación en descenso",
  "CategoryAnalysis-Alert-NoStock": "Categoría con ventas y sin stock",
  "CategoryAnalysis-Driver-SalesGrowth":
    "Ventas en crecimiento respecto al año anterior",
  "CategoryAnalysis-Driver-UnitsGrowth":
    "Unidades en crecimiento respecto al año anterior",
  "CategoryAnalysis-Driver-MarginImprove":
    "Mejora de margen respecto al año anterior",
  "CategoryAnalysis-Driver-HighShare": "Alta participación en la venta total",
  "CategoryAnalysis-Summary-SalesGrowing": "Ventas en crecimiento",
  "CategoryAnalysis-Summary-SalesStable": "Ventas estables",
  "CategoryAnalysis-Summary-SalesDeclining": "Ventas en descenso",
  "CategoryAnalysis-Summary-MarginUp": "Margen en mejora",
  "CategoryAnalysis-Summary-MarginStable": "Margen estable",
  "CategoryAnalysis-Summary-MarginDown": "Margen en deterioro",
  "CategoryAnalysis-PerformanceByChannel": "Performance por canal",
  "CategoryAnalysis-PerformanceByStore": "Performance por tienda",
  "CategoryAnalysis-TopProducts": "Productos más vendidos",
  "CategoryAnalysis-BottomProducts": "Productos menos vendidos",
  "CategoryAnalysis-ParticipatingPromotions": "Promociones en las que participó",
  "CategoryAnalysis-ComplementaryCategories": "Categorías complementarias",
  "CategoryAnalysis-RelatedActions": "Acciones relacionadas",
  "CategoryAnalysis-ViewArticles": "Ver artículos de la categoría",
  "CategoryAnalysis-ViewPromotions": "Ir a promociones asociadas",
  "CategoryAnalysis-ActiveProducts": "productos activos",
  "CategoryAnalysis-SalesShareLabel": "de la venta total",
  "CategoryAnalysis-BackToCategories": "Categorías",
  "CategoryAnalysis-LoadError": "No se pudo cargar el análisis de categoría.",
  "ClientAnalysis-Badge": "Diagnóstico Comercial",
  "ClientAnalysis-PageTitle": "Análisis por Clientes",
  "ClientAnalysis-PageSubtitle":
    "Dinámica del ciclo de vida, comportamiento y valor económico de la base de clientes.",
  "ClientAnalysis-Period": "Período",
  "ClientAnalysis-Period-30": "Últimos 30 días",
  "ClientAnalysis-Period-60": "Últimos 60 días",
  "ClientAnalysis-Period-90": "Últimos 90 días",
  "ClientAnalysis-Period-180": "Últimos 180 días",
  "ClientAnalysis-Filter-AllChannels": "Todos los canales",
  "ClientAnalysis-Filter-AllStores": "Todas las tiendas",
  "ClientAnalysis-Filter-Channel": "Canal",
  "ClientAnalysis-Filter-Store": "Tienda",
  "ClientAnalysis-Exec-conversion": "Conversión",
  "ClientAnalysis-Exec-upgrade": "Upgrade",
  "ClientAnalysis-Exec-reactivation": "Reactivación",
  "ClientAnalysis-Exec-risk": "Riesgo",
  "ClientAnalysis-Kpi-active": "Clientes activos",
  "ClientAnalysis-Kpi-active-Hint": "Estado Activo al cierre del período",
  "ClientAnalysis-Kpi-new": "Clientes nuevos",
  "ClientAnalysis-Kpi-new-Hint": "Estado Nuevo al cierre del período",
  "ClientAnalysis-Kpi-reactivated": "Clientes reactivados",
  "ClientAnalysis-Kpi-reactivated-Hint": "Pasaron de En riesgo/Perdido a Activo/Recurrente/VIP en el período",
  "ClientAnalysis-Kpi-atRisk": "Clientes en riesgo",
  "ClientAnalysis-Kpi-atRisk-Hint": "Estado En riesgo al cierre del período",
  "ClientAnalysis-Kpi-lost": "Clientes perdidos",
  "ClientAnalysis-Kpi-lost-Hint": "Estado Perdido al cierre del período",
  "ClientAnalysis-Kpi-repurchaseRate": "Tasa de recompra",
  "ClientAnalysis-Kpi-repurchaseRate-Hint": "2da compra o más",
  "ClientAnalysis-Kpi-frequency": "Frecuencia promedio",
  "ClientAnalysis-Kpi-frequency-Hint": "Compras por cliente",
  "ClientAnalysis-Kpi-avgTicket": "Ticket promedio",
  "ClientAnalysis-Kpi-avgTicket-Hint": "Venta media por compra",
  "ClientAnalysis-Kpi-timeBetween": "Tiempo medio entre compras",
  "ClientAnalysis-Kpi-timeBetween-Hint": "Menor es mejor",
  "ClientAnalysis-Kpi-recency": "Recencia promedio",
  "ClientAnalysis-Kpi-recency-Hint": "Días desde última compra",
  "ClientAnalysis-Days": "días",
  "ClientAnalysis-Section-Composition": "Composición actual de la base",
  "ClientAnalysis-StateClientsHint": "clientes en este estado",
  "ClientAnalysis-Section-Activation": "Impacto de activaciones",
  "ClientAnalysis-Activation-Link": "Conecta con Activación de Clientes",
  "ClientAnalysis-Activation-Reactivated": "Clientes reactivados tras campañas",
  "ClientAnalysis-Activation-Reactivated-Hint":
    "Inactivos incluidos en campaña que volvieron a comprar en su vigencia.",
  "ClientAnalysis-Activation-NoReaction": "Clientes que no reaccionaron",
  "ClientAnalysis-Activation-NoReaction-Hint":
    "Audiencia de campaña en el período sin compra en la ventana de vigencia.",
  "ClientAnalysis-Activation-ReactionRate": "Tasa de reacción a activaciones",
  "ClientAnalysis-Activation-ReactionRate-Hint":
    "Compraron durante la vigencia / incluidos en audiencia.",
  "ClientAnalysis-Activation-InactiveReactivation": "Reactivación sobre inactivos impactados",
  "ClientAnalysis-Activation-InactiveReactivation-Hint":
    "Inactivos impactados que compraron / total inactivos impactados.",
  "ClientAnalysis-LoadError": "No se pudo cargar el análisis de clientes.",
  "ClientAnalysis-Loading": "Cargando análisis…",
  "ClientAnalysis-Section-Flow": "Flujo entre estados",
  "ClientAnalysis-Flow-Badge": "Transiciones mensuales",
  "ClientAnalysis-Column-Origin": "Origen",
  "ClientAnalysis-Column-Destination": "Destino",
  "ClientAnalysis-Column-Clients": "Clientes",
  "ClientAnalysis-Column-Type": "Tipo",
  "ClientAnalysis-TransitionType-advance": "Avance",
  "ClientAnalysis-TransitionType-decline": "Deterioro",
  "ClientAnalysis-TransitionType-recovery": "Recuperación",
  "ClientAnalysis-Section-Insights": "Insights automáticos",
  "ClientAnalysis-Insight-funnel-Title": "El funnel de maduración mejora",
  "ClientAnalysis-Insight-funnel-Desc":
    "La conversión Nuevo → Activo subió 4.1 pp impulsada por onboarding en eCommerce.",
  "ClientAnalysis-Insight-retail-Title": "Retail sigue frágil",
  "ClientAnalysis-Insight-retail-Desc":
    "El 46% de los clientes que pasan a riesgo proviene de tiendas físicas con ticket por debajo del promedio.",
  "ClientAnalysis-Insight-vip-Title": "VIP gana peso económico",
  "ClientAnalysis-Insight-vip-Desc":
    "VIP aumentó 0.8 pp en participación de venta y ya explica 29% de la facturación del trimestre.",
  "ClientAnalysis-Insight-stockout-Title": "El stock-out erosiona recurrencia",
  "ClientAnalysis-Insight-stockout-Desc":
    "La tasa de recompra cae 6% en categorías con quiebre de stock recurrente.",
  "ClientAnalysis-Insight-reactivation-Title": "Tasa de reactivación en alza",
  "ClientAnalysis-Insight-reactivation-Desc":
    "La reactivación mejora respecto al período anterior.",
  "ClientAnalysis-Insight-newTicket-Title": "Nuevos clientes gastan más",
  "ClientAnalysis-Insight-newTicket-Desc":
    "El ticket de clientes nuevos supera el promedio del período.",
  "ClientAnalysis-Insight-lowRecurrentTransition-Title": "Baja transición a recurrente",
  "ClientAnalysis-Insight-lowRecurrentTransition-Desc":
    "Menos clientes alcanzan recurrencia; conviene revisar retención.",
  "ClientAnalysis-Insight-riskDown-Title": "Clientes en riesgo disminuyen",
  "ClientAnalysis-Insight-riskDown-Desc":
    "Disminuye el pool de clientes con riesgo de abandono.",
  "ClientAnalysis-Insight-frequencyUp-Title": "La frecuencia de compra mejora",
  "ClientAnalysis-Insight-frequencyUp-Desc":
    "Los clientes compran con mayor frecuencia que en el período anterior.",
  "ClientAnalysis-Insight-dormantUp-Title": "Crece la cantidad de clientes dormidos",
  "ClientAnalysis-Insight-dormantUp-Desc":
    "Aumenta el volumen de clientes sin compras recientes.",
  "ClientAnalysis-Insight-cohortQuality-Title": "Generación con buena maduración",
  "ClientAnalysis-Insight-cohortQuality-Desc":
    "Una cohorte reciente muestra alta conversión a tercera compra.",
  "ClientAnalysis-Section-EconomicValue": "Valor económico por estado",
  "ClientAnalysis-Column-State": "Estado",
  "ClientAnalysis-Column-AvgTicket": "Ticket promedio",
  "ClientAnalysis-Column-Frequency": "Frecuencia",
  "ClientAnalysis-Column-TotalSales": "Venta total",
  "ClientAnalysis-Column-SalesPct": "% venta",
  "ClientAnalysis-Section-Segments": "Segmentos que explican el comportamiento",
  "ClientAnalysis-Segment-channelLifecycle-Title": "Ciclo de vida por canal",
  "ClientAnalysis-Segment-channelLifecycle-Desc":
    "eCommerce concentra 41% de los VIP y acelera la frecuencia de recompra.",
  "ClientAnalysis-Segment-frequencyGender-Title": "Frecuencia promedio",
  "ClientAnalysis-Segment-frequencyGender-Desc":
    "Mujer 3.0 vs Hombre 2.5. La brecha se mantiene estable en el trimestre.",
  "ClientAnalysis-Segment-ticketRegion-Title": "Ticket promedio",
  "ClientAnalysis-Segment-ticketRegion-Desc":
    "Capital +9% vs Interior. Capital combina más frecuencia con ticket superior.",
  "ClientAnalysis-Segment-recencyStore-Title": "Recencia",
  "ClientAnalysis-Segment-recencyStore-Desc":
    "Pocitos 22 días vs Unión 36. Hay dispersión operativa relevante por plaza.",
  "ClientAnalysis-Segment-timeSegment-Title": "Tiempo entre compras",
  "ClientAnalysis-Segment-timeSegment-Desc":
    "Recurrente 28 días vs Activo 43. La segunda compra dentro de 35 días mejora mucho la maduración.",
  "ClientAnalysis-Segment-Dim-channel": "Canal",
  "ClientAnalysis-Segment-Dim-gender": "Género",
  "ClientAnalysis-Segment-Dim-region": "País / plaza",
  "ClientAnalysis-Segment-Dim-store": "Tienda",
  "ClientAnalysis-Segment-Dim-segment": "Segmento",
  "ClientAnalysis-Section-Dynamics": "Dinámica del ciclo en el tiempo",
  "ClientAnalysis-Section-Navigation": "Navegación relacionada",
  "ClientAnalysis-Nav-Opportunities": "Ver oportunidades comerciales",
  "ClientAnalysis-Nav-Opportunities-Desc":
    "Cruzar hallazgos del ciclo con desvíos y oportunidades.",
  "ClientAnalysis-Nav-Stores": "Ver tiendas",
  "ClientAnalysis-Nav-Stores-Desc":
    "Analizar recencia, frecuencia y deterioro por sucursal.",
  "ClientAnalysis-Nav-Channels": "Ver canales",
  "ClientAnalysis-Nav-Channels-Desc":
    "Comparar maduración de clientes entre retail y ecommerce.",
  "ClientAnalysis-Nav-Activation": "Ir a activación de clientes",
  "ClientAnalysis-Nav-Activation-Desc":
    "Profundizar campañas, audiencias e incentivos.",
  "ClientAnalysis-ExecutiveNote":
    "El foco no está en listar clientes sino en entender si la base madura, se deteriora o se recupera de forma sostenible.",
  "ClientAnalysis-Section-Generations": "Generaciones de clientes",
  "ClientAnalysis-Generations-Badge": "Mes de primera compra",
  "ClientAnalysis-Column-Generation": "Generación",
  "ClientAnalysis-Column-Initial": "Clientes iniciales",
  "ClientAnalysis-Column-New": "Nuevos",
  "ClientAnalysis-Column-Active": "Activos",
  "ClientAnalysis-Column-Recurrent": "Recurrentes",
  "ClientAnalysis-Column-Vip": "VIP",
  "ClientAnalysis-Column-AtRisk": "En riesgo",
  "ClientAnalysis-Column-Lost": "Perdidos",
  "ClientAnalysis-Column-AccumSales": "Venta acumulada",
  "ClientAnalysis-Matrix-Subtitle":
    "Retención y actividad por meses desde la primera compra.",
  "ClientAnalysis-Matrix-Badge": "Heatmap",
  "ClientAnalysis-Month": "Mes",
  "ClientAnalysis-Maturation-secondPurchase": "Tiempo medio a 2da compra",
  "ClientAnalysis-Maturation-thirdPurchase": "Tiempo a 3ra compra",
  "ClientAnalysis-Maturation-highValue": "Tiempo a cliente de alto valor",
  "ClientAnalysis-Column-PctSecondPurchase": "% con 2da compra",
  "ClientAnalysis-Column-PctThirdPurchase": "% con 3ra compra",
  "ClientAnalysis-Column-AvgDaysSecond": "Tiempo medio a 2da compra",
  "ClientAnalysis-Column-PctHighValue": "% clientes alto valor",
  "ClientAnalysis-Section-GenPerformance": "Generaciones con mejor desempeño",
  "ClientAnalysis-Ranking": "Ranking",
  "ClientAnalysis-Column-PctRecurrent": "% llegó a recurrente",
  "ClientAnalysis-Column-PctVip": "% llegó a VIP",
  "ClientAnalysis-Column-AvgSaleClient": "Venta media cliente",
  "ClientAnalysis-GenInsight-Title": "Insight de generaciones",
  "ClientAnalysis-GenInsight-cohortQuality-Desc":
    "Una generación reciente muestra mejor conversión a tercera compra que el promedio histórico.",
  "ClientAnalysis-GenInsight-digital-Desc":
    "Las generaciones adquiridas durante campañas digitales muestran 18% más conversión a recurrente.",
  "ClientAnalysis-GenInsight-retail-Desc":
    "Los clientes adquiridos en retail tardan 22 días más en realizar su segunda compra y las generaciones posteriores a la campaña de invierno muestran mayor velocidad de maduración.",
  "ClientAnalysis-Export": "Exportar vista",
  "ClientAnalysis-State-new": "Nuevos",
  "ClientAnalysis-State-active": "Activos",
  "ClientAnalysis-State-recurrent": "Recurrentes",
  "ClientAnalysis-State-vip": "VIP",
  "ClientAnalysis-State-atRisk": "En riesgo",
  "ClientAnalysis-State-lost": "Perdidos",
  "ClientAnalysis-State-reactivated": "Reactivados",
  "ClientDiagnosis-AutomaticInsights": "Insights automáticos",
  "ClientDiagnosis-BehaviorChanges": "Cambios en comportamiento",
  "ClientDiagnosis-Cadence": "Cadencia típica",
  "ClientDiagnosis-CadenceText": "Compra cada {{days}} días en promedio",
  "ClientDiagnosis-ChannelShare": "{{pct}}% de sus compras históricas se concentran en este canal",
  "ClientDiagnosis-CurrentState": "Estado actual",
  "ClientDiagnosis-DaysValue": "{{days}} días",
  "ClientDiagnosis-Frequency": "Frecuencia",
  "ClientDiagnosis-FrequencyHint": "Vs período anterior comparable",
  "ClientDiagnosis-HistoricValue": "Valor histórico",
  "ClientDiagnosis-Incentive-content": "Campañas de contenido",
  "ClientDiagnosis-Incentive-discountHigh": "Descuento >15%",
  "ClientDiagnosis-Incentive-discountLow": "Descuento <10%",
  "ClientDiagnosis-Incentive-discountMid": "Descuento 10-15%",
  "ClientDiagnosis-Incentive-points": "Puntos",
  "ClientDiagnosis-IncentiveSensitivity": "Sensibilidad a incentivos",
  "ClientDiagnosis-Insight-AbandonedCategory": "Abandonó temporalmente su categoría habitual: {{category}}.",
  "ClientDiagnosis-Insight-MonthlyButInactive": "Este cliente compraba mensualmente y lleva más de {{days}} días sin comprar.",
  "ClientDiagnosis-Insight-PrefersDiscountsOverPoints": "Responde mejor a descuentos altos que a incentivos por puntos.",
  "ClientDiagnosis-Insight-TicketUpFrequencyDown": "Su ticket promedio aumentó, pero su frecuencia de compra cayó de forma relevante.",
  "ClientDiagnosis-Level": "Nivel",
  "ClientDiagnosis-MainChannel": "Canal principal",
  "ClientDiagnosis-NoCampaigns": "El cliente no ha participado en ninguna campaña aún",
  "ClientDiagnosis-NoData": "No hay datos de diagnóstico para este cliente",
  "ClientDiagnosis-NoInsights": "Sin insights relevantes por el momento",
  "ClientDiagnosis-PurchasePattern": "Patrón de compra",
  "ClientDiagnosis-PurchasesValue": "{{value}} compras",
  "ClientDiagnosis-Reactivated": "Reactivado",
  "ClientDiagnosis-Reading-high": "Alta respuesta",
  "ClientDiagnosis-Reading-low": "Baja respuesta",
  "ClientDiagnosis-Reading-medium": "Respuesta media",
  "ClientDiagnosis-Recency": "Recencia",
  "ClientDiagnosis-RecencyDirection-better": "↓ mejora",
  "ClientDiagnosis-RecencyDirection-stable": "estable",
  "ClientDiagnosis-RecencyDirection-worseModerate": "↑ moderada",
  "ClientDiagnosis-RecencyDirection-worseStrong": "↑ fuerte",
  "ClientDiagnosis-RecencyHint": "{{days}} días desde la última compra",
  "ClientDiagnosis-State-active": "Activo",
  "ClientDiagnosis-State-atRisk": "En riesgo",
  "ClientDiagnosis-State-lost": "Perdido",
  "ClientDiagnosis-State-new": "Nuevo",
  "ClientDiagnosis-State-recurrent": "Recurrente",
  "ClientDiagnosis-State-vip": "VIP",
  "ClientDiagnosis-Ticket": "Ticket",
  "ClientDiagnosis-TicketHint": "Variación del ticket promedio",
  "ClientDiagnosis-TopCategories": "Categorías principales",
  "ClientDiagnosis-Trend": "Tendencia",
  "ClientDiagnosis-Window-historic": "Promedio histórico",
  "ClientDiagnosis-Window-previous": "12 meses previos",
  "ClientDiagnosis-Window-recent": "Últimos 12 meses",
  "ProductMixAnalysis-PageTitle": "Mix de Producto",
  "ProductMixAnalysis-LoadError": "No se pudo cargar el análisis. Intentá nuevamente.",
  "ProductMixAnalysis-Filter-DateStart": "Fecha inicio",
  "ProductMixAnalysis-Filter-DateEnd": "Fecha fin",
  "ProductMixAnalysis-Filter-Channel": "Canal",
  "ProductMixAnalysis-Filter-Store": "Tienda",
  "ProductMixAnalysis-Filter-Category": "Categoría",
  "ProductMixAnalysis-Filter-Brand": "Marca",
  "ProductMixAnalysis-Filter-Article": "Artículo",
  "ProductMixAnalysis-Filter-AllChannels": "Todos los canales",
  "ProductMixAnalysis-Filter-AllStores": "Todas las tiendas",
  "ProductMixAnalysis-Filter-AllCategories": "Todas las categorías",
  "ProductMixAnalysis-Filter-AllBrands": "Todas las marcas",
  "ProductMixAnalysis-Filter-AllArticles": "Todos los artículos",
  "ProductMixAnalysis-Period-Month": "Mes actual",
  "ProductMixAnalysis-Period-90d": "Últimos 90 días",
  "ProductMixAnalysis-Period-Q1": "Q1",
  "ProductMixAnalysis-Kpi-ArticlesSold": "Nº de artículos vendidos",
  "ProductMixAnalysis-Kpi-ArticlesSoldHint": "Artículos con al menos una venta",
  "ProductMixAnalysis-Kpi-CatalogTotal": "Nº total en catálogo",
  "ProductMixAnalysis-Kpi-CatalogTotalHint": "Base completa de artículos cargados",
  "ProductMixAnalysis-Kpi-CatalogActivePct": "% catálogo activo",
  "ProductMixAnalysis-Kpi-CatalogActiveHint":
    "Porcentaje del catálogo que participó en venta",
  "ProductMixAnalysis-Kpi-AvgSale": "Venta media por artículo",
  "ProductMixAnalysis-Kpi-AvgSaleHint": "Facturación promedio por artículo vendido",
  "ProductMixAnalysis-Kpi-AvgUnits": "Unidades medias por artículo",
  "ProductMixAnalysis-Kpi-AvgUnitsHint": "Unidades promedio por artículo vendido",
  "ProductMixAnalysis-Column-Category": "Categoría",
  "ProductMixAnalysis-Column-Brand": "Marca",
  "ProductMixAnalysis-Column-Sales": "Venta",
  "ProductMixAnalysis-Column-SalesPctTotal": "% venta total",
  "ProductMixAnalysis-Column-SalesPct": "% venta",
  "ProductMixAnalysis-Column-Margin": "Margen",
  "ProductMixAnalysis-Column-VariationLy": "Variación vs LY",
  "ProductMixAnalysis-Column-PriceRange": "Rango precio",
  "ProductMixAnalysis-Column-Units": "Unidades",
  "ProductMixAnalysis-Column-AvgTicket": "Ticket medio",
  "ProductMixAnalysis-Column-SalesPctCurrent": "% venta actual",
  "ProductMixAnalysis-Column-SalesPctLy": "% venta LY",
  "ProductMixAnalysis-Column-Variation": "Variación",
  "ProductMixAnalysis-Column-UnitsPct": "% unidades",
  "ProductMixAnalysis-VariationPpSuffix": " p.p.",
  "ProductMixAnalysis-NoCategory": "Sin categoría",
  "ProductMixAnalysis-NoBrand": "Sin marca",
  "ProductMixAnalysis-PriceRange-0": "< $1.000",
  "ProductMixAnalysis-PriceRange-1": "$1.000 – $2.500",
  "ProductMixAnalysis-PriceRange-2": "$2.501 – $4.000",
  "ProductMixAnalysis-PriceRange-3": "$4.001 – $6.000",
  "ProductMixAnalysis-PriceRange-4": "> $6.000",
  "ProductMixAnalysis-Section-CategoryDist-Title": "Distribución de la venta por categoría",
  "ProductMixAnalysis-Section-CategoryDist-Subtitle":
    "Qué categorías explican la venta y cómo evolucionan frente al año anterior.",
  "ProductMixAnalysis-Section-Alerts-Title": "Alertas de estructura del negocio",
  "ProductMixAnalysis-Section-Alerts-Subtitle":
    "Señales de concentración, caída o dispersión del portafolio.",
  "ProductMixAnalysis-Alerts-Empty":
    "Sin alertas de estructura para los filtros seleccionados.",
  "ProductMixAnalysis-Section-BrandDist-Title": "Distribución por marca",
  "ProductMixAnalysis-Section-BrandDist-Subtitle":
    "Participación de cada marca en la estructura del negocio.",
  "ProductMixAnalysis-Section-PriceMix-Title": "Mix por rango de precio",
  "ProductMixAnalysis-Section-PriceMix-Subtitle":
    "Distribución de la venta por posicionamiento de precio.",
  "ProductMixAnalysis-Section-MixEvolution-Title": "Evolución del mix",
  "ProductMixAnalysis-Section-MixEvolution-Subtitle":
    "Comparación del peso de cada categoría con el mismo período del año anterior.",
  "ProductMixAnalysis-Section-Portfolio-Title": "Dependencia del portafolio",
  "ProductMixAnalysis-Section-Portfolio-Subtitle":
    "Qué parte del negocio depende de pocos productos.",
  "ProductMixAnalysis-Portfolio-Top5": "Top 5 productos",
  "ProductMixAnalysis-Portfolio-Top10": "Top 10 productos",
  "ProductMixAnalysis-Portfolio-Top20": "Top 20 productos",
  "ProductMixAnalysis-Section-UnitsVsSales-Title": "Distribución de unidades vs venta",
  "ProductMixAnalysis-Section-UnitsVsSales-Subtitle":
    "Comparación entre categorías de alto volumen y categorías de alto valor.",
  "ProductMixAnalysis-Section-Insights-Title": "Insights automáticos",
  "ProductMixAnalysis-Section-Insights-Subtitle":
    "Resumen de los cambios más relevantes del mix.",
  "ProductMixAnalysis-Insights-Empty":
    "Sin insights automáticos para los filtros seleccionados.",
  "ProductMixAnalysis-Alert-Title-Top10Dependency": "Dependencia de pocos productos",
  "ProductMixAnalysis-Alert-Top10Dependency":
    "Los 10 productos más vendidos concentran el {{pct}}% de la venta.",
  "ProductMixAnalysis-Alert-Title-BrandDependency": "Dependencia de marca",
  "ProductMixAnalysis-Alert-BrandDependency":
    "{{name}} concentra el {{pct}}% de la venta — riesgo de dependencia de marca.",
  "ProductMixAnalysis-Alert-Title-LowCatalogDispersion": "Baja dispersión de catálogo",
  "ProductMixAnalysis-Alert-LowCatalogDispersion":
    "Solo el {{pct}}% del catálogo tuvo venta en el período.",
  "ProductMixAnalysis-Alert-Title-CategoryStructuralDrop": "Caída estructural de categoría",
  "ProductMixAnalysis-Alert-CategoryStructuralDrop":
    "{{name}} cae {{pp}} p.p. de participación con {{weight}}% de peso.",
  "ProductMixAnalysis-Alert-Title-PromotionalDependency":
    "Dependencia promocional estructural",
  "ProductMixAnalysis-Alert-PromotionalDependency":
    "Más del {{pct}}% de la venta ocurre bajo promociones.",
  "ProductMixAnalysis-Alert-Title-PriceRangeConcentration":
    "Concentración por rango de precios",
  "ProductMixAnalysis-Alert-PriceRangeConcentration":
    "El rango {{rangeLabel}} concentra el {{pct}}% de la facturación.",
  "ProductMixAnalysis-Alert-Title-BrandDiversityLoss": "Pérdida de diversidad de marcas",
  "ProductMixAnalysis-Alert-BrandDiversityLoss":
    "Disminuye la diversidad activa de marcas en el mix.",
  "ProductMixAnalysis-Insight-CategoryShare":
    "La categoría {{name}} representa el {{pct}}% de la venta total.",
  "ProductMixAnalysis-Insight-BrandShare":
    "La marca {{name}} concentra el {{pct}}% de la facturación.",
  "ProductMixAnalysis-Insight-PriceRangeShare":
    "El rango {{rangeLabel}} concentra el {{pct}}% de la facturación.",
  "ProductMixAnalysis-Insight-Top10Share":
    "Los 10 productos más vendidos explican el {{pct}}% de la venta.",
  "ProductMixAnalysis-Insight-CategoryGainLy":
    "{{name}} gana +{{pp}} p.p. de participación frente a LY.",
  "ProductMixAnalysis-Insight-CategoryLossLy":
    "{{name}} pierde {{pp}} p.p. de participación frente a LY.",
  "ProductMixParam-SectionTitle": "Parámetros de mix de producto",
  "ProductMixParam-UsdFallback":
    "Cotización USD/UYU de respaldo si la API pública no responde para una fecha",
  "ProductMixParam-InsightCategoryShareMin":
    "Umbral mínimo (%) de participación de categoría para generar insight",
  "ProductMixParam-InsightBrandShareMin":
    "Umbral mínimo (%) de participación de marca para generar insight",
  "ProductMixParam-InsightPriceRangeShareMin":
    "Umbral mínimo (%) de participación por rango de precio para generar insight",
  "ProductMixParam-InsightTop10ShareMin":
    "Umbral mínimo (%) del top 10 productos para generar insight",
  "ProductMixParam-InsightMixShiftPp":
    "Variación mínima (p.p.) de participación para insight de cambio de mix",
  "ProductMixParam-AlertTop10ShareMin":
    "Umbral mínimo (%) del top 10 productos para alerta de concentración",
  "ProductMixParam-AlertTop10ShareLow":
    "Umbral bajo (%) del top 10 para severidad warning",
  "ProductMixParam-AlertTop10ShareHigh":
    "Umbral alto (%) del top 10 para severidad crítica",
  "ProductMixParam-AlertBrandShareMin":
    "Umbral mínimo (%) de participación de marca para alerta",
  "ProductMixParam-AlertCatalogActiveMax":
    "Umbral máximo (%) de catálogo activo; por debajo genera alerta",
  "ProductMixParam-AlertMixDropPp":
    "Caída mínima (p.p.) de participación de categoría para alerta estructural",
  "ProductMixParam-AlertCategoryMinWeight":
    "Peso mínimo (%) de categoría para considerar caída estructural",
  "ProductMixParam-AlertPromotedSalesMin":
    "Umbral mínimo (%) de venta promocional para alerta",
  "ProductMixParam-AlertPriceRangeShareMin":
    "Umbral mínimo (%) de concentración por rango de precio para alerta",
  "ProductMixParam-AlertBrandDiversityRatio":
    "Ratio mínimo de marcas activas vs LY para alerta de diversidad",
  "ProductMixParam-PriceBucket1": "Límite inferior del 2.º rango de precio unitario (UYU)",
  "ProductMixParam-PriceBucket2": "Límite superior del 2.º rango / inferior del 3.º (UYU)",
  "ProductMixParam-PriceBucket3": "Límite superior del 3.º rango / inferior del 4.º (UYU)",
  "ProductMixParam-PriceBucket4": "Límite superior del 4.º rango de precio unitario (UYU)",
  "ProductAnalysisParam-SectionTitle": "Parámetros de análisis de productos",
  "ProductAnalysisParam-HighStockUnits":
    "Unidades de stock a partir de las cuales se considera \"stock alto\" (alerta de baja rotación)",
  "ProductAnalysisParam-HighStockDays":
    "Días de cobertura de stock a partir de los cuales se considera sobrestock",
  "ProductAnalysisParam-LowStockDays":
    "Días de cobertura de stock por debajo de los cuales se considera stock ajustado (oportunidad de alta demanda)",
  "FaissIndexes-Title": "Índices FAISS de similitud",
  "FaissIndexes-Description":
    "Subí índices FAISS por organización y elegí cuál usar para similitud de productos.",
  "FaissIndexes-Organization": "Organización",
  "FaissIndexes-SelectOrganization": "Seleccionar organización",
  "FaissIndexes-SelectOrganizationFirst":
    "Seleccioná una organización en el encabezado para gestionar sus índices.",
  "FaissIndexes-Upload": "Subir índice",
  "FaissIndexes-UploadSuccess": "Índice FAISS subido correctamente",
  "FaissIndexes-UploadError": "No se pudo subir el índice FAISS",
  "FaissIndexes-UploadOverlayTitle": "Subiendo índice FAISS",
  "FaissIndexes-UploadOverlayHint":
    "No cierres ni abandones esta pantalla hasta que termine la carga.",
  "FaissIndexes-UploadProgress": "{{percent}}% · {{loaded}} / {{total}}",
  "FaissIndexes-UploadEta": "Tiempo restante estimado: {{eta}}",
  "FaissIndexes-UploadEtaCalculating": "Calculando tiempo restante…",
  "FaissIndexes-UploadProcessing": "Procesando en el servidor…",
  "FaissIndexes-Filename": "Archivo",
  "FaissIndexes-Size": "Tamaño",
  "FaissIndexes-UploadedAt": "Subido",
  "FaissIndexes-Status": "Estado",
  "FaissIndexes-Active": "Activo",
  "FaissIndexes-Inactive": "Inactivo",
  "FaissIndexes-SetActive": "Usar este índice",
  "FaissIndexes-SetActiveSuccess": "Índice activo actualizado",
  "FaissIndexes-Deactivate": "Desactivar",
  "FaissIndexes-DeactivateSuccess": "Índice desactivado",
  "FaissIndexes-DeleteConfirm": "¿Eliminar este índice FAISS?",
  "FaissIndexes-DeleteSuccess": "Índice FAISS eliminado",
  "FaissIndexes-DownloadError": "No se pudo descargar el índice FAISS",
  "FaissIndexes-SettingsTitle": "Parámetros de similitud",
  "FaissIndexes-SettingsDescription":
    "Configuración de esta organización ({{organization}}). Se envía a data science al buscar artículos similares.",
  "FaissIndexes-SettingsTopK": "Cantidad de candidatos (top_k)",
  "FaissIndexes-SettingsSkipDuplicates": "Omitir duplicados",
  "FaissIndexes-SettingsMaxDistance": "Distancia máxima",
  "FaissIndexes-SettingsSameCategory": "Misma categoría",
  "FaissIndexes-SettingsSameBrand": "Misma marca",
  "FaissIndexes-SettingsMaxPriceDiff": "Diferencia máxima de precio (%)",
  "FaissIndexes-SettingsSave": "Guardar parámetros",
  "FaissIndexes-SettingsSaveSuccess": "Parámetros de similitud guardados",
  "FaissIndexes-SettingsSaveError": "No se pudieron guardar los parámetros",
  "FaissIndexes-SettingsLoadError": "No se pudieron cargar los parámetros",
  "PromotionParam-DaysInAdvance":
    "Antelación, en días, con la que hay que recomendar las promociones",
  "PromotionParam-DiscountValues":
    "Porcentajes de descuento que la organización acepta simular, como los valores configurados en incentivos",
  "PromotionParam-DiscountValuesPlaceholder": "Por ejemplo 10, 20, 30",
  "PromotionParam-MaxDurationDays":
    "Duración máxima de una promoción, en días",
  "PromotionParam-ReusePromotions":
    "Reutiliza promociones: buscar por promociones agrupadas (id original o sufijo de fecha) y asociar el ticket a la última ventana. Activar (true) en organizaciones que reutilizan ids de promoción.",
  "PromotionParam-SectionTitle": "Parámetros de promociones",
  "DailyControlParam-SectionTitle": "Parámetros de control diario de venta",
  "DailyControlParam-GrowthTargetPct": "Target de crecimiento (%) sobre la venta del mismo mes del año anterior, usado para calcular la meta mensual",
  "DailyControl-Title": "Control Diario de Venta",
  "DailyControl-LastUpdated": "Última actualización: {{date}}",
  "DailyControl-ExportSummary": "Exportar resumen",
  "DailyControl-Kpi-VentaLy": "Venta mes comparable LY",
  "DailyControl-Kpi-GrowthTarget": "Crecimiento target",
  "DailyControl-Kpi-MetaMensual": "Meta mensual",
  "DailyControl-Kpi-AcumuladoReal": "Acumulado real",
  "DailyControl-Kpi-PctCumplimiento": "% cumplimiento acumulado",
  "DailyControl-Kpi-ForecastCierre": "Forecast de cierre",
  "DailyControl-Diagnostico-Title": "Diagnóstico",
  "DailyControl-EstadoMes-Title": "Estado del mes",
  "DailyControl-Estado-Alineado": "Alineado",
  "DailyControl-Estado-Atencion": "Atención",
  "DailyControl-Estado-EnRiesgo": "En riesgo",
  "DailyControl-EstadoMes-GapEstimado": "Gap estimado al cierre",
  "DailyControl-EstadoMes-Probabilidad": "Probabilidad de cumplimiento",
  "DailyControl-EstadoMes-ProbabilidadTooltip":
    "Estimado a partir del ritmo de venta necesario para los días restantes",
  "DailyControl-Probabilidad-Baja": "Baja",
  "DailyControl-Probabilidad-Media": "Media",
  "DailyControl-Probabilidad-Alta": "Alta",
  "DailyControl-WeekDist-Title": "Distribución esperada por semana",
  "DailyControl-DowDist-Title": "Distribución esperada por día de la semana",
  "DailyControl-Column-Semana": "Semana",
  "DailyControl-Column-PctDistribucion": "% distribución",
  "DailyControl-Column-MetaSemanal": "Meta semanal",
  "DailyControl-Column-Dia": "Día",
  "DailyControl-Column-VentaHistorica": "Venta histórica / referencia",
  "DailyControl-DailyTable-Title": "Control diario del mes",
  "DailyControl-Column-Fecha": "Fecha",
  "DailyControl-Column-MetaDiaria": "Meta diaria",
  "DailyControl-Column-VentaReal": "Venta real",
  "DailyControl-Column-AcumMeta": "Acum. meta",
  "DailyControl-Column-AcumReal": "Acum. real",
  "DailyControl-Column-Desvio": "Desvío",
  "DailyControl-Column-PctCumplimientoShort": "% cumplim.",
  "DailyControl-GapExplanation-Title": "Qué explica el desvío",
  "DailyControl-GapExplanation-Total": "Gap acumulado total",
  "DailyControl-Column-PctGapExplicado": "% del gap explicado",
  "DailyControl-Column-AporteGap": "Aporte al gap",
  "WholesaleAnalysis-PageTitle": "Venta mayorista",
  "WholesaleAnalysis-Filter-Date": "Fecha",
  "WholesaleAnalysis-Filter-Category": "Categoría",
  "WholesaleAnalysis-Filter-Brand": "Marca",
  "WholesaleAnalysis-Filter-Wholesaler": "Mayorista",
  "WholesaleAnalysis-Filter-All-F": "Todas",
  "WholesaleAnalysis-Filter-All-M": "Todos",
  "WholesaleAnalysis-Chart-Wholesale": "Mayorista",
  "WholesaleAnalysis-Chart-Retail": "Retail",
  "WholesaleAnalysis-Column-Client": "Cliente",
  "WholesaleAnalysis-Column-Sales": "Venta",
  "WholesaleAnalysis-Column-Margin": "Margen",
  "WholesaleAnalysis-Column-AvgTicket": "Ticket promedio",
  "WholesaleAnalysis-Column-WholesaleSalesPct": "% venta mayorista",
  "WholesaleAnalysis-Column-Category": "Categoría",
  "WholesaleAnalysis-Column-Participation": "% participación",
  "WholesaleAnalysis-Column-VsLy": "Var. vs LY",
  "WholesaleAnalysis-Column-Product": "Producto",
  "WholesaleAnalysis-Column-Units": "Unidades",
  "WholesaleAnalysis-Column-Metric": "Métrica",
  "WholesaleAnalysis-Column-Wholesale": "Mayorista",
  "WholesaleAnalysis-Column-Retail": "Retail",
  "WholesaleAnalysis-Column-Difference": "Diferencia",
  "WholesaleAnalysis-Metric-AvgTicket": "Ticket promedio",
  "WholesaleAnalysis-Metric-Margin": "Margen",
  "WholesaleAnalysis-Kpi-WholesaleSalesPct": "% venta mayorista",
  "WholesaleAnalysis-Kpi-WholesaleSalesDesc": "de",
  "WholesaleAnalysis-Kpi-WholesaleSalesDescTotal": "venta total",
  "WholesaleAnalysis-Kpi-AvgTicket": "Ticket promedio mayorista",
  "WholesaleAnalysis-Kpi-Tickets": "tickets",
  "WholesaleAnalysis-Kpi-Margin": "Margen mayorista",
  "WholesaleAnalysis-Kpi-MarginDesc": "Sobre venta mayorista del período",
  "WholesaleAnalysis-Kpi-Clients": "Clientes mayoristas",
  "WholesaleAnalysis-Kpi-ClientsDesc": "Con compra en el período",
  "WholesaleAnalysis-Kpi-Na": "N/A",
  "WholesaleAnalysis-Section-B2bComparison": "Comparativa B2B vs B2C",
  "WholesaleAnalysis-B2b-Wholesale": "Mayorista (B2B)",
  "WholesaleAnalysis-B2b-Retail": "Retail (B2C)",
  "WholesaleAnalysis-B2b-Difference": "Diferencia",
  "WholesaleAnalysis-B2b-WholesaleTicketHint": "venta mayorista / cantidad de compras mayoristas",
  "WholesaleAnalysis-B2b-RetailTicketHint": "venta minorista / cantidad de tickets retail",
  "WholesaleAnalysis-B2b-WholesaleMarginHint": "margen de los tickets mayoristas",
  "WholesaleAnalysis-B2b-RetailMarginHint": "margen de los tickets minoristas",
  "WholesaleAnalysis-B2b-DiffFormula": "(valor mayorista / valor minorista) × 100",
  "WholesaleAnalysis-B2b-Footnote":
    "La diferencia se calcula como (valor mayorista / valor minorista) × 100. Un resultado mayor a 100% indica mayor valor en el canal mayorista.",
  "WholesaleAnalysis-Section-SalesByWholesaler": "Venta por mayorista",
  "WholesaleAnalysis-Column-Wholesaler": "Mayorista",
  "WholesaleAnalysis-Section-Exposure": "Exposición comercial",
  "WholesaleAnalysis-Section-ExposurePending": "Próximamente",
  "WholesaleAnalysis-Section-ExposurePendingDesc":
    "La sección de concentración / exposición comercial se publicará en una próxima versión.",
  "WholesaleAnalysis-Config-MissingTitle": "Configuración de mayoristas pendiente",
  "WholesaleAnalysis-Config-MissingDesc":
    "Registrá mayoristas y modos de identificación en Admin - Parametrizaciones - Mayoristas para clasificar tickets y habilitar el filtro por mayorista.",
  "Wholesalers-PageTitle": "Mayoristas",
  "Wholesalers-SettingsTitle": "Identificación en tickets",
  "Wholesalers-Mode-BRANCH_OFFICE": "Sucursal que factura",
  "Wholesalers-Mode-SALE_POINT": "Caja que factura",
  "Wholesalers-Mode-CLIENT_ID": "Id cliente",
  "Wholesalers-Mode-CLIENT_RUT": "RUT",
  "Wholesalers-Column-Name": "Nombre",
  "Wholesalers-Column-ExternalId": "ID",
  "Wholesalers-Column-Rules": "Reglas",
  "Wholesalers-Add": "Agregar mayorista",
  "Wholesalers-SaveSettings": "Guardar configuración",
  "Wholesalers-SettingsSaved": "Configuración guardada",
  "Wholesalers-SelectBranchOffice": "Seleccionar sucursal",
  "Wholesalers-SelectSalePoint": "Seleccionar caja",
  "Wholesalers-SelectClient": "Seleccionar cliente",
  "Wholesalers-EnterRut": "Ingresar RUT",
  "Wholesalers-AddRule": "Agregar regla",
  "Wholesalers-Edit": "Editar",
  "Wholesalers-DeleteConfirm": "¿Eliminar mayorista?",
  "Wholesalers-Active": "Activo",
  "Wholesalers-RulesHint": "Reglas según los modos habilitados arriba",
  "WholesaleAnalysis-Section-CategoryMix": "Mix de compra mayorista",
  "WholesaleAnalysis-Section-TopProducts": "Productos más comprados",
  "WholesaleAnalysis-Section-Seasonality": "Estacionalidad mayorista",
  "WholesaleAnalysis-Season-WholesalePeak": "Pico mayorista",
  "WholesaleAnalysis-Season-RetailPeak": "Pico retail",
  "WholesaleAnalysis-Season-AvgLead": "Anticipación promedio",
  "WholesaleAnalysis-Season-Days": "días",
  "WholesaleAnalysis-Section-Insights": "Insights automáticos",
  "WholesaleAnalysis-Section-Alerts": "Alertas de estructura del negocio",
  "WholesaleAnalysis-Insights-Empty": "Sin insights para el período seleccionado.",
  "WholesaleAnalysis-Alerts-Empty": "Sin alertas para el período seleccionado.",
  "WholesaleAnalysis-Insights-Pending": "Pendiente",
  "WholesaleAnalysis-Insights-PendingDesc":
    "Los insights automáticos de venta mayorista se habilitarán con el motor de análisis.",
  "WholesaleAnalysis-NoCategory": "Sin categoría",
  "WholesaleAnalysis-DefaultClient": "Mayorista",
  "WholesaleAnalysis-ClientOption": "Cliente",
  "WholesaleAnalysis-Month-1": "Ene",
  "WholesaleAnalysis-Month-2": "Feb",
  "WholesaleAnalysis-Month-3": "Mar",
  "WholesaleAnalysis-Month-4": "Abr",
  "WholesaleAnalysis-Month-5": "May",
  "WholesaleAnalysis-Month-6": "Jun",
  "WholesaleAnalysis-Month-7": "Jul",
  "WholesaleAnalysis-Month-8": "Ago",
  "WholesaleAnalysis-Month-9": "Sep",
  "WholesaleAnalysis-Month-10": "Oct",
  "WholesaleAnalysis-Month-11": "Nov",
  "WholesaleAnalysis-Month-12": "Dic",
  "WholesaleAnalysis-NoName": "Sin nombre",
  "WholesaleAnalysis-Severity-high": "Alta",
  "WholesaleAnalysis-Severity-medium": "Media",
  "WholesaleAnalysis-Severity-low": "Baja",
  "WholesaleAnalysis-AlertType-dependency": "Dependencia",
  "WholesaleAnalysis-AlertType-performance": "Performance",
  "WholesaleAnalysis-AlertType-portfolio": "Cartera",
  "WholesaleAnalysis-AlertType-dispersion": "Dispersión",
  "WholesaleAnalysis-AlertType-profitability": "Rentabilidad",
  "WholesaleAnalysis-AlertType-structuralDecline": "Caída estructural",
  "WholesaleAnalysis-Insight-TopClientShare":
    "{{name}} representa el {{pct}}% de la venta mayorista",
  "WholesaleAnalysis-Insight-TopCategoryShare":
    "{{name}} representa el {{pct}}% de la venta mayorista",
  "WholesaleAnalysis-Insight-TopBrandBilling":
    "{{name}} concentra el {{pct}}% de la facturación mayorista",
  "WholesaleAnalysis-Insight-TopClientsExplained":
    "Los {{count}} principales clientes explican el {{pct}}% de la venta mayorista",
  "WholesaleAnalysis-Insight-AvgTicketGrowth":
    "El ticket promedio mayorista crece +{{pct}}% vs LY",
  "WholesaleAnalysis-Insight-GrowthConcentration":
    "El crecimiento se concentra en {{names}}",
  "WholesaleAnalysis-Insight-RecentRecovery":
    "El canal mayorista muestra recuperación reciente",
  "WholesaleAnalysis-Insight-CategoryMixShift":
    "{{name}} gana relevancia dentro del mix mayorista",
  "WholesaleAnalysis-Insight-TopProductsExplained":
    "Los {{count}} productos más vendidos explican el {{pct}}% de la venta mayorista",
  "WholesaleAnalysis-Alert-TopClientsConcentration":
    "Los principales clientes concentran el {{pct}}% de la venta mayorista",
  "WholesaleAnalysis-Alert-SalesDropLy": "Caída relevante de venta mayorista vs LY",
  "WholesaleAnalysis-Alert-ActiveClientsDown":
    "Disminuye la cantidad de clientes mayoristas activos",
  "WholesaleAnalysis-Alert-AvgTicketDeteriorated": "Ticket promedio mayorista deteriorado",
  "WholesaleAnalysis-Alert-TopCategoryConcentration":
    "{{name}} concentra el {{pct}}% de la venta mayorista",
  "WholesaleAnalysis-Alert-TopBrandConcentration":
    "{{name}} concentra el {{pct}}% de la facturación mayorista",
  "WholesaleAnalysis-Alert-LowCatalogCoverage":
    "Solo el {{pct}}% del catálogo tuvo venta en mayorista",
  "WholesaleAnalysis-Alert-TopProductsConcentration":
    "Los productos más vendidos concentran el {{pct}}% de la venta mayorista",
  "WholesaleAnalysis-Alert-MarginDeteriorated":
    "Margen mayorista deteriorado respecto al año anterior",
  "WholesaleAnalysis-Alert-CategoryShareLoss":
    "{{name}} pierde participación dentro del canal mayorista",

  // Recommendation i18n keys (synced with api i18n/recommendation_messages_*.properties)
  "SegmentName-Inactive365": "Inactivo 365",
  "SegmentDescription-Inactive365": "Clientes que no compran hace más de un año.",
  "SegmentName-Inactive180": "Inactivo 180",
  "SegmentDescription-Inactive180": "Clientes que no compran hace varios meses.",
  "SegmentName-Inactive90": "Inactivo 90",
  "SegmentDescription-Inactive90": "Clientes que dejaron de comprar recientemente.",
  "SegmentName-Active": "Activo",
  "SegmentDescription-Active": "Clientes que compraron recientemente y están dentro de su ciclo normal.",
  "SegmentName-Frequent": "Clientes frecuentes",
  "SegmentDescription-Frequent": "Clientes que compran seguido y mantienen su ritmo habitual.",
  "SegmentName-New": "Clientes nuevos",
  "SegmentDescription-New": "Clientes que comenzaron a comprar recientemente.",
  "SegmentName-Occasional": "Clientes ocasionales",
  "SegmentDescription-Occasional": "Clientes activos con comportamiento intermedio.",
  "SegmentName-Declining": "Clientes en caída",
  "SegmentDescription-Declining": "Clientes que solían comprar más seguido y van empezando a dejar de hacerlo.",
  "SegmentName-Vip": "Clientes VIP",
  "SegmentDescription-Vip": "Clientes activos de alto valor económico.",
  "SegmentName-LowTicket": "Clientes ticket bajo",
  "SegmentDescription-LowTicket": "Clientes activos con bajo gasto promedio por compra.",
  "SegmentName-InactiveExFrequent": "Inactivos - ex frecuentes",
  "SegmentDescription-InactiveExFrequent": "Clientes inactivos que antes compraban seguido.",
  "SegmentName-InactiveHighValue": "Inactivos - alto valor",
  "SegmentDescription-InactiveHighValue": "Clientes inactivos que generaban mucho valor.",
  "SegmentName-OverdueFrequency": "Excedió frecuencia esperada",
  "SegmentDescription-OverdueFrequency": "Clientes que ya deberían haber vuelto a comprar según su comportamiento histórico.",
  "SegmentName-SpendDrop": "Caída de gasto",
  "SegmentDescription-SpendDrop": "Clientes activos que gastan significativamente menos que antes.",
  "SegmentName-TicketDrop": "Caída de ticket",
  "SegmentDescription-TicketDrop": "Clientes activos cuyo ticket reciente bajó frente al histórico.",
  "SegmentName-BrandFans": "Fans de marca - {{brand}}",
  "SegmentDescription-BrandFans": "Clientes activos con preferencia clara por la marca {{brand}}.",
  "SegmentName-CategoryFans": "Fans de categoría - {{category}}",
  "SegmentDescription-CategoryFans": "Clientes activos con fuerte afinidad por la categoría {{category}}.",
  "SegmentName-AttributeBuyers": "Compradores de {{attributeName}}: {{attributeValue}}",
  "SegmentDescription-AttributeBuyers": "Clientes activos que compraron productos con {{attributeName}} = {{attributeValue}}.",
  "SegmentName-CategoryBoost": "Clientes para reforzar categoría {{category}}",
  "SegmentDescription-CategoryBoost": "Clientes con afinidad por la categoría {{category}} detectada con baja performance comercial ({{status}}).",
  "SegmentName-BrandBoost": "Clientes para reforzar marca {{brand}}",
  "SegmentDescription-BrandBoost": "Clientes con afinidad por la marca {{brand}} detectada con baja performance comercial ({{status}}).",
  "SegmentName-StoreReactivate": "Clientes para reactivar {{store}}",
  "SegmentDescription-StoreReactivate": "Clientes habituales de la tienda {{store}} detectada con baja performance comercial ({{status}}).",
  "SegmentName-PointsExpiring": "Clientes con puntos próximos a vencer",
  "SegmentDescription-PointsExpiring": "Clientes que perderán puntos dentro de los próximos {{days}} días.",
  "SegmentName-PointsBelowRedemption": "Clientes próximos al mínimo de canje",
  "SegmentDescription-PointsBelowRedemption": "Clientes con saldo positivo pero aún insuficiente para canjear (mínimo {{minPoints}}).",
  "SegmentName-PointsReadyToRedeem": "Clientes listos para su primer canje",
  "SegmentDescription-PointsReadyToRedeem": "Clientes que recientemente alcanzaron el mínimo requerido para canjear.",
  "SegmentName-HighPointsBalance": "Clientes con alto saldo de puntos",
  "SegmentDescription-HighPointsBalance": "Clientes que acumularon una cantidad importante de puntos y aún no los utilizan.",
  "SegmentName-StockExcess": "Clientes para liquidar talle {{size}} - {{article}} ({{scope}})",
  "SegmentDescription-StockExcess": "Clientes que compraron previamente el talle {{size}}; artículo con exceso de stock.",
  "SegmentName-BankCustomers": "Clientes Banco {{bank}}",
  "SegmentDescription-BankCustomers": "Clientes que habitualmente pagan con tarjetas emitidas por {{bank}}.",
  "SegmentName-ChildrenRenewal": "Clientes para renovación infantil",
  "SegmentDescription-ChildrenRenewal": "Clientes cuya última compra infantil supera {{months}} meses y tienen stock disponible en el talle siguiente.",
  "ActivationAction-Message-CategoryNovelty": "Llegaron nuevos {{category}} que te pueden gustar",
  "ActivationAction-Message-RelatedModel": "Si te gustó {{articleA}}, llegó {{articleB}}",
  "ActivationAction-Message-AttributeSimilarity": "Si te gustó {{article}}, mirá estos similares",
  "ActivationAction-Message-Renewal": "Es momento de renovar tus {{category}}",
  "ActivationAction-Message-BrandAffinity": "Lo nuevo de {{brand}} que te puede gustar",
  "ActivationAction-Message-DemographicAffinity": "Nuevos {{category}} para vos",
  "ActivationAction-Message-BroadSpectrum": "Novedades para toda la familia",
  "ActivationAction-Message-SoftReactivation": "Te extrañamos — mirá lo nuevo que llegó",
  "RecommendationRun-Step-Cleanup": "{{stepIndex}}/{{totalSteps}} Borrando sugerencias anteriores",
  "RecommendationRun-Step-Segments": "{{stepIndex}}/{{totalSteps}} Generando segmentos",
  "RecommendationRun-Step-DsSegments": "{{stepIndex}}/{{totalSteps}} Generando segmentos",
  "RecommendationRun-Step-CommercialOpportunities": "{{stepIndex}}/{{totalSteps}} Detectando oportunidades comerciales",
  "RecommendationRun-Step-NextPurchase": "{{stepIndex}}/{{totalSteps}} Generando próxima compra",
  "RecommendationRun-Step-Rewards": "{{stepIndex}}/{{totalSteps}} Generando incentivos",
  "RecommendationRun-Step-Promotions": "{{stepIndex}}/{{totalSteps}} Generando promociones",
  "RecommendationRun-Step-ActivationActions": "{{stepIndex}}/{{totalSteps}} Generando acciones de activación",
  "RecommendationRun-Step-Preparing": "Preparando ejecución",
  "RecommendationRun-Step-Cancelled": "Cancelado por el usuario",
  "RecommendationRun-FlowStep-Cleanup": "Borrando sugerencias anteriores",
  "RecommendationRun-FlowStep-Segments": "Generando segmentos",
  "RecommendationRun-FlowStep-DsSegments": "Generando segmentos",
  "RecommendationRun-FlowStep-CommercialOpportunities": "Detectando oportunidades comerciales",
  "RecommendationRun-FlowStep-NextPurchase": "Generando próxima compra",
  "RecommendationRun-FlowStep-Rewards": "Generando incentivos",
  "RecommendationRun-FlowStep-Promotions": "Generando promociones",
  "RecommendationRun-FlowStep-ActivationActions": "Generando acciones de activación",
  "RecommendationRun-Progress-RefreshingMetrics": "Actualizando métricas de clientes",
  "RecommendationRun-Progress-MetricsSkipped": "Métricas de clientes recientes; omitiendo actualización completa",
  "RecommendationRun-Progress-LoadingParams": "Cargando parámetros y percentiles",
  "RecommendationRun-Progress-GeneratingBase": "Generando segmentos base",
  "RecommendationRun-Progress-GeneratingBrandAffinity": "Generando segmentos por afinidad de marca",
  "RecommendationRun-Progress-GeneratingCategoryAffinity": "Generando segmentos por afinidad de categoría",
  "RecommendationRun-Progress-GeneratingAttributes": "Generando segmentos por atributos",
  "RecommendationRun-Progress-SegmentEngineDone": "Finalizando motor de segmentos. Segmentos generados: {{count}}",
  "RecommendationRun-Progress-BrandSegment": "Generando segmentos por marca {{index}}/{{total}}: {{name}} ({{memberCount}} clientes)",
  "RecommendationRun-Progress-BrandSegmentsDone": "Segmentos por marca completados: {{count}} generados",
  "RecommendationRun-Progress-CategorySegment": "Generando segmentos por categoría {{index}}/{{total}}: {{name}} ({{memberCount}} clientes)",
  "RecommendationRun-Progress-CategorySegmentsDone": "Segmentos por categoría completados: {{count}} generados",
  "RecommendationRun-Progress-AttributeSegment": "Generando segmentos por atributo {{index}}/{{total}}: {{attributeName}} = {{attributeValue}} ({{memberCount}} clientes)",
  "RecommendationRun-Progress-AttributeSegmentsDone": "Segmentos por atributos completados: {{count}} generados",
  "RecommendationRun-Progress-BaseSegment": "Generando segmentos base {{index}}/{{total}}: {{name}}",
  "RecommendationRun-Progress-BaseSegmentResult": "Segmento base {{index}}/{{total}}: {{name}} {{result}}",
  "RecommendationRun-Progress-BaseSegmentResultGenerated": "generado",
  "RecommendationRun-Progress-BaseSegmentResultSkipped": "omitido",
  "RecommendationRun-Progress-ActivationCleanup": "Eliminando acciones sugeridas anteriores",
  "RecommendationRun-Progress-ActivationEvaluating": "Evaluando segmentos sugeridos",
  "RecommendationRun-Progress-ActivationDone": "Acciones de activación generadas: {{count}}",
  "RecommendationRun-Progress-ActivationSegments": "{{evaluated}}/{{total}} segmentos",
  "RecommendationRun-Progress-OppCategoryPerf": "Analizando performance de categorías",
  "RecommendationRun-Progress-OppBrandPerf": "Analizando performance de marcas",
  "RecommendationRun-Progress-OppStorePerf": "Analizando performance de tiendas",
  "RecommendationRun-Progress-OppPoints": "Analizando saldo y vencimiento de puntos",
  "RecommendationRun-Progress-OppStock": "Analizando exceso de stock por talle",
  "RecommendationRun-Progress-OppBank": "Analizando banco emisor de tarjetas",
  "RecommendationRun-Progress-OppChildren": "Analizando renovación infantil por talle",
  "RecommendationRun-Progress-MetricsDirty": "Métricas: {{count}} clientes con actividad nueva",
  "RecommendationRun-Progress-MetricsUpdated": "Métricas: client_metrics actualizado",
  "RecommendationRun-Progress-MetricsUpdating": "Métricas: actualizando client_metrics 0/{{total}} clientes (0%)",
  "RecommendationRun-Progress-MetricsUpdatingPct": "Métricas: actualizando client_metrics {{processed}}/{{total}} clientes ({{percent}}%)",
  "RecommendationRun-Progress-MetricsSkipFresh": "Métricas: client_metrics reciente; omitiendo refresh completo"
};

export { es };
